let OptionsUPLBillApproval = (option) => {
    let optionStype = option;
    switch (optionStype) {
        case "COMPANY_CODE":
            return {
                "COMPANY_CODE": [
                    {
                        "value": "1000",
                        "text": "1000 - UPL Limited"
                    },
                    {
                        "value": "1200",
                        "text": "1200 - SWAL Corporation Limited"
                    },
                    {
                        "value": "1300",
                        "text": "1300 - UPL Sustainable Agri Solu"
                    },
                    {
                        "value": "1400",
                        "text": "1400 - UPL Sustainable Agri Solu"
                    },
                    {
                        "value": "1500",
                        "text": "1500 - Arysta LifeScience India"
                    },
                    {
                        "value": "1600",
                        "text": "1600 - Natural Plant Protection"
                    },
                    {
                        "value": "1700",
                        "text": "1700 - NURTURE AGTECH PRIVATE LI"
                    }
                ]
            }
        case "SECTION_CODE":
            return {
                "SECTION_CODE" : [
                    {
                        "key":"1",
                        "value":"IN01",
                        "text":"IN01"
                    }
                ]
            }
        case "BUSINESS_PLACE":
            return {
                "BUSINESS_PLACE": [
                    {
                        "companyCode": "1000",
                        "value": "FTWZ",
                        "businessPlace": "FTWZ",
                        "text": "FTWZ - Maharashtra - Raigad"
                    },
                    {
                        "companyCode": "1000",
                        "value": "IN01",
                        "businessPlace": "IN01",
                        "text": "IN01 - UPL Mumbai"
                    },
                    {
                        "companyCode": "1000",
                        "value": "IN02",
                        "businessPlace": "IN02",
                        "text": "IN02 - UPL Vapi"
                    },
                    {
                        "companyCode": "1000",
                        "value": "IN03",
                        "businessPlace": "IN03",
                        "text": "IN03 - UPL -Ankleshwar"
                    },
                    {
                        "companyCode": "1000",
                        "value": "IN04",
                        "businessPlace": "IN04",
                        "text": "IN04 - SCIL-Jhagadia"
                    },
                    {
                        "companyCode": "1000",
                        "value": "IN05",
                        "businessPlace": "IN05",
                        "text": "IN05 - SCIL-Vapi"
                    },
                    {
                        "companyCode": "1000",
                        "value": "IN06",
                        "businessPlace": "IN06",
                        "text": "IN06 - UPL - Jammu"
                    },
                    {
                        "companyCode": "1000",
                        "value": "IN07",
                        "businessPlace": "IN07",
                        "text": "IN07 - UPL - Thane"
                    },
                    {
                        "companyCode": "1000",
                        "value": "IN08",
                        "businessPlace": "IN08",
                        "text": "IN08 - UPL - Haldia"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST01",
                        "businessPlace": "ST01",
                        "text": "ST01 - Andhra Pradesh"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST02",
                        "businessPlace": "ST02",
                        "text": "ST02 - Arunachal Pradesh"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST03",
                        "businessPlace": "ST03",
                        "text": "ST03 - Assam"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST04",
                        "businessPlace": "ST04",
                        "text": "ST04 - Bihar"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST05",
                        "businessPlace": "ST05",
                        "text": "ST05 - Goa"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST06",
                        "businessPlace": "ST06",
                        "text": "ST06 - Gujarat"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST07",
                        "businessPlace": "ST07",
                        "text": "ST07 - Haryana"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST08",
                        "businessPlace": "ST08",
                        "text": "ST08 - Himachal Pradesh"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST09",
                        "businessPlace": "ST09",
                        "text": "ST09 - Jammu and Kashmir"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST10",
                        "businessPlace": "ST10",
                        "text": "ST10 - Karnataka"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST11",
                        "businessPlace": "ST11",
                        "text": "ST11 - Kerala"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST12",
                        "businessPlace": "ST12",
                        "text": "ST12 - Madhya Pradesh"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST13",
                        "businessPlace": "ST13",
                        "text": "ST13 - Maharashtra"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST14",
                        "businessPlace": "ST14",
                        "text": "ST14 - Manipur"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST15",
                        "businessPlace": "ST15",
                        "text": "ST15 - Megalaya"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST16",
                        "businessPlace": "ST16",
                        "text": "ST16 - Mizoram"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST17",
                        "businessPlace": "ST17",
                        "text": "ST17 - Nagaland"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST18",
                        "businessPlace": "ST18",
                        "text": "ST18 - Orissa"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST19",
                        "businessPlace": "ST19",
                        "text": "ST19 - Punjab"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST20",
                        "businessPlace": "ST20",
                        "text": "ST20 - Rajasthan"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST21",
                        "businessPlace": "ST21",
                        "text": "ST21 - Sikkim"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST22",
                        "businessPlace": "ST22",
                        "text": "ST22 - Tamil Nadu"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST23",
                        "businessPlace": "ST23",
                        "text": "ST23 - Tripura"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST24",
                        "businessPlace": "ST24",
                        "text": "ST24 - Uttar Pradesh"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST25",
                        "businessPlace": "ST25",
                        "text": "ST25 - West Bengal"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST26",
                        "businessPlace": "ST26",
                        "text": "ST26 - Andaman and Nico.In."
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST27",
                        "businessPlace": "ST27",
                        "text": "ST27 - Chandigarh"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST28",
                        "businessPlace": "ST28",
                        "text": "ST28 - Dadra and Nagar Hav."
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST29",
                        "businessPlace": "ST29",
                        "text": "ST29 - Daman and Diu"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST30",
                        "businessPlace": "ST30",
                        "text": "ST30 - Delhi"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST31",
                        "businessPlace": "ST31",
                        "text": "ST31 - Lakshadweep"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST32",
                        "businessPlace": "ST32",
                        "text": "ST32 - Pondicherry"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST33",
                        "businessPlace": "ST33",
                        "text": "ST33 - Jharkand"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST34",
                        "businessPlace": "ST34",
                        "text": "ST34 - Uttaranchal"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST35",
                        "businessPlace": "ST35",
                        "text": "ST35 - Chattisgarh"
                    },
                    {
                        "companyCode": "1000",
                        "value": "ST37",
                        "businessPlace": "ST37",
                        "text": "ST37 - Telangana"
                    },
                    {
                        "companyCode": "1200",
                        "value": "IN11",
                        "businessPlace": "IN11",
                        "text": "IN11 - SWAL CORPORATION LIMITED"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW01",
                        "businessPlace": "SW01",
                        "text": "SW01 - Andhra Pradesh"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW02",
                        "businessPlace": "SW02",
                        "text": "SW02 - Arunachal Pradesh"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW03",
                        "businessPlace": "SW03",
                        "text": "SW03 - Assam"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW04",
                        "businessPlace": "SW04",
                        "text": "SW04 - Bihar"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW05",
                        "businessPlace": "SW05",
                        "text": "SW05 - Goa"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW06",
                        "businessPlace": "SW06",
                        "text": "SW06 - Gujarat"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW07",
                        "businessPlace": "SW07",
                        "text": "SW07 - Haryana"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW08",
                        "businessPlace": "SW08",
                        "text": "SW08 - Himachal Pradesh"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW09",
                        "businessPlace": "SW09",
                        "text": "SW09 - Jammu and Kashmir"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW10",
                        "businessPlace": "SW10",
                        "text": "SW10 - Karnataka"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW11",
                        "businessPlace": "SW11",
                        "text": "SW11 - Kerala"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW12",
                        "businessPlace": "SW12",
                        "text": "SW12 - Madhya Pradesh"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW13",
                        "businessPlace": "SW13",
                        "text": "SW13 - Maharashtra"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW14",
                        "businessPlace": "SW14",
                        "text": "SW14 - Manipur"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW15",
                        "businessPlace": "SW15",
                        "text": "SW15 - Megalaya"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW16",
                        "businessPlace": "SW16",
                        "text": "SW16 - Mizoram"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW17",
                        "businessPlace": "SW17",
                        "text": "SW17 - Nagaland"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW18",
                        "businessPlace": "SW18",
                        "text": "SW18 - Odisha"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW19",
                        "businessPlace": "SW19",
                        "text": "SW19 - Punjab"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW20",
                        "businessPlace": "SW20",
                        "text": "SW20 - Rajasthan"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW21",
                        "businessPlace": "SW21",
                        "text": "SW21 - Sikkim"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW22",
                        "businessPlace": "SW22",
                        "text": "SW22 - Tamil Nadu"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW23",
                        "businessPlace": "SW23",
                        "text": "SW23 - Tripura"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW24",
                        "businessPlace": "SW24",
                        "text": "SW24 - Uttar Pradesh"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW25",
                        "businessPlace": "SW25",
                        "text": "SW25 - West Bengal"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW26",
                        "businessPlace": "SW26",
                        "text": "SW26 - Andaman and Nico.In."
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW27",
                        "businessPlace": "SW27",
                        "text": "SW27 - Chandigarh"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW28",
                        "businessPlace": "SW28",
                        "text": "SW28 - Dadra and Nagar Hav."
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW29",
                        "businessPlace": "SW29",
                        "text": "SW29 - Daman and Diu"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW30",
                        "businessPlace": "SW30",
                        "text": "SW30 - Delhi"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW31",
                        "businessPlace": "SW31",
                        "text": "SW31 - Lakshadweep"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW32",
                        "businessPlace": "SW32",
                        "text": "SW32 - Pondicherry"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW33",
                        "businessPlace": "SW33",
                        "text": "SW33 - Jharkand"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW34",
                        "businessPlace": "SW34",
                        "text": "SW34 - Uttaranchal"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW35",
                        "businessPlace": "SW35",
                        "text": "SW35 - Chhattisgarh"
                    },
                    {
                        "companyCode": "1200",
                        "value": "SW37",
                        "businessPlace": "SW37",
                        "text": "SW37 - Telangana"
                    },
                    {
                        "companyCode": "1300",
                        "value": "IN13",
                        "businessPlace": "IN13",
                        "text": "IN13 - UNITED PHOS (INDIA) LLP"
                    },
                    {
                        "companyCode": "1300",
                        "value": "LL06",
                        "text": "LL06 - Gujarat"
                    },
                    {
                        "companyCode": "1300",
                        "value": "LL13",
                        "text": "LL13 - Maharashtra"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT01",
                        "businessPlace": "DT01",
                        "text": "DT01 - UPL - Bhatinda Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT02",
                        "businessPlace": "DT02",
                        "text": "DT02 - UPL - Ludhiana Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT03",
                        "businessPlace": "DT03",
                        "text": "DT03 - UPL - Hissar Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT04",
                        "businessPlace": "DT04",
                        "text": "DT04 - UPL - Ahmedabad Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT05",
                        "businessPlace": "DT05",
                        "text": "DT05 - UPL - Srinagar Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT06",
                        "businessPlace": "DT06",
                        "text": "DT06 - UPL - Lucknow Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT07",
                        "businessPlace": "DT07",
                        "text": "DT07 - UPL - Gaziabad Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT08",
                        "businessPlace": "DT08",
                        "text": "DT08 - UPL - Jaipur Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT09",
                        "businessPlace": "DT09",
                        "text": "DT09 - UPL - Sriganganagar Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT10",
                        "businessPlace": "DT10",
                        "text": "DT10 - UPL - Raipur Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT11",
                        "businessPlace": "DT11",
                        "text": "DT11 - UPL - Cuttack Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT12",
                        "businessPlace": "DT12",
                        "text": "DT12 - UPL - Kolkatta Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT13",
                        "businessPlace": "DT13",
                        "text": "DT13 - UPL - Guwahati Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT14",
                        "businessPlace": "DT14",
                        "text": "DT14 - UPL - Patna Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT15",
                        "businessPlace": "DT15",
                        "text": "DT15 - UPL - Ranchi Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT16",
                        "businessPlace": "DT16",
                        "text": "DT16 - UPL - Secunderabad Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT17",
                        "businessPlace": "DT17",
                        "text": "DT17 - UPL - Guntur Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT18",
                        "businessPlace": "DT18",
                        "text": "DT18 - UPL - Kurnool Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT19",
                        "businessPlace": "DT19",
                        "text": "DT19 - UPL - Pune Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT20",
                        "businessPlace": "DT20",
                        "text": "DT20 - UPL - Akola Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT21",
                        "businessPlace": "DT21",
                        "text": "DT21 - UPL - Aurangabad Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT22",
                        "businessPlace": "DT22",
                        "text": "DT22 - UPL - Indore Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT23",
                        "businessPlace": "DT23",
                        "text": "DT23 - UPL - Jabalpur Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT24",
                        "businessPlace": "DT24",
                        "text": "DT24 - UPL - Bellary Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT25",
                        "businessPlace": "DT25",
                        "text": "DT25 - UPL - Davanagere Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT26",
                        "businessPlace": "DT26",
                        "text": "DT26 - UPL - Coimbatore Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT27",
                        "businessPlace": "DT27",
                        "text": "DT27 - UPL - Cochin Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT28",
                        "businessPlace": "DT28",
                        "text": "DT28 - UPL - Siliguri Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT29",
                        "businessPlace": "DT29",
                        "text": "DT29 - UPL - Ankleshwar Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT30",
                        "businessPlace": "DT30",
                        "text": "DT30 - UPL - Zirakhpur Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT31",
                        "businessPlace": "DT31",
                        "text": "DT31 - UPL - Ankleshwar Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT32",
                        "businessPlace": "DT32",
                        "text": "DT32 - UPL SAS LTD GUJRAT"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT33",
                        "businessPlace": "DT33",
                        "text": "DT33 - UPL SAS LTD J&K"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT34",
                        "businessPlace": "DT34",
                        "text": "DT34 - UPL SAS LTD WEST BENGAL"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT35",
                        "businessPlace": "DT35",
                        "text": "DT35 - UPL SAS LTD MAHARASHTRA"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT36",
                        "businessPlace": "DT36",
                        "text": "DT36 - UPL SAS KARNATAKA"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT37",
                        "businessPlace": "DT37",
                        "text": "DT37 - UPL Sustainable Agri Solu Ltd"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT38",
                        "businessPlace": "DT38",
                        "text": "DT38 - UPL Sustainable Agri Solu Ltd"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT39",
                        "businessPlace": "DT39",
                        "text": "DT39 - UPL - Bargarh Depot"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT40",
                        "businessPlace": "DT40",
                        "text": "DT40 - UPL SAS - Unit-1 [Ankleshwar]"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT41",
                        "businessPlace": "DT41",
                        "text": "DT41 - UPL SAS - Unit-2 [Ankleshwar]"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT42",
                        "businessPlace": "DT42",
                        "text": "DT42 - UPL SAS - Unit-3 [Ankleshwar]"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT43",
                        "businessPlace": "DT43",
                        "text": "DT43 - UPL SAS - Unit-4 [Halol]"
                    },
                    {
                        "companyCode": "1400",
                        "value": "DT44",
                        "businessPlace": "DT44",
                        "text": "DT44 - UPL SAS - Unit-5 [Jhagadia]"
                    },
                    {
                        "companyCode": "1400",
                        "value": "IN12",
                        "businessPlace": "IN12",
                        "text": "IN12 - Optima Farm Solutions Ltd"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN01",
                        "businessPlace": "UN01",
                        "text": "UN01 - UPL SAS Unimart - Lasalgaon"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN02",
                        "businessPlace": "UN02",
                        "text": "UN02 - UPL SAS Unimart - Abohar"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN03",
                        "businessPlace": "UN03",
                        "text": "UN03 - UPL SAS Unimart - Hissar"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN06",
                        "businessPlace": "UN06",
                        "text": "UN06 - UPL SAS Unimart - Pimpalgao"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN07",
                        "businessPlace": "UN07",
                        "text": "UN07 - UPL SAS Unimart - Manchar"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN08",
                        "businessPlace": "UN08",
                        "text": "UN08 - UPL SAS Unimart - Satana"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN10",
                        "businessPlace": "UN10",
                        "text": "UN10 - UPL SAS Unimart - Sillod"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN11",
                        "businessPlace": "UN11",
                        "text": "UN11 - UPL SAS Unimart - Hansi"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN12",
                        "businessPlace": "UN12",
                        "text": "UN12 - UPL SAS Unimart - Latur"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN13",
                        "businessPlace": "UN13",
                        "text": "UN13 - UPL SAS Unimart - Khuiyan"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN14",
                        "businessPlace": "UN14",
                        "text": "UN14 - UPL SAS Unimart - Ghatanji"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN15",
                        "businessPlace": "UN15",
                        "text": "UN15 - UPL SAS Unimart - Pusad"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN16",
                        "businessPlace": "UN16",
                        "text": "UN16 - UPL SAS Unimart - Shrigonda"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN17",
                        "businessPlace": "UN17",
                        "text": "UN17 - UPL SAS Unimart - Akola"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN18",
                        "businessPlace": "UN18",
                        "text": "UN18 - UPL SAS Unimart - Hinganghat"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN19",
                        "businessPlace": "UN19",
                        "text": "UN19 - UPL SAS Unimart - Warud"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN20",
                        "businessPlace": "UN20",
                        "text": "UN20 - UPL SAS Unimart - Karnal"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN22",
                        "businessPlace": "UN22",
                        "text": "UN22 - UPL SAS Unimart - Sirsa"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN23",
                        "businessPlace": "UN23",
                        "text": "UN23 - UPL SAS Unimart - Bhatinda"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN24",
                        "businessPlace": "UN24",
                        "text": "UN24 - UPL SAS Unimart - Junagadh"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN25",
                        "businessPlace": "UN25",
                        "text": "UN25 - UPL SAS Unimart - Khambaliya"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN26",
                        "businessPlace": "UN26",
                        "text": "UN26 - UPL SAS Unimart - Jetpur"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN27",
                        "businessPlace": "UN27",
                        "text": "UN27 - UPL SAS Unimart - Anjad"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN28",
                        "businessPlace": "UN28",
                        "text": "UN28 - UPL SAS Unimart - Bhiwani"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN29",
                        "businessPlace": "UN29",
                        "text": "UN29 - UPL SAS Unimart - Srigangana"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN30",
                        "businessPlace": "UN30",
                        "text": "UN30 - UPL SAS Unimart - Porbandar"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN31",
                        "businessPlace": "UN31",
                        "text": "UN31 - UPL SAS Unimart - Chilakalur"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN32",
                        "businessPlace": "UN32",
                        "text": "UN32 - UPL SAS Unimart – Dhrol"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN33",
                        "businessPlace": "UN33",
                        "text": "UN33 - UPL SAS Unimart - Savarkundl"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN34",
                        "businessPlace": "UN34",
                        "text": "UN34 - UPL SAS Unimart - Mortagi"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN35",
                        "businessPlace": "UN35",
                        "text": "UN35 - UPL SAS Unimart - Thirumalag"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN36",
                        "businessPlace": "UN36",
                        "text": "UN36 - UPL SUS Unimart - Himmatnagar"
                    },
                    {
                        "companyCode": "1400",
                        "value": "UN38",
                        "businessPlace": "UN38",
                        "text": "UN38 - UPL SAS Unimart –Talikota"
                    },
                    {
                        "companyCode": "1500",
                        "value": "AR03",
                        "businessPlace": "AR03",
                        "text": "AR03 - Arysta Lifescience India"
                    },
                    {
                        "companyCode": "1500",
                        "value": "AR06",
                        "businessPlace": "AR06",
                        "text": "AR06 - Arysta Lifescience India"
                    },
                    {
                        "companyCode": "1500",
                        "value": "AR07",
                        "businessPlace": "AR07",
                        "text": "AR07 - Arysta Lifescience India"
                    },
                    {
                        "companyCode": "1500",
                        "value": "AR12",
                        "businessPlace": "AR12",
                        "text": "AR12 - Arysta Lifescience India"
                    },
                    {
                        "companyCode": "1500",
                        "value": "AR13",
                        "businessPlace": "AR13",
                        "text": "AR13 - Arysta Lifescience India"
                    },
                    {
                        "companyCode": "1500",
                        "value": "AR19",
                        "businessPlace": "AR19",
                        "text": "AR19 - Arysta Lifescience India"
                    },
                    {
                        "companyCode": "1500",
                        "value": "AR20",
                        "businessPlace": "AR20",
                        "text": "AR20 - Arysta Lifescience India"
                    },
                    {
                        "companyCode": "1500",
                        "value": "AR24",
                        "businessPlace": "AR24",
                        "text": "AR24 - Arysta Lifescience India"
                    },
                    {
                        "companyCode": "1500",
                        "value": "AR25",
                        "businessPlace": "AR25",
                        "text": "AR25 - Arysta Lifescience India"
                    },
                    {
                        "companyCode": "1600",
                        "value": "NP10",
                        "businessPlace": "NP10",
                        "text": "NP10 - KARNATAKA"
                    },
                    {
                        "companyCode": "1600",
                        "value": "NP13",
                        "businessPlace": "NP13",
                        "text": "NP13 - MAHARASHTRA"
                    },
                    {
                        "companyCode": "1700",
                        "value": "AF10",
                        "businessPlace": "AF10",
                        "text": "AF10 - AFS AGTECH PRIVATE LIMITED"
                    },
                    {
                        "companyCode": "1700",
                        "value": "AF13",
                        "businessPlace": "AF13",
                        "text": "AF13 - Maharashtra"
                    },
                    {
                        "companyCode": "1700",
                        "value": "EC01",
                        "businessPlace": "EC01",
                        "text": "EC01 - Andhra Pradesh"
                    },
                    {
                        "companyCode": "1700",
                        "value": "EC04",
                        "businessPlace": "EC04",
                        "text": "EC04 - Bihar"
                    },
                    {
                        "companyCode": "1700",
                        "value": "EC06",
                        "businessPlace": "EC06",
                        "text": "EC06 - Gujarat"
                    },
                    {
                        "companyCode": "1700",
                        "value": "EC07",
                        "businessPlace": "EC07",
                        "text": "EC07 - Haryana"
                    },
                    {
                        "companyCode": "1700",
                        "value": "EC10",
                        "businessPlace": "EC10",
                        "text": "EC10 - Karnataka"
                    },
                    {
                        "companyCode": "1700",
                        "value": "EC12",
                        "businessPlace": "EC12",
                        "text": "EC12 - Madhya Pradesh"
                    },
                    {
                        "companyCode": "1700",
                        "value": "EC13",
                        "businessPlace": "EC13",
                        "text": "EC13 - Maharashtra"
                    },
                    {
                        "companyCode": "1700",
                        "value": "EC18",
                        "businessPlace": "EC18",
                        "text": "EC18 - Odisha"
                    },
                    {
                        "companyCode": "1700",
                        "value": "EC19",
                        "businessPlace": "EC19",
                        "text": "EC19 - Punjab"
                    },
                    {
                        "companyCode": "1700",
                        "value": "EC20",
                        "businessPlace": "EC20",
                        "text": "EC20 - Rajasthan"
                    },
                    {
                        "companyCode": "1700",
                        "value": "EC22",
                        "businessPlace": "EC22",
                        "text": "EC22 - Tamilnadu"
                    },
                    {
                        "companyCode": "1700",
                        "value": "EC24",
                        "businessPlace": "EC24",
                        "text": "EC24 - Uttar Pradesh"
                    },
                    {
                        "companyCode": "1700",
                        "value": "EC33",
                        "businessPlace": "EC33",
                        "text": "EC33 - Jharkhand"
                    },
                    {
                        "companyCode": "1700",
                        "value": "EC37",
                        "businessPlace": "EC37",
                        "text": "EC37 - Telangana"
                    },
                ]
            }
        case "GL_CODE":
            return {
                "GL_CODE": [
                    {
                        "freightType": "Inward",
                        "text": "160638 - Freight RM/PM/Consumable",
                        "tCode": "MIRO",
                        "value": "160638"
                    },
                    {
                        "freightType": "Inward",
                        "text": "160624 - Freight /FG-Import/Local",
                        "tCode": "MIRO",
                        "value": "160624"
                    },
                    {
                        "freightType": "Inward",
                        "text": "401115 - Freight -Demurrage",
                        "tCode": "FB60",
                        "value": "401115"
                    },
                    {
                        "freightType": "Out ward",
                        "text": "401101 - Freight Plant to Customer",
                        "tCode": "FB60/LSMW",
                        "value": "401101"
                    },
                    {
                        "freightType": "Out ward",
                        "text": "401103 - Freight Plant to Plant / Fixed monthly Freight / Plant to JOB Work side- Up & Down both/Freight -Holding Tanker",
                        "tCode": "FB60/LSMW",
                        "value": "401103"
                    },
                    {
                        "freightType": "Out ward",
                        "text": "401057 = Freight- ETP",
                        "tCode": "FB60/LSMW",
                        "value": "401057"
                    },
                    {
                        "freightType": "Out ward",
                        "text": "401107 - Freight- Water/Freight -One time",
                        "tCode": "FB60/LSMW",
                        "value": "401107"
                    }
                ]
            }
        case "COST_CENTER":
            return {
                "COST_CENTER": [
                    {
                        "value": "53182",
                        "companyCode": "1000",
                        "text": "53182 - **"
                    },
                    {
                        "value": "1700A01001",
                        "companyCode": "1700",
                        "text": "1700A01001 - Nurture Administration"
                    },
                    {
                        "value": "1700B01001",
                        "companyCode": "1700",
                        "text": "1700B01001 - Nurture Marketing"
                    },
                    {
                        "value": "1700B02001",
                        "companyCode": "1700",
                        "text": "1700B02001 - Nurture Farm - Harvesting Operations"
                    },
                    {
                        "value": "1700B02002",
                        "companyCode": "1700",
                        "text": "1700B02002 - Nurture Farm - Soil Testing Operations"
                    },
                    {
                        "value": "1700B02003",
                        "companyCode": "1700",
                        "text": "1700B02003 - Nurture Farm - Drone Spraying Operations"
                    },
                    {
                        "value": "1700B02004",
                        "companyCode": "1700",
                        "text": "1700B02004 - Nurture Farm - Insurance"
                    },
                    {
                        "value": "1700B02005",
                        "companyCode": "1700",
                        "text": "1700B02005 - Nurture Retail - Retail App Operations"
                    },
                    {
                        "value": "1700B02006",
                        "companyCode": "1700",
                        "text": "1700B02006 - Nurture Trade - Market Linkage Operation"
                    },
                    {
                        "value": "1700B02007",
                        "companyCode": "1700",
                        "text": "1700B02007 - Nurture Sustain - Carbon Operations"
                    },
                    {
                        "value": "1700B02008",
                        "companyCode": "1700",
                        "text": "1700B02008 - Nurture Sustain - Crop Residue Managemen"
                    },
                    {
                        "value": "1700B02009",
                        "companyCode": "1700",
                        "text": "1700B02009 - Nurture Retail - Retail App Operations"
                    },
                    {
                        "value": "1700B02010",
                        "companyCode": "1700",
                        "text": "1700B02010 - Nurture AKC"
                    },
                    {
                        "value": "1700C01001",
                        "companyCode": "1700",
                        "text": "1700C01001 - Nurture Corporate"
                    },
                    {
                        "value": "1700C01002",
                        "companyCode": "1700",
                        "text": "1700C01002 - Nurture Project Management"
                    },
                    {
                        "value": "1700E01001",
                        "companyCode": "1700",
                        "text": "1700E01001 - Nurture Legal"
                    },
                    {
                        "value": "1700F01001",
                        "companyCode": "1700",
                        "text": "1700F01001 - Nurture Finance"
                    },
                    {
                        "value": "1700F01002",
                        "companyCode": "1700",
                        "text": "1700F01002 - Nurture Business Finance & Operational E"
                    },
                    {
                        "value": "1700H01001",
                        "companyCode": "1700",
                        "text": "1700H01001 - Nurture Farm - Learning & Development"
                    },
                    {
                        "value": "1700H01002",
                        "companyCode": "1700",
                        "text": "1700H01002 - Nurture Retail - Learning & Development"
                    },
                    {
                        "value": "1700H01003",
                        "companyCode": "1700",
                        "text": "1700H01003 - Nurture Trade - Learning & Development"
                    },
                    {
                        "value": "1700H01004",
                        "companyCode": "1700",
                        "text": "1700H01004 - Nurture Sustain - Learning & Development"
                    },
                    {
                        "value": "1700H01005",
                        "companyCode": "1700",
                        "text": "1700H01005 - Nurture Human Resources"
                    },
                    {
                        "value": "1700H01006",
                        "companyCode": "1700",
                        "text": "1700H01006 - Nurture Learning & Development"
                    },
                    {
                        "value": "1700H01007",
                        "companyCode": "1700",
                        "text": "1700H01007 - Nurture Retail - Learning & Development"
                    },
                    {
                        "value": "1700I01001",
                        "companyCode": "1700",
                        "text": "1700I01001 - Nurture Farm - Product & Technology"
                    },
                    {
                        "value": "1700I01002",
                        "companyCode": "1700",
                        "text": "1700I01002 - Nurture Retail - Product & Technology"
                    },
                    {
                        "value": "1700I01003",
                        "companyCode": "1700",
                        "text": "1700I01003 - Nurture Trade - Product & Technology"
                    },
                    {
                        "value": "1700I01004",
                        "companyCode": "1700",
                        "text": "1700I01004 - Nurture Sustain - Product & Technology"
                    },
                    {
                        "value": "1700I01005",
                        "companyCode": "1700",
                        "text": "1700I01005 - Nurture Product & Technology"
                    },
                    {
                        "value": "1700I01006",
                        "companyCode": "1700",
                        "text": "1700I01006 - Nurture Retail - Product & Technology"
                    },
                    {
                        "value": "1700S02001",
                        "companyCode": "1700",
                        "text": "1700S02001 - Nurture Farm - Supply Chain"
                    },
                    {
                        "value": "1700S09001",
                        "companyCode": "1700",
                        "text": "1700S09001 - Nurture Supply Chain"
                    },
                    {
                        "value": "1700S13001",
                        "companyCode": "1700",
                        "text": "1700S13001 - Nurture Retail - Supply Chain"
                    },
                    {
                        "value": "1700S13002",
                        "companyCode": "1700",
                        "text": "1700S13002 - Nurture Trade - Supply Chain"
                    },
                    {
                        "value": "1700S13003",
                        "companyCode": "1700",
                        "text": "1700S13003 - Nurture Sustain - Supply Chain"
                    },
                    {
                        "value": "1700S13004",
                        "companyCode": "1700",
                        "text": "1700S13004 - Nurture Retail - Supply Chain"
                    },
                    {
                        "value": "A00001",
                        "companyCode": "1000",
                        "text": "A00001 - Adv FC R&D Canola"
                    },
                    {
                        "value": "A00002",
                        "companyCode": "1000",
                        "text": "A00002 - India-R&D-Breeding-Veg&Path"
                    },
                    {
                        "value": "A00003",
                        "companyCode": "1000",
                        "text": "A00003 - Adv FC R&D Cotton"
                    },
                    {
                        "value": "A00004",
                        "companyCode": "1000",
                        "text": "A00004 - Adv FC R&D Field Corn"
                    },
                    {
                        "value": "A00005",
                        "companyCode": "1000",
                        "text": "A00005 - Adv FC R&D Forage Sorghum"
                    },
                    {
                        "value": "A00006",
                        "companyCode": "1000",
                        "text": "A00006 - Adv FC R&D Grain Sorghum"
                    },
                    {
                        "value": "A00007",
                        "companyCode": "1000",
                        "text": "A00007 - Adv FC R&D Mustard"
                    },
                    {
                        "value": "A00008",
                        "companyCode": "1000",
                        "text": "A00008 - Adv FC R&D Pearl Millet"
                    },
                    {
                        "value": "A00009",
                        "companyCode": "1000",
                        "text": "A00009 - Adv FC R&D Rice"
                    },
                    {
                        "value": "A00010",
                        "companyCode": "1000",
                        "text": "A00010 - Adv FC R&D Sunflower"
                    },
                    {
                        "value": "A00011",
                        "companyCode": "1000",
                        "text": "A00011 - Adv FC DH-Protocols Development"
                    },
                    {
                        "value": "A00012",
                        "companyCode": "1000",
                        "text": "A00012 - Adv FC PVP/IPR"
                    },
                    {
                        "value": "A00013",
                        "companyCode": "1000",
                        "text": "A00013 - Adv VC R&D Bitter Gourd"
                    },
                    {
                        "value": "A00014",
                        "companyCode": "1000",
                        "text": "A00014 - Adv VC R&D Cabbage"
                    },
                    {
                        "value": "A00015",
                        "companyCode": "1000",
                        "text": "A00015 - Adv VC R&D Cauli Flower"
                    },
                    {
                        "value": "A00016",
                        "companyCode": "1000",
                        "text": "A00016 - India-R&D-Breeding-Veg&MB"
                    },
                    {
                        "value": "A00017",
                        "companyCode": "1000",
                        "text": "A00017 - India-Bihar-R&D-Corn-Breeding"
                    },
                    {
                        "value": "A00018",
                        "companyCode": "1000",
                        "text": "A00018 - India-Hyderabad-R&D-Global-DH"
                    },
                    {
                        "value": "A00019",
                        "companyCode": "1000",
                        "text": "A00019 - Adv VC R&D Okra"
                    },
                    {
                        "value": "A00020",
                        "companyCode": "1000",
                        "text": "A00020 - Adv VC R&D Pepper"
                    },
                    {
                        "value": "A00021",
                        "companyCode": "1000",
                        "text": "A00021 - Adv VC R&D Sweet Corn"
                    },
                    {
                        "value": "A00022",
                        "companyCode": "1000",
                        "text": "A00022 - Adv VC R&D Tomata"
                    },
                    {
                        "value": "A00023",
                        "companyCode": "1000",
                        "text": "A00023 - India-Banglore-R&D-Corn-Breeding"
                    },
                    {
                        "value": "A00024",
                        "companyCode": "1000",
                        "text": "A00024 - India-Bangalore-R&D-Mustard-Breeding"
                    },
                    {
                        "value": "A00025",
                        "companyCode": "1000",
                        "text": "A00025 - India-Hyderbad-R&D-Pearl Millet-Breeding"
                    },
                    {
                        "value": "A00026",
                        "companyCode": "1000",
                        "text": "A00026 - India-Hyderabad-R&D-Rice-Breeding"
                    },
                    {
                        "value": "A00027",
                        "companyCode": "1000",
                        "text": "A00027 - India-Pune-R&D-Sorghum-Breeding"
                    },
                    {
                        "value": "A00028",
                        "companyCode": "1000",
                        "text": "A00028 - India-Hyderabad-R&D-Global-DH-FC"
                    },
                    {
                        "value": "A00029",
                        "companyCode": "1000",
                        "text": "A00029 - India-Hyd-R&D-Global-Mole Breed-FC"
                    },
                    {
                        "value": "A00030",
                        "companyCode": "1000",
                        "text": "A00030 - India-Bihar-R&D-Corn-Breeding"
                    },
                    {
                        "value": "A00031",
                        "companyCode": "1000",
                        "text": "A00031 - India-Hyderabad-R&D-Global-Pathology-FC"
                    },
                    {
                        "value": "A00032",
                        "companyCode": "1000",
                        "text": "A00032 - India-Hyd-R&D-Global-Trait Intgr-FC"
                    },
                    {
                        "value": "A00033",
                        "companyCode": "1000",
                        "text": "A00033 - India-Hyderabad-R&D-Global-Pathology-VC"
                    },
                    {
                        "value": "A00034",
                        "companyCode": "1000",
                        "text": "A00034 - India-Hyd-R&D-Global-Mole Breed-VC"
                    },
                    {
                        "value": "A00035",
                        "companyCode": "1000",
                        "text": "A00035 - India-Hyderabad-R&D-Global-DH-VC"
                    },
                    {
                        "value": "A00036",
                        "companyCode": "1000",
                        "text": "A00036 - India-Sonipat-R&D-Cauliflower-Breeding"
                    },
                    {
                        "value": "A00037",
                        "companyCode": "1000",
                        "text": "A00037 - India-Hyderabad-R&D-Okra-Breeding"
                    },
                    {
                        "value": "A00038",
                        "companyCode": "1000",
                        "text": "A00038 - India-Hyd-R&D-Global-Trait Intgr-VC"
                    },
                    {
                        "value": "A00039",
                        "companyCode": "1000",
                        "text": "A00039 - India-Pune-R&D-Sweet Corn-Breeding"
                    },
                    {
                        "value": "A00040",
                        "companyCode": "1000",
                        "text": "A00040 - India-Bangalore-R&D-Tomato-Breeding"
                    },
                    {
                        "value": "A00041",
                        "companyCode": "1000",
                        "text": "A00041 - India-Bangalore-R&D-Hot Pepper-Breeding"
                    },
                    {
                        "value": "A00042",
                        "companyCode": "1000",
                        "text": "A00042 - India-Hyderabad-R&D-COMMON-FC"
                    },
                    {
                        "value": "A00043",
                        "companyCode": "1000",
                        "text": "A00043 - India-Hyderabad-R&D-FC Trials"
                    },
                    {
                        "value": "A00044",
                        "companyCode": "1000",
                        "text": "A00044 - India-Hyderabad-R&D-COMMON-VC"
                    },
                    {
                        "value": "A00045",
                        "companyCode": "1000",
                        "text": "A00045 - India-Hyderabad-R&D-VC Trials"
                    },
                    {
                        "value": "A00046",
                        "companyCode": "1000",
                        "text": "A00046 - India-Hyderabad-R&D-Rice-Projects"
                    },
                    {
                        "value": "A00047",
                        "companyCode": "1000",
                        "text": "A00047 - Adv FC R&D-SORGHUM PROJECTS"
                    },
                    {
                        "value": "A00048",
                        "companyCode": "1000",
                        "text": "A00048 - India-Hyd-R&D-Global-Mole Breed-Projects"
                    },
                    {
                        "value": "A00049",
                        "companyCode": "1000",
                        "text": "A00049 - India-Blr-R&D-Research Trials-Forages"
                    },
                    {
                        "value": "A00050",
                        "companyCode": "1000",
                        "text": "A00050 - India-Hyd-R&D-Pearl Mill-Grain-Breeding"
                    },
                    {
                        "value": "A00051",
                        "companyCode": "1000",
                        "text": "A00051 - India-Hyd-R&D-Pearl Mill-Forages-Breedin"
                    },
                    {
                        "value": "A00052",
                        "companyCode": "1000",
                        "text": "A00052 - India-Pune-R&D-Sorghum-Forages-Breeding"
                    },
                    {
                        "value": "A00053",
                        "companyCode": "1000",
                        "text": "A00053 - India-Hyderabad-R&D-Global Breeding"
                    },
                    {
                        "value": "A00054",
                        "companyCode": "1000",
                        "text": "A00054 - India-Hyderabad-R&D-Global Breeding VC"
                    },
                    {
                        "value": "A00055",
                        "companyCode": "1000",
                        "text": "A00055 - ."
                    },
                    {
                        "value": "A00056",
                        "companyCode": "1000",
                        "text": "A00056 - ."
                    },
                    {
                        "value": "A00057",
                        "companyCode": "1000",
                        "text": "A00057 - ."
                    },
                    {
                        "value": "A00058",
                        "companyCode": "1000",
                        "text": "A00058 - ADV Surat Field Crop"
                    },
                    {
                        "value": "A00059",
                        "companyCode": "1000",
                        "text": "A00059 - ADV Meerut Field Crop"
                    },
                    {
                        "value": "A00060",
                        "companyCode": "1000",
                        "text": "A00060 - **"
                    },
                    {
                        "value": "A00061",
                        "companyCode": "1000",
                        "text": "A00061 - **"
                    },
                    {
                        "value": "A00062",
                        "companyCode": "1000",
                        "text": "A00062 - **"
                    },
                    {
                        "value": "A01001",
                        "companyCode": "1000",
                        "text": "A01001 - Adv FC Basic Seed Overheads"
                    },
                    {
                        "value": "A01002",
                        "companyCode": "1000",
                        "text": "A01002 - Adv FC Basic Seed Prod Common"
                    },
                    {
                        "value": "A01003",
                        "companyCode": "1000",
                        "text": "A01003 - Adv FC Kallakal Processing Common"
                    },
                    {
                        "value": "A01004",
                        "companyCode": "1000",
                        "text": "A01004 - Adv FC Basic Seed Processing Common"
                    },
                    {
                        "value": "A01005",
                        "companyCode": "1000",
                        "text": "A01005 - Adv FC Basic Seed COGM"
                    },
                    {
                        "value": "A01006",
                        "companyCode": "1000",
                        "text": "A01006 - Adv VC Basic Seed COGM"
                    },
                    {
                        "value": "A01007",
                        "companyCode": "1000",
                        "text": "A01007 - Adv FC Kalakal COGM"
                    },
                    {
                        "value": "A01008",
                        "companyCode": "1000",
                        "text": "A01008 - Adv FC R&D-CORN PROJECTS"
                    },
                    {
                        "value": "A02001",
                        "companyCode": "1000",
                        "text": "A02001 - Adv FC Commercial Seed Overheads"
                    },
                    {
                        "value": "A02002",
                        "companyCode": "1000",
                        "text": "A02002 - Adv Production Baby Corn"
                    },
                    {
                        "value": "A02003",
                        "companyCode": "1000",
                        "text": "A02003 - Adv FC Production BT Cotton"
                    },
                    {
                        "value": "A02004",
                        "companyCode": "1000",
                        "text": "A02004 - Adv FC Production Common"
                    },
                    {
                        "value": "A02005",
                        "companyCode": "1000",
                        "text": "A02005 - Adv FC Production Field Corn"
                    },
                    {
                        "value": "A02006",
                        "companyCode": "1000",
                        "text": "A02006 - Adv FC Production Forage Sorghum"
                    },
                    {
                        "value": "A02007",
                        "companyCode": "1000",
                        "text": "A02007 - Adv FC Production Grain Sorghum"
                    },
                    {
                        "value": "A02008",
                        "companyCode": "1000",
                        "text": "A02008 - Adv FC Production Hybrid Canola"
                    },
                    {
                        "value": "A02009",
                        "companyCode": "1000",
                        "text": "A02009 - Adv FC Production Mustard"
                    },
                    {
                        "value": "A02010",
                        "companyCode": "1000",
                        "text": "A02010 - Adv FC Production Non BT Cotton"
                    },
                    {
                        "value": "A02011",
                        "companyCode": "1000",
                        "text": "A02011 - Adv FC Production Pearl Millet"
                    },
                    {
                        "value": "A02012",
                        "companyCode": "1000",
                        "text": "A02012 - Adv FC Production Rice"
                    },
                    {
                        "value": "A02013",
                        "companyCode": "1000",
                        "text": "A02013 - Adv FC Production Sweet Corn"
                    },
                    {
                        "value": "A02014",
                        "companyCode": "1000",
                        "text": "A02014 - Adv FC Production Sunflower"
                    },
                    {
                        "value": "A02015",
                        "companyCode": "1000",
                        "text": "A02015 - Adv FC Production Sweet Sorghum"
                    },
                    {
                        "value": "A02016",
                        "companyCode": "1000",
                        "text": "A02016 - Adv FC Production Research Common"
                    },
                    {
                        "value": "A02017",
                        "companyCode": "1000",
                        "text": "A02017 - Adv VC Production Common"
                    },
                    {
                        "value": "A02018",
                        "companyCode": "1000",
                        "text": "A02018 - Adv VC Commercial Seed Overheads"
                    },
                    {
                        "value": "A02019",
                        "companyCode": "1000",
                        "text": "A02019 - Adv VC Production Research Common"
                    },
                    {
                        "value": "A02020",
                        "companyCode": "1000",
                        "text": "A02020 - Forages - Production and Processing"
                    },
                    {
                        "value": "A02021",
                        "companyCode": "1000",
                        "text": "A02021 - Forages Production and Processing-COGM"
                    },
                    {
                        "value": "A03001",
                        "companyCode": "1000",
                        "text": "A03001 - Adv FC Nutankal Processing Common"
                    },
                    {
                        "value": "A03002",
                        "companyCode": "1000",
                        "text": "A03002 - Adv FC Quality Common"
                    },
                    {
                        "value": "A03003",
                        "companyCode": "1000",
                        "text": "A03003 - Adv VC Quality"
                    },
                    {
                        "value": "A03004",
                        "companyCode": "1000",
                        "text": "A03004 - Adv FC Hybrid Seed Overheads"
                    },
                    {
                        "value": "A03005",
                        "companyCode": "1000",
                        "text": "A03005 - Adv FC COMMERCIAL SEED COGM"
                    },
                    {
                        "value": "A03006",
                        "companyCode": "1000",
                        "text": "A03006 - Adv FC SPR SEED COGM"
                    },
                    {
                        "value": "A04001",
                        "companyCode": "1000",
                        "text": "A04001 - Adv VC FS Processing"
                    },
                    {
                        "value": "A04002",
                        "companyCode": "1000",
                        "text": "A04002 - Adv VC FS Overhead"
                    },
                    {
                        "value": "A04003",
                        "companyCode": "1000",
                        "text": "A04003 - Adv VC Processing Kalakal"
                    },
                    {
                        "value": "A04004",
                        "companyCode": "1000",
                        "text": "A04004 - Adv VC SPR SEED COGM"
                    },
                    {
                        "value": "A04005",
                        "companyCode": "1000",
                        "text": "A04005 - Adv VC COMM SEED COGM"
                    },
                    {
                        "value": "A05001",
                        "companyCode": "1000",
                        "text": "A05001 - Adv VC Processing Kundli"
                    },
                    {
                        "value": "A06001",
                        "companyCode": "1000",
                        "text": "A06001 - Adv VC Processing Sri Ganganagar"
                    },
                    {
                        "value": "A07001",
                        "companyCode": "1000",
                        "text": "A07001 - '--"
                    },
                    {
                        "value": "A08001",
                        "companyCode": "1000",
                        "text": "A08001 - Adv VC NUTANKAL COMM SEED COGM"
                    },
                    {
                        "value": "A10001",
                        "companyCode": "1000",
                        "text": "A10001 - Adv FC NANDYAL COMM SEED COGM"
                    },
                    {
                        "value": "A11001",
                        "companyCode": "1000",
                        "text": "A11001 - Adv FC ELURU COMM SEED COGM"
                    },
                    {
                        "value": "A12001",
                        "companyCode": "1000",
                        "text": "A12001 - Adv FC Kalakal COGM"
                    },
                    {
                        "value": "A52001",
                        "companyCode": "1000",
                        "text": "A52001 - Adv FC Corporate Administration"
                    },
                    {
                        "value": "A52002",
                        "companyCode": "1000",
                        "text": "A52002 - Adv FC Corporate Finance"
                    },
                    {
                        "value": "A52003",
                        "companyCode": "1000",
                        "text": "A52003 - Adv FC Corporate HR & Admin"
                    },
                    {
                        "value": "A52004",
                        "companyCode": "1000",
                        "text": "A52004 - Adv FC Corporate IT"
                    },
                    {
                        "value": "A52005",
                        "companyCode": "1000",
                        "text": "A52005 - Adv FC Corporate Legal"
                    },
                    {
                        "value": "A52006",
                        "companyCode": "1000",
                        "text": "A52006 - Adv FC Purchase Dept"
                    },
                    {
                        "value": "A52007",
                        "companyCode": "1000",
                        "text": "A52007 - Adv VC Corporate Finance"
                    },
                    {
                        "value": "A52008",
                        "companyCode": "1000",
                        "text": "A52008 - Adv VC Corporate Purchase"
                    },
                    {
                        "value": "A52009",
                        "companyCode": "1000",
                        "text": "A52009 - Adv VC Corporate HR & Admin"
                    },
                    {
                        "value": "A52010",
                        "companyCode": "1000",
                        "text": "A52010 - Adv VC Corporate Administration"
                    },
                    {
                        "value": "A52011",
                        "companyCode": "1000",
                        "text": "A52011 - Adv FC Corporate SAP"
                    },
                    {
                        "value": "A52012",
                        "companyCode": "1000",
                        "text": "A52012 - Adv FC Corporate Logistics"
                    },
                    {
                        "value": "A52013",
                        "companyCode": "1000",
                        "text": "A52013 - Adv VC Corporate Logistics"
                    },
                    {
                        "value": "A52014",
                        "companyCode": "1000",
                        "text": "A52014 - Adv VC Corporate IT"
                    },
                    {
                        "value": "A52015",
                        "companyCode": "1000",
                        "text": "A52015 - Adv VC Corporate SAP"
                    },
                    {
                        "value": "A52016",
                        "companyCode": "1000",
                        "text": "A52016 - FC India Supply Chain Management"
                    },
                    {
                        "value": "A52017",
                        "companyCode": "1000",
                        "text": "A52017 - VC India Supply Chain Management"
                    },
                    {
                        "value": "A52018",
                        "companyCode": "1000",
                        "text": "A52018 - Forages common - Finance"
                    },
                    {
                        "value": "A52019",
                        "companyCode": "1000",
                        "text": "A52019 - Forages common - HR & Admin"
                    },
                    {
                        "value": "A52020",
                        "companyCode": "1000",
                        "text": "A52020 - Forages common - IT"
                    },
                    {
                        "value": "A52021",
                        "companyCode": "1000",
                        "text": "A52021 - Supply Chain common"
                    },
                    {
                        "value": "A52022",
                        "companyCode": "1000",
                        "text": "A52022 - PSP common Expenses"
                    },
                    {
                        "value": "A52023",
                        "companyCode": "1000",
                        "text": "A52023 - SPR common Expenses"
                    },
                    {
                        "value": "A52024",
                        "companyCode": "1000",
                        "text": "A52024 - QC common Expenses"
                    },
                    {
                        "value": "A52025",
                        "companyCode": "1000",
                        "text": "A52025 - Logistics common Expenses"
                    },
                    {
                        "value": "A52026",
                        "companyCode": "1000",
                        "text": "A52026 - Purchase common Expenses"
                    },
                    {
                        "value": "A52027",
                        "companyCode": "1000",
                        "text": "A52027 - Forage India Supp.Chain"
                    },
                    {
                        "value": "A52028",
                        "companyCode": "1000",
                        "text": "A52028 - Production FC and Forage common Expenses"
                    },
                    {
                        "value": "A52029",
                        "companyCode": "1000",
                        "text": "A52029 - Processing FC and Forage common Expenses"
                    },
                    {
                        "value": "A52030",
                        "companyCode": "1000",
                        "text": "A52030 - Forage Processing"
                    },
                    {
                        "value": "A52031",
                        "companyCode": "1000",
                        "text": "A52031 - Forage PSP"
                    },
                    {
                        "value": "A52032",
                        "companyCode": "1000",
                        "text": "A52032 - Forage SPR"
                    },
                    {
                        "value": "A52033",
                        "companyCode": "1000",
                        "text": "A52033 - Forage QC"
                    },
                    {
                        "value": "A52034",
                        "companyCode": "1000",
                        "text": "A52034 - Forage Logistics"
                    },
                    {
                        "value": "A52035",
                        "companyCode": "1000",
                        "text": "A52035 - Forage Purchase"
                    },
                    {
                        "value": "A52036",
                        "companyCode": "1000",
                        "text": "A52036 - Forage Administration"
                    },
                    {
                        "value": "A52037",
                        "companyCode": "1000",
                        "text": "A52037 - Finace common Expenses"
                    },
                    {
                        "value": "A52038",
                        "companyCode": "1000",
                        "text": "A52038 - IT common Expenses"
                    },
                    {
                        "value": "A52039",
                        "companyCode": "1000",
                        "text": "A52039 - Admin common Expenses"
                    },
                    {
                        "value": "A52040",
                        "companyCode": "1000",
                        "text": "A52040 - HR common Expenses"
                    },
                    {
                        "value": "A53001",
                        "companyCode": "1000",
                        "text": "A53001 - Production FC"
                    },
                    {
                        "value": "A53002",
                        "companyCode": "1000",
                        "text": "A53002 - Processing FC"
                    },
                    {
                        "value": "A53003",
                        "companyCode": "1000",
                        "text": "A53003 - TD"
                    },
                    {
                        "value": "A53004",
                        "companyCode": "1000",
                        "text": "A53004 - Quality"
                    },
                    {
                        "value": "A53005",
                        "companyCode": "1000",
                        "text": "A53005 - SPR"
                    },
                    {
                        "value": "A53006",
                        "companyCode": "1000",
                        "text": "A53006 - Production VC"
                    },
                    {
                        "value": "A53007",
                        "companyCode": "1000",
                        "text": "A53007 - Processing VC"
                    },
                    {
                        "value": "A53051",
                        "companyCode": "1000",
                        "text": "A53051 - Marketing"
                    },
                    {
                        "value": "A53052",
                        "companyCode": "1000",
                        "text": "A53052 - Sales"
                    },
                    {
                        "value": "A53053",
                        "companyCode": "1000",
                        "text": "A53053 - Admin"
                    },
                    {
                        "value": "A53054",
                        "companyCode": "1000",
                        "text": "A53054 - HR"
                    },
                    {
                        "value": "A53055",
                        "companyCode": "1000",
                        "text": "A53055 - Finance"
                    },
                    {
                        "value": "A53056",
                        "companyCode": "1000",
                        "text": "A53056 - Legal"
                    },
                    {
                        "value": "A53057",
                        "companyCode": "1000",
                        "text": "A53057 - IT"
                    },
                    {
                        "value": "A53058",
                        "companyCode": "1000",
                        "text": "A53058 - Advanta SAP"
                    },
                    {
                        "value": "A53059",
                        "companyCode": "1000",
                        "text": "A53059 - R&D"
                    },
                    {
                        "value": "A53101",
                        "companyCode": "1000",
                        "text": "A53101 - Global CEO"
                    },
                    {
                        "value": "A53102",
                        "companyCode": "1000",
                        "text": "A53102 - Global HR"
                    },
                    {
                        "value": "A53103",
                        "companyCode": "1000",
                        "text": "A53103 - Global Finance"
                    },
                    {
                        "value": "A53104",
                        "companyCode": "1000",
                        "text": "A53104 - Global Supply chain"
                    },
                    {
                        "value": "A53105",
                        "companyCode": "1000",
                        "text": "A53105 - Global R&D"
                    },
                    {
                        "value": "A53106",
                        "companyCode": "1000",
                        "text": "A53106 - Global Legal"
                    },
                    {
                        "value": "A53107",
                        "companyCode": "1000",
                        "text": "A53107 - Global Admin"
                    },
                    {
                        "value": "A53108",
                        "companyCode": "1000",
                        "text": "A53108 - International business - Asia"
                    },
                    {
                        "value": "A53109",
                        "companyCode": "1000",
                        "text": "A53109 - International business - Africa"
                    },
                    {
                        "value": "A53110",
                        "companyCode": "1000",
                        "text": "A53110 - International business - Common"
                    },
                    {
                        "value": "A53111",
                        "companyCode": "1000",
                        "text": "A53111 - International Business Europe"
                    },
                    {
                        "value": "A53112",
                        "companyCode": "1000",
                        "text": "A53112 - International Business HR"
                    },
                    {
                        "value": "A53113",
                        "companyCode": "1000",
                        "text": "A53113 - International Business Finance"
                    },
                    {
                        "value": "A53114",
                        "companyCode": "1000",
                        "text": "A53114 - International Business Logistics"
                    },
                    {
                        "value": "A53115",
                        "companyCode": "1000",
                        "text": "A53115 - International Business Supply chain"
                    },
                    {
                        "value": "A53116",
                        "companyCode": "1000",
                        "text": "A53116 - International Business Marketing Philip"
                    },
                    {
                        "value": "A53117",
                        "companyCode": "1000",
                        "text": "A53117 - South Asia Marketing"
                    },
                    {
                        "value": "A53118",
                        "companyCode": "1000",
                        "text": "A53118 - International Business Africa"
                    },
                    {
                        "value": "A53119",
                        "companyCode": "1000",
                        "text": "A53119 - International Business South Asia"
                    },
                    {
                        "value": "A53120",
                        "companyCode": "1000",
                        "text": "A53120 - International Business South Asia"
                    },
                    {
                        "value": "A53121",
                        "companyCode": "1000",
                        "text": "A53121 - International Business Europe"
                    },
                    {
                        "value": "A53122",
                        "companyCode": "1000",
                        "text": "A53122 - International Business Europe-Finance"
                    },
                    {
                        "value": "A53123",
                        "companyCode": "1000",
                        "text": "A53123 - Adv-Mol Breeder Projects"
                    },
                    {
                        "value": "A53124",
                        "companyCode": "1000",
                        "text": "A53124 - Supply chain- Africa"
                    },
                    {
                        "value": "A53125",
                        "companyCode": "1000",
                        "text": "A53125 - Global IT"
                    },
                    {
                        "value": "A53126",
                        "companyCode": "1000",
                        "text": "A53126 - Global QC"
                    },
                    {
                        "value": "A53127",
                        "companyCode": "1000",
                        "text": "A53127 - Global Commercial"
                    },
                    {
                        "value": "A53128",
                        "companyCode": "1000",
                        "text": "A53128 - International Business"
                    },
                    {
                        "value": "A53129",
                        "companyCode": "1000",
                        "text": "A53129 - Global Parent Seeds"
                    },
                    {
                        "value": "A53130",
                        "companyCode": "1000",
                        "text": "A53130 - Global Corporate - Supply Chain"
                    },
                    {
                        "value": "C00101",
                        "companyCode": "1000",
                        "text": "C00101 - UPL-VAPI-ALUMINIUM PHOSPHIDE MFG+LAB"
                    },
                    {
                        "value": "C00102",
                        "companyCode": "1000",
                        "text": "C00102 - UPL-VAPI-ALUMINIUM PHOSPHIDE - PKG"
                    },
                    {
                        "value": "C00103",
                        "companyCode": "1000",
                        "text": "C00103 - UPL-VAPI-MR17"
                    },
                    {
                        "value": "C00104",
                        "companyCode": "1000",
                        "text": "C00104 - UPL-VAPI-ZINC PHOSPHIDE - MFG"
                    },
                    {
                        "value": "C00105",
                        "companyCode": "1000",
                        "text": "C00105 - UPL-VAPI-ZINC PHOSPHIDE - PKG"
                    },
                    {
                        "value": "C00106",
                        "companyCode": "1000",
                        "text": "C00106 - UPL-VAPI-RED PHOSPHORUS"
                    },
                    {
                        "value": "C00107",
                        "companyCode": "1000",
                        "text": "C00107 - UPL-VAPI-DVA-ETP (OLD P2S5)"
                    },
                    {
                        "value": "C00108",
                        "companyCode": "1000",
                        "text": "C00108 - UPL-VAPI-PESTICIDES - TECHNICAL"
                    },
                    {
                        "value": "C00109",
                        "companyCode": "1000",
                        "text": "C00109 - UPL-VAPI-PERMETHRIN"
                    },
                    {
                        "value": "C00110",
                        "companyCode": "1000",
                        "text": "C00110 - UPL-VAPI-PEST-FORMULATIONS"
                    },
                    {
                        "value": "C00111",
                        "companyCode": "1000",
                        "text": "C00111 - UPL-VAPI-PMA/MEMC"
                    },
                    {
                        "value": "C00112",
                        "companyCode": "1000",
                        "text": "C00112 - UPL-VAPI-META PHENOXY BENZALDEHYDE"
                    },
                    {
                        "value": "C00113",
                        "companyCode": "1000",
                        "text": "C00113 - UPL-VAPI-PROPANIL"
                    },
                    {
                        "value": "C00114",
                        "companyCode": "1000",
                        "text": "C00114 - UPL-VAPI-D.V.A CHLORIDE"
                    },
                    {
                        "value": "C00115",
                        "companyCode": "1000",
                        "text": "C00115 - UPL-VAPI-PHEN/DESMEDIPHAM (OLD METAMITR)"
                    },
                    {
                        "value": "C00116",
                        "companyCode": "1000",
                        "text": "C00116 - UPL-VAPI-R&D PILOT"
                    },
                    {
                        "value": "C00117",
                        "companyCode": "1000",
                        "text": "C00117 - UPL-VAPI - UPH - 203"
                    },
                    {
                        "value": "C00201",
                        "companyCode": "1000",
                        "text": "C00201 - UPL-VAPI-POWER"
                    },
                    {
                        "value": "C00202",
                        "companyCode": "1000",
                        "text": "C00202 - UPL-VAPI-WATER"
                    },
                    {
                        "value": "C00203",
                        "companyCode": "1000",
                        "text": "C00203 - UPL-VAPI-STEAM"
                    },
                    {
                        "value": "C00204",
                        "companyCode": "1000",
                        "text": "C00204 - UPL-VAPI-COOLING WATER"
                    },
                    {
                        "value": "C00205",
                        "companyCode": "1000",
                        "text": "C00205 - UPL-VAPI-D G HOUSE"
                    },
                    {
                        "value": "C00206",
                        "companyCode": "1000",
                        "text": "C00206 - UPL-VAPI-NITROGEN"
                    },
                    {
                        "value": "C00207",
                        "companyCode": "1000",
                        "text": "C00207 - UPL-VAPI-CHILLED WATER"
                    },
                    {
                        "value": "C00208",
                        "companyCode": "1000",
                        "text": "C00208 - UPL-VAPI-BOILER (STEAM PRODUCTION)"
                    },
                    {
                        "value": "C00301",
                        "companyCode": "1000",
                        "text": "C00301 - UPL-VAPI-ENGINEERING - MECHANICAL"
                    },
                    {
                        "value": "C00302",
                        "companyCode": "1000",
                        "text": "C00302 - UPL-VAPI-ENGINEERING - ELECTRICAL"
                    },
                    {
                        "value": "C00303",
                        "companyCode": "1000",
                        "text": "C00303 - UPL-VAPI-ENGINEERING - INSTRUMENTATION"
                    },
                    {
                        "value": "C00304",
                        "companyCode": "1000",
                        "text": "C00304 - UPL-VAPI-ENGINEERING - CIVIL"
                    },
                    {
                        "value": "C00401",
                        "companyCode": "1000",
                        "text": "C00401 - UPL-VAPI-FACTORY ACCOUNTS/MIS"
                    },
                    {
                        "value": "C00402",
                        "companyCode": "1000",
                        "text": "C00402 - UPL-VAPI-FACTORY PURCHASE"
                    },
                    {
                        "value": "C00403",
                        "companyCode": "1000",
                        "text": "C00403 - UPL-VAPI-MATERIAL MGMT / STORES"
                    },
                    {
                        "value": "C00501",
                        "companyCode": "1000",
                        "text": "C00501 - UPL-VAPI-ADMINISTRATION"
                    },
                    {
                        "value": "C00502",
                        "companyCode": "1000",
                        "text": "C00502 - UPL-VAPI-SECURITY"
                    },
                    {
                        "value": "C00503",
                        "companyCode": "1000",
                        "text": "C00503 - UPL-VAPI-FACTORY PERSONNEL DEPT"
                    },
                    {
                        "value": "C00504",
                        "companyCode": "1000",
                        "text": "C00504 - UPL-VAPI-HRD"
                    },
                    {
                        "value": "C00505",
                        "companyCode": "1000",
                        "text": "C00505 - UPL-VAPI-INFORMATION TECHNOLOGY"
                    },
                    {
                        "value": "C00506",
                        "companyCode": "1000",
                        "text": "C00506 - UPL-VAPI-CANTEEN + GEN WELFARE"
                    },
                    {
                        "value": "C00507",
                        "companyCode": "1000",
                        "text": "C00507 - UPL-VAPI-QUALITY CONTROL LABORATORY"
                    },
                    {
                        "value": "C00508",
                        "companyCode": "1000",
                        "text": "C00508 - UPL-VAPI-SAFETY DEPARTMENT"
                    },
                    {
                        "value": "C00509",
                        "companyCode": "1000",
                        "text": "C00509 - UPL-VAPI-RESEARCH & DEVELOPMENT"
                    },
                    {
                        "value": "C00510",
                        "companyCode": "1000",
                        "text": "C00510 - UPL-VAPI-MAXPRO EXPENSES"
                    },
                    {
                        "value": "C00511",
                        "companyCode": "1000",
                        "text": "C00511 - UPL-VAPI-EFFLUENT TREATMENT PLANT"
                    },
                    {
                        "value": "C00512",
                        "companyCode": "1000",
                        "text": "C00512 - UPL-VAPI-INCINERATOR"
                    },
                    {
                        "value": "C00513",
                        "companyCode": "1000",
                        "text": "C00513 - UPL-VAPI-GUEST HOUSE"
                    },
                    {
                        "value": "C00514",
                        "companyCode": "1000",
                        "text": "C00514 - UPL-VAPI-BATCHELOR ACCOMODATION"
                    },
                    {
                        "value": "C00515",
                        "companyCode": "1000",
                        "text": "C00515 - UPL-VAPI-HOUSING COLONY"
                    },
                    {
                        "value": "C00517",
                        "companyCode": "1000",
                        "text": "C00517 - UPL-VAPI-ENVIRONMENT CELL"
                    },
                    {
                        "value": "C00518",
                        "companyCode": "1000",
                        "text": "C00518 - UPL-VAPI-METAL PHOSPHIDE LAB (R & D)"
                    },
                    {
                        "value": "C00519",
                        "companyCode": "1000",
                        "text": "C00519 - UPL-VAPI-QUALITY CONTROL PACKAGING"
                    },
                    {
                        "value": "C00520",
                        "companyCode": "1000",
                        "text": "C00520 - UPL-VAPI-TRIPLE EFFECT EVAPORATOR"
                    },
                    {
                        "value": "C00521",
                        "companyCode": "1000",
                        "text": "C00521 - UPL-VAPI-HOUSEKEEPIN"
                    },
                    {
                        "value": "C00522",
                        "companyCode": "1000",
                        "text": "C00522 - UPL-VAPI-ENVIRONMENT CELL"
                    },
                    {
                        "value": "C00523",
                        "companyCode": "1000",
                        "text": "C00523 - UPL-VAPI-CORPORATE SOCIAL RESPONSIBILITY"
                    },
                    {
                        "value": "C00524",
                        "companyCode": "1000",
                        "text": "C00524 - ."
                    },
                    {
                        "value": "C00525",
                        "companyCode": "1000",
                        "text": "C00525 - Manufacturing Management Vapi"
                    },
                    {
                        "value": "C00601",
                        "companyCode": "1000",
                        "text": "C00601 - UPL-VAPI-STANDSTILL & ELIMINATION COST"
                    },
                    {
                        "value": "C00602",
                        "companyCode": "1000",
                        "text": "C00602 - UPL-VAPI-FINISHED GOODS STORES"
                    },
                    {
                        "value": "C00603",
                        "companyCode": "1000",
                        "text": "C00603 - UPL-VAPI-PROJECT PLANNING/TECHNICAL"
                    },
                    {
                        "value": "C00604",
                        "companyCode": "1000",
                        "text": "C00604 - UPL-VAPI-FUMIGATION TECHNOLOGY (R & D)"
                    },
                    {
                        "value": "C00605",
                        "companyCode": "1000",
                        "text": "C00605 - UPL-VAPI-R & D PROCECSS DEVELOPMENT"
                    },
                    {
                        "value": "C00606",
                        "companyCode": "1000",
                        "text": "C00606 - UPL-VAPI-R & D NAHULI"
                    },
                    {
                        "value": "C00607",
                        "companyCode": "1000",
                        "text": "C00607 - UPL-VAPI-R & D - GAS DETECTION EQUIPMENT"
                    },
                    {
                        "value": "C00608",
                        "companyCode": "1000",
                        "text": "C00608 - UPL-VAPI-DEVKA GUEST HOUSE"
                    },
                    {
                        "value": "C00609",
                        "companyCode": "1000",
                        "text": "C00609 - UPL-VAPI-VIKRAM-FARM"
                    },
                    {
                        "value": "C00610",
                        "companyCode": "1000",
                        "text": "C00610 - UPL-SUB-ULTIMA SEARCH"
                    },
                    {
                        "value": "C00611",
                        "companyCode": "1000",
                        "text": "C00611 - UPL-SUB-UNIPHOS AGRO"
                    },
                    {
                        "value": "C00612",
                        "companyCode": "1000",
                        "text": "C00612 - UPL-SUB-NERKA"
                    },
                    {
                        "value": "C00613",
                        "companyCode": "1000",
                        "text": "C00613 - UPL-VAPI-EQUIPMENT YARD"
                    },
                    {
                        "value": "C00614",
                        "companyCode": "1000",
                        "text": "C00614 - UPL-VAPI-PCPL [ TARAPUR ]"
                    },
                    {
                        "value": "C01101",
                        "companyCode": "1000",
                        "text": "C01101 - UPL-ANK1-ULALA"
                    },
                    {
                        "value": "C01102",
                        "companyCode": "1000",
                        "text": "C01102 - UPL-ANK1-PHOSPHORUS TRI CHLORIDE (PCL3)"
                    },
                    {
                        "value": "C01103",
                        "companyCode": "1000",
                        "text": "C01103 - UPL-ANK1-TRIMETHYL PHOSPHITE (TMP)"
                    },
                    {
                        "value": "C01104",
                        "companyCode": "1000",
                        "text": "C01104 - UPL-ANK1-EFFLUENT TREATMENT PLANT-NH4CL"
                    },
                    {
                        "value": "C01105",
                        "companyCode": "1000",
                        "text": "C01105 - UPL-ANK1-EFF TREAT PLANT CALC CHLORIDE"
                    },
                    {
                        "value": "C01106",
                        "companyCode": "1000",
                        "text": "C01106 - UPL-ANK1-MONOCROTOPHOS"
                    },
                    {
                        "value": "C01107",
                        "companyCode": "1000",
                        "text": "C01107 - UPL-ANK1-MANCOZEB"
                    },
                    {
                        "value": "C01108",
                        "companyCode": "1000",
                        "text": "C01108 - UPL-ANK1-ANTRACOL"
                    },
                    {
                        "value": "C01109",
                        "companyCode": "1000",
                        "text": "C01109 - UPL-ANK1-NOFLAN"
                    },
                    {
                        "value": "C01110",
                        "companyCode": "1000",
                        "text": "C01110 - UPL-ANK1-DDVP"
                    },
                    {
                        "value": "C01111",
                        "companyCode": "1000",
                        "text": "C01111 - UPL-ANK1-MANCOZEB-SMALL PACK"
                    },
                    {
                        "value": "C01112",
                        "companyCode": "1000",
                        "text": "C01112 - UPL-ANK1-IKI"
                    },
                    {
                        "value": "C01113",
                        "companyCode": "1000",
                        "text": "C01113 - UPL-ANK1-IKI220(NEW)"
                    },
                    {
                        "value": "C01201",
                        "companyCode": "1000",
                        "text": "C01201 - UPL-ANK1-POWER"
                    },
                    {
                        "value": "C01202",
                        "companyCode": "1000",
                        "text": "C01202 - UPL-ANK1-WATER"
                    },
                    {
                        "value": "C01203",
                        "companyCode": "1000",
                        "text": "C01203 - UPL-ANK1-STEAM"
                    },
                    {
                        "value": "C01204",
                        "companyCode": "1000",
                        "text": "C01204 - UPL-ANK1-COOLING WATER"
                    },
                    {
                        "value": "C01205",
                        "companyCode": "1000",
                        "text": "C01205 - UPL-ANK1-D G HOUSE"
                    },
                    {
                        "value": "C01208",
                        "companyCode": "1000",
                        "text": "C01208 - UPL-ANK1-BOILER (STEAM PRODUCTION)"
                    },
                    {
                        "value": "C01301",
                        "companyCode": "1000",
                        "text": "C01301 - UPL-ANK1-ENGINEERING - MECHANICAL"
                    },
                    {
                        "value": "C01302",
                        "companyCode": "1000",
                        "text": "C01302 - UPL-ANK1-ENGINEERING - ELECTRICAL"
                    },
                    {
                        "value": "C01303",
                        "companyCode": "1000",
                        "text": "C01303 - UPL-ANK1-ENGINEERING - INSTRUMENT"
                    },
                    {
                        "value": "C01304",
                        "companyCode": "1000",
                        "text": "C01304 - UPL-ANK1-ENGINEERING - CIVIL"
                    },
                    {
                        "value": "C01401",
                        "companyCode": "1000",
                        "text": "C01401 - UPL-ANK1-FACTORY ACCOUNTS/MIS"
                    },
                    {
                        "value": "C01402",
                        "companyCode": "1000",
                        "text": "C01402 - UPL-ANK1-FACTORY PURCHASE"
                    },
                    {
                        "value": "C01403",
                        "companyCode": "1000",
                        "text": "C01403 - UPL-ANK1-MATERIAL MGMT / STORES"
                    },
                    {
                        "value": "C01501",
                        "companyCode": "1000",
                        "text": "C01501 - UPL-ANK1-ADMINISTRATION"
                    },
                    {
                        "value": "C01502",
                        "companyCode": "1000",
                        "text": "C01502 - UPL-ANK1-SECURITY"
                    },
                    {
                        "value": "C01503",
                        "companyCode": "1000",
                        "text": "C01503 - UPL-ANK1-FACTORY PERSONNEL DEPT"
                    },
                    {
                        "value": "C01504",
                        "companyCode": "1000",
                        "text": "C01504 - UPL-ANK1-HRD"
                    },
                    {
                        "value": "C01505",
                        "companyCode": "1000",
                        "text": "C01505 - UPL-ANK1-INFORMATION TECHNOLOGY"
                    },
                    {
                        "value": "C01506",
                        "companyCode": "1000",
                        "text": "C01506 - UPL-ANK1-CANTEEN + GEN WELFARE"
                    },
                    {
                        "value": "C01507",
                        "companyCode": "1000",
                        "text": "C01507 - UPL-ANK1-QUALITY CONTROL LABORATORY"
                    },
                    {
                        "value": "C01508",
                        "companyCode": "1000",
                        "text": "C01508 - UPL-ANK1-SAFETY DEPT"
                    },
                    {
                        "value": "C01509",
                        "companyCode": "1000",
                        "text": "C01509 - UPL-ANK1-RESEARCH & DEVELOPMENT"
                    },
                    {
                        "value": "C01510",
                        "companyCode": "1000",
                        "text": "C01510 - UPL-ANK1-MAXPRO EXPENSES"
                    },
                    {
                        "value": "C01511",
                        "companyCode": "1000",
                        "text": "C01511 - UPL-ANK1-EFFLUENT TREATMENT PLANT"
                    },
                    {
                        "value": "C01512",
                        "companyCode": "1000",
                        "text": "C01512 - UPL-ANK1-INCINERATOR"
                    },
                    {
                        "value": "C01513",
                        "companyCode": "1000",
                        "text": "C01513 - UPL-ANK1-GUEST HOUSE (IN HOUSING COLONY)"
                    },
                    {
                        "value": "C01514",
                        "companyCode": "1000",
                        "text": "C01514 - UPL-ANK1-BATCHELOR ACCOMODATION"
                    },
                    {
                        "value": "C01515",
                        "companyCode": "1000",
                        "text": "C01515 - UPL-ANK1-HOUSING COLONY - 1"
                    },
                    {
                        "value": "C01516",
                        "companyCode": "1000",
                        "text": "C01516 - UPL-ANK1-HOUSING COLONY - 2"
                    },
                    {
                        "value": "C01517",
                        "companyCode": "1000",
                        "text": "C01517 - UPL-ANK1-ENVIRONMENT"
                    },
                    {
                        "value": "C01520",
                        "companyCode": "1000",
                        "text": "C01520 - UPL-ANK1-FACTORY MANAGEMENT"
                    },
                    {
                        "value": "C01521",
                        "companyCode": "1000",
                        "text": "C01521 - UPL-ANK1-HOUSEKEEPING"
                    },
                    {
                        "value": "C01523",
                        "companyCode": "1000",
                        "text": "C01523 - UPL-ANK1-CORPORATE SOCIAL RESPONSIBILITY"
                    },
                    {
                        "value": "C01524",
                        "companyCode": "1000",
                        "text": "C01524 - ."
                    },
                    {
                        "value": "C01525",
                        "companyCode": "1000",
                        "text": "C01525 - Manufacturing Management ANK1"
                    },
                    {
                        "value": "C01601",
                        "companyCode": "1000",
                        "text": "C01601 - UPL-ANK1-STANDSTILL & ELIMINATION COST"
                    },
                    {
                        "value": "C01602",
                        "companyCode": "1000",
                        "text": "C01602 - UPL-ANK1-FINISHED GOODS STORES"
                    },
                    {
                        "value": "C01603",
                        "companyCode": "1000",
                        "text": "C01603 - UPL-ANK1-PROJECT PLANNING/TECHNICAL"
                    },
                    {
                        "value": "C01613",
                        "companyCode": "1000",
                        "text": "C01613 - UPL-ANK1-EQUIPMENT YARD"
                    },
                    {
                        "value": "C02101",
                        "companyCode": "1000",
                        "text": "C02101 - UPL-ANK2-DEVRINOL TECH"
                    },
                    {
                        "value": "C02102",
                        "companyCode": "1000",
                        "text": "C02102 - UPL-ANK2-Clomazone"
                    },
                    {
                        "value": "C02103",
                        "companyCode": "1000",
                        "text": "C02103 - UPL-ANK2-ASULAM"
                    },
                    {
                        "value": "C02104",
                        "companyCode": "1000",
                        "text": "C02104 - UPL-ANK2-Terbufos"
                    },
                    {
                        "value": "C02105",
                        "companyCode": "1000",
                        "text": "C02105 - UPL-ANK2-DETA"
                    },
                    {
                        "value": "C02106",
                        "companyCode": "1000",
                        "text": "C02106 - UPL-ANK2-ZnDTP"
                    },
                    {
                        "value": "C02107",
                        "companyCode": "1000",
                        "text": "C02107 - UPL-ANK2-BIFENTHRIN"
                    },
                    {
                        "value": "C02108",
                        "companyCode": "1000",
                        "text": "C02108 - UPL-ANK2-ACEPHATE"
                    },
                    {
                        "value": "C02109",
                        "companyCode": "1000",
                        "text": "C02109 - UPL-ANK2-ZDDP"
                    },
                    {
                        "value": "C02110",
                        "companyCode": "1000",
                        "text": "C02110 - UPL-ANK2-METHYL CHLORIDE PLANT"
                    },
                    {
                        "value": "C02111",
                        "companyCode": "1000",
                        "text": "C02111 - UPL-ANK2-Ammonium Acetate Treatment"
                    },
                    {
                        "value": "C02201",
                        "companyCode": "1000",
                        "text": "C02201 - UPL-ANK2-POWER"
                    },
                    {
                        "value": "C02202",
                        "companyCode": "1000",
                        "text": "C02202 - UPL-ANK2-WATER"
                    },
                    {
                        "value": "C02203",
                        "companyCode": "1000",
                        "text": "C02203 - UPL-ANK2-STEAM"
                    },
                    {
                        "value": "C02204",
                        "companyCode": "1000",
                        "text": "C02204 - UPL-ANK2-COOLING WATER"
                    },
                    {
                        "value": "C02205",
                        "companyCode": "1000",
                        "text": "C02205 - UPL-ANK2-D G HOUSE"
                    },
                    {
                        "value": "C02206",
                        "companyCode": "1000",
                        "text": "C02206 - UPL-ANK2-NITROGEN"
                    },
                    {
                        "value": "C02207",
                        "companyCode": "1000",
                        "text": "C02207 - UPL-ANK2-CHILLED WATER"
                    },
                    {
                        "value": "C02208",
                        "companyCode": "1000",
                        "text": "C02208 - UPL-ANK2-BOILER (STEAM PRODUCTION)"
                    },
                    {
                        "value": "C02209",
                        "companyCode": "1000",
                        "text": "C02209 - UPL-ANK2-COMPRESSED AIR"
                    },
                    {
                        "value": "C02301",
                        "companyCode": "1000",
                        "text": "C02301 - UPL-ANK2-ENGINEERING - MECHANICAL"
                    },
                    {
                        "value": "C02302",
                        "companyCode": "1000",
                        "text": "C02302 - UPL-ANK2-ENGINEERING - ELECTRICAL"
                    },
                    {
                        "value": "C02303",
                        "companyCode": "1000",
                        "text": "C02303 - UPL-ANK2-ENGINEERING - INSTRUMENTATION"
                    },
                    {
                        "value": "C02304",
                        "companyCode": "1000",
                        "text": "C02304 - UPL-ANK2-ENGINEERING - CIVIL"
                    },
                    {
                        "value": "C02403",
                        "companyCode": "1000",
                        "text": "C02403 - UPL-ANK2-MATERIAL MGMT / STORES"
                    },
                    {
                        "value": "C02404",
                        "companyCode": "1000",
                        "text": "C02404 - UPL-ANK2-COMMERCIAL"
                    },
                    {
                        "value": "C02501",
                        "companyCode": "1000",
                        "text": "C02501 - UPL-ANK2-ADMINISTRATION"
                    },
                    {
                        "value": "C02502",
                        "companyCode": "1000",
                        "text": "C02502 - UPL-ANK2-SECURITY"
                    },
                    {
                        "value": "C02503",
                        "companyCode": "1000",
                        "text": "C02503 - UPL-ANK2-FACTORY PERSONNEL DEPT"
                    },
                    {
                        "value": "C02505",
                        "companyCode": "1000",
                        "text": "C02505 - UPL-ANK2-INFORMATION TECHNOLOGY"
                    },
                    {
                        "value": "C02506",
                        "companyCode": "1000",
                        "text": "C02506 - UPL-ANK2-CANTEEN + GEN WELFARE"
                    },
                    {
                        "value": "C02507",
                        "companyCode": "1000",
                        "text": "C02507 - UPL-ANK2-QUALITY CONTROL LABORATORY"
                    },
                    {
                        "value": "C02508",
                        "companyCode": "1000",
                        "text": "C02508 - UPL-ANK2-SAFETY DEPT"
                    },
                    {
                        "value": "C02510",
                        "companyCode": "1000",
                        "text": "C02510 - UPL-ANK2-MAXPRO EXPENSES"
                    },
                    {
                        "value": "C02511",
                        "companyCode": "1000",
                        "text": "C02511 - UPL-ANK2-EFFLUENT TREATMENT PLANT"
                    },
                    {
                        "value": "C02512",
                        "companyCode": "1000",
                        "text": "C02512 - UPL-ANK2-INCINERATOR"
                    },
                    {
                        "value": "C02521",
                        "companyCode": "1000",
                        "text": "C02521 - UPL-ANK2-CHEMICAL HOUSE"
                    },
                    {
                        "value": "C02522",
                        "companyCode": "1000",
                        "text": "C02522 - UPL-ANK2-HOUSEKEEPING"
                    },
                    {
                        "value": "C02523",
                        "companyCode": "1000",
                        "text": "C02523 - UPL-ANK2-CORPORATE SOCIAL RESPONSIBILITY"
                    },
                    {
                        "value": "C02524",
                        "companyCode": "1000",
                        "text": "C02524 - ."
                    },
                    {
                        "value": "C02525",
                        "companyCode": "1000",
                        "text": "C02525 - Manufacturing Management ANK2"
                    },
                    {
                        "value": "C02601",
                        "companyCode": "1000",
                        "text": "C02601 - UPL-ANK2-STANDSTILL & ELIMINATION COST"
                    },
                    {
                        "value": "C02602",
                        "companyCode": "1000",
                        "text": "C02602 - UPL-ANK2-FINISHED GOODS STORES"
                    },
                    {
                        "value": "C02603",
                        "companyCode": "1000",
                        "text": "C02603 - UPL-ANK3-BLOCKED"
                    },
                    {
                        "value": "C03101",
                        "companyCode": "1000",
                        "text": "C03101 - UPL-ANK3-Liquid EC / SL"
                    },
                    {
                        "value": "C03102",
                        "companyCode": "1000",
                        "text": "C03102 - UPL-ANK3-BATTUS GOLD"
                    },
                    {
                        "value": "C03103",
                        "companyCode": "1000",
                        "text": "C03103 - UPL-ANK3-Main Pilot Plant"
                    },
                    {
                        "value": "C03104",
                        "companyCode": "1000",
                        "text": "C03104 - UPL-ANK3-EROS GOLD"
                    },
                    {
                        "value": "C03105",
                        "companyCode": "1000",
                        "text": "C03105 - UPL-ANK3- Spray Dryer 10 TPD"
                    },
                    {
                        "value": "C03106",
                        "companyCode": "1000",
                        "text": "C03106 - Liquid CS"
                    },
                    {
                        "value": "C03107",
                        "companyCode": "1000",
                        "text": "C03107 - Liquid SC"
                    },
                    {
                        "value": "C03108",
                        "companyCode": "1000",
                        "text": "C03108 - Manual Packing / Repacking"
                    },
                    {
                        "value": "C03109",
                        "companyCode": "1000",
                        "text": "C03109 - UPL-ANK3-WDG 10 TPD"
                    },
                    {
                        "value": "C03110",
                        "companyCode": "1000",
                        "text": "C03110 - UPL-ANK3-WDG 2 TPD"
                    },
                    {
                        "value": "C03111",
                        "companyCode": "1000",
                        "text": "C03111 - UPL-ANK3-Acephate 40 TPD"
                    },
                    {
                        "value": "C03112",
                        "companyCode": "1000",
                        "text": "C03112 - UPL-ANK3-Pendi+PSE"
                    },
                    {
                        "value": "C03201",
                        "companyCode": "1000",
                        "text": "C03201 - UPL-ANK3-POWER"
                    },
                    {
                        "value": "C03203",
                        "companyCode": "1000",
                        "text": "C03203 - UPL-ANK3-STEAM"
                    },
                    {
                        "value": "C03205",
                        "companyCode": "1000",
                        "text": "C03205 - UPL-ANK3-D G HOUSE"
                    },
                    {
                        "value": "C03301",
                        "companyCode": "1000",
                        "text": "C03301 - UPL-ANK3-ENGINEERING - MECHANICAL"
                    },
                    {
                        "value": "C03303",
                        "companyCode": "1000",
                        "text": "C03303 - UPL-ANK3-ENGINEERING - INSTRUMENTATION"
                    },
                    {
                        "value": "C03304",
                        "companyCode": "1000",
                        "text": "C03304 - UPL-ANK3-ENGINEERING - CIVIL"
                    },
                    {
                        "value": "C03403",
                        "companyCode": "1000",
                        "text": "C03403 - UPL-ANK3-MATERIAL MGMT / STORES"
                    },
                    {
                        "value": "C03404",
                        "companyCode": "1000",
                        "text": "C03404 - UPL-ANK3-COMMERCIAL"
                    },
                    {
                        "value": "C03501",
                        "companyCode": "1000",
                        "text": "C03501 - UPL-ANK3-ADMINISTRATION"
                    },
                    {
                        "value": "C03502",
                        "companyCode": "1000",
                        "text": "C03502 - UPL-ANK3-SECURITY"
                    },
                    {
                        "value": "C03503",
                        "companyCode": "1000",
                        "text": "C03503 - UPL-ANK3-FACTORY PERSONNEL DEPT"
                    },
                    {
                        "value": "C03505",
                        "companyCode": "1000",
                        "text": "C03505 - UPL-ANK3-INFORMATION TECHNOLOGY"
                    },
                    {
                        "value": "C03506",
                        "companyCode": "1000",
                        "text": "C03506 - UPL-ANK3-CANTEEN + GEN WELFARE"
                    },
                    {
                        "value": "C03507",
                        "companyCode": "1000",
                        "text": "C03507 - UPL-ANK3-QUALITY CONTROL LABORATORY"
                    },
                    {
                        "value": "C03508",
                        "companyCode": "1000",
                        "text": "C03508 - UPL-ANK3-SAFETY DEPT"
                    },
                    {
                        "value": "C03510",
                        "companyCode": "1000",
                        "text": "C03510 - UPL-ANK3-MAXPRO EXPENSES"
                    },
                    {
                        "value": "C03511",
                        "companyCode": "1000",
                        "text": "C03511 - UPL-ANK3-PILOT PLANT EXPENSES"
                    },
                    {
                        "value": "C03512",
                        "companyCode": "1000",
                        "text": "C03512 - UPL-ANK3-VIRAL FILAMENTS"
                    },
                    {
                        "value": "C03513",
                        "companyCode": "1000",
                        "text": "C03513 - UPL-ANK3-EXTERNAL SUPPORTS"
                    },
                    {
                        "value": "C03514",
                        "companyCode": "1000",
                        "text": "C03514 - UPL-ANK3-CONTRACT MANUFACTURING"
                    },
                    {
                        "value": "C03523",
                        "companyCode": "1000",
                        "text": "C03523 - UPL-ANK3-CORPORATE SOCIAL RESPONSIBILITY"
                    },
                    {
                        "value": "C03524",
                        "companyCode": "1000",
                        "text": "C03524 - ."
                    },
                    {
                        "value": "C03525",
                        "companyCode": "1000",
                        "text": "C03525 - Manufacturing Management ANK3"
                    },
                    {
                        "value": "C03601",
                        "companyCode": "1000",
                        "text": "C03601 - UPL-ANK3-STANDSTILL & ELIMINATION COST"
                    },
                    {
                        "value": "C03602",
                        "companyCode": "1000",
                        "text": "C03602 - UPL-ANK3-FINISHED GOODS STORES"
                    },
                    {
                        "value": "C03603",
                        "companyCode": "1000",
                        "text": "C03603 - UPL-ANK3-PROJECT PLANNING/TECHNICAL"
                    },
                    {
                        "value": "C03613",
                        "companyCode": "1000",
                        "text": "C03613 - UPL-ANK3-RESEARCH & DEVELOPMENT- A3 FORM"
                    },
                    {
                        "value": "C03614",
                        "companyCode": "1000",
                        "text": "C03614 - UPL-ANK3-PACKAGING DEVELOPMENT"
                    },
                    {
                        "value": "C03615",
                        "companyCode": "1000",
                        "text": "C03615 - UPL-ARY-PRODUCTION"
                    },
                    {
                        "value": "C04101",
                        "companyCode": "1000",
                        "text": "C04101 - UPL-HALOL-ISOSYANATES PLANT"
                    },
                    {
                        "value": "C04102",
                        "companyCode": "1000",
                        "text": "C04102 - UPL-HALOL-PILOT PLANT"
                    },
                    {
                        "value": "C04103",
                        "companyCode": "1000",
                        "text": "C04103 - UPL-HALOL-ATABRON [IKI 7899 FORMULATION]"
                    },
                    {
                        "value": "C04104",
                        "companyCode": "1000",
                        "text": "C04104 - UPL-HALOL-ICY Parallel Products"
                    },
                    {
                        "value": "C04201",
                        "companyCode": "1000",
                        "text": "C04201 - UPL-HALOL-POWER"
                    },
                    {
                        "value": "C04202",
                        "companyCode": "1000",
                        "text": "C04202 - UPL-HALOL-WATER"
                    },
                    {
                        "value": "C04203",
                        "companyCode": "1000",
                        "text": "C04203 - UPL-HALOL-STEAM"
                    },
                    {
                        "value": "C04204",
                        "companyCode": "1000",
                        "text": "C04204 - UPL-HALOL-COOLING WATER"
                    },
                    {
                        "value": "C04205",
                        "companyCode": "1000",
                        "text": "C04205 - UPL-HALOL-D G HOUSE"
                    },
                    {
                        "value": "C04207",
                        "companyCode": "1000",
                        "text": "C04207 - UPL-HALOL-CHILLED WATER"
                    },
                    {
                        "value": "C04208",
                        "companyCode": "1000",
                        "text": "C04208 - UPL-HALOL-BOILER (STEAM PRODUCTION)"
                    },
                    {
                        "value": "C04209",
                        "companyCode": "1000",
                        "text": "C04209 - UPL-HALOL-COMPRESSED AIR"
                    },
                    {
                        "value": "C04301",
                        "companyCode": "1000",
                        "text": "C04301 - UPL-HALOL-ENGINEERING - MECHANICAL"
                    },
                    {
                        "value": "C04302",
                        "companyCode": "1000",
                        "text": "C04302 - UPL-HALOL-ENGINEERING - ELECTRICAL"
                    },
                    {
                        "value": "C04303",
                        "companyCode": "1000",
                        "text": "C04303 - UPL-HALOL-ENGINEERING - INSTRUMENTATION"
                    },
                    {
                        "value": "C04304",
                        "companyCode": "1000",
                        "text": "C04304 - UPL-HALOL-ENGINEERING - CIVIL"
                    },
                    {
                        "value": "C04401",
                        "companyCode": "1000",
                        "text": "C04401 - UPL-HALOL-FACTORY ACCOUNTS"
                    },
                    {
                        "value": "C04403",
                        "companyCode": "1000",
                        "text": "C04403 - UPL-HALOL-MATERIAL MGMT / STORES"
                    },
                    {
                        "value": "C04501",
                        "companyCode": "1000",
                        "text": "C04501 - UPL-HALOL-ADMINISTRATION"
                    },
                    {
                        "value": "C04502",
                        "companyCode": "1000",
                        "text": "C04502 - UPL-HALOL-SECURITY"
                    },
                    {
                        "value": "C04503",
                        "companyCode": "1000",
                        "text": "C04503 - UPL-HALOL-FACTORY PERSONNEL DEPT"
                    },
                    {
                        "value": "C04505",
                        "companyCode": "1000",
                        "text": "C04505 - UPL-HALOL-INFORMATION TECHNOLOGY"
                    },
                    {
                        "value": "C04506",
                        "companyCode": "1000",
                        "text": "C04506 - UPL-HALOL-CANTEEN + GEN WELFARE"
                    },
                    {
                        "value": "C04507",
                        "companyCode": "1000",
                        "text": "C04507 - UPL-HALOL-QUALITY CONTROL LABORATORY"
                    },
                    {
                        "value": "C04508",
                        "companyCode": "1000",
                        "text": "C04508 - UPL-HALOL-SAFETY DEPARTMENT"
                    },
                    {
                        "value": "C04509",
                        "companyCode": "1000",
                        "text": "C04509 - UPL-HALOL-RESEARCH & DEVELOPMENT"
                    },
                    {
                        "value": "C04511",
                        "companyCode": "1000",
                        "text": "C04511 - UPL-HALOL-EFFLUENT TREATMENT PLANT"
                    },
                    {
                        "value": "C04523",
                        "companyCode": "1000",
                        "text": "C04523 - UPL-HALOL-CORPORATE SOCIAL RESPONSIBILIT"
                    },
                    {
                        "value": "C04524",
                        "companyCode": "1000",
                        "text": "C04524 - ."
                    },
                    {
                        "value": "C04525",
                        "companyCode": "1000",
                        "text": "C04525 - Manufacturing Management Halol"
                    },
                    {
                        "value": "C04601",
                        "companyCode": "1000",
                        "text": "C04601 - UPL-HALOL-STANDSTILL & ELIMINATION COST"
                    },
                    {
                        "value": "C04602",
                        "companyCode": "1000",
                        "text": "C04602 - UPL-HALOL-FINISHED GOODS STORES (DESPATC"
                    },
                    {
                        "value": "C05101",
                        "companyCode": "1000",
                        "text": "C05101 - SCIL-JHA-CAUSTIC SODA LYE"
                    },
                    {
                        "value": "C05102",
                        "companyCode": "1000",
                        "text": "C05102 - SCIL-JHA-PCL 3 OWN PRODUCTION"
                    },
                    {
                        "value": "C05103",
                        "companyCode": "1000",
                        "text": "C05103 - SCIL-JHA-POCL 3 PRODUCTION"
                    },
                    {
                        "value": "C05104",
                        "companyCode": "1000",
                        "text": "C05104 - SCIL-JHA-TRI PHENYL PHOSPHITE (TPPI )"
                    },
                    {
                        "value": "C05105",
                        "companyCode": "1000",
                        "text": "C05105 - SCIL-JHA- DPMP"
                    },
                    {
                        "value": "C05106",
                        "companyCode": "1000",
                        "text": "C05106 - SCIL-JHA-WHITE PHOSPHORUS"
                    },
                    {
                        "value": "C05107",
                        "companyCode": "1000",
                        "text": "C05107 - SCIL-JHA-PCL5 PRODUCTION"
                    },
                    {
                        "value": "C05108",
                        "companyCode": "1000",
                        "text": "C05108 - SCIL-JHA-TTDP"
                    },
                    {
                        "value": "C05109",
                        "companyCode": "1000",
                        "text": "C05109 - SCIL-JHA-POWER"
                    },
                    {
                        "value": "C05110",
                        "companyCode": "1000",
                        "text": "C05110 - SCIL-JHA-NAX"
                    },
                    {
                        "value": "C05111",
                        "companyCode": "1000",
                        "text": "C05111 - SCIL-JHA-PNOX"
                    },
                    {
                        "value": "C05112",
                        "companyCode": "1000",
                        "text": "C05112 - SCIL-JHA - Mancozeb"
                    },
                    {
                        "value": "C05113",
                        "companyCode": "1000",
                        "text": "C05113 - SCIL-JHA -GLYPHOSATE"
                    },
                    {
                        "value": "C05114",
                        "companyCode": "1000",
                        "text": "C05114 - SCIL-JHA - CARBON DISULPHIDE"
                    },
                    {
                        "value": "C05115",
                        "companyCode": "1000",
                        "text": "C05115 - SCIL-JHA -ANTRACOL[EQ YARD]"
                    },
                    {
                        "value": "C05116",
                        "companyCode": "1000",
                        "text": "C05116 - SCIL-JHA -SULFENTRAZONE"
                    },
                    {
                        "value": "C05117",
                        "companyCode": "1000",
                        "text": "C05117 - SCIL-JHA -DMPAT 7000"
                    },
                    {
                        "value": "C05118",
                        "companyCode": "1000",
                        "text": "C05118 - SCIL-JHA -UPDT"
                    },
                    {
                        "value": "C05119",
                        "companyCode": "1000",
                        "text": "C05119 - SCIL-JHA -GF Plant 1"
                    },
                    {
                        "value": "C05120",
                        "companyCode": "1000",
                        "text": "C05120 - SCIL-JHA - Mancozeb WDG direct route"
                    },
                    {
                        "value": "C05121",
                        "companyCode": "1000",
                        "text": "C05121 - SCIL-JHA - PENDI5000"
                    },
                    {
                        "value": "C05122",
                        "companyCode": "1000",
                        "text": "C05122 - SCIL-JHA - ACROLIN"
                    },
                    {
                        "value": "C05123",
                        "companyCode": "1000",
                        "text": "C05123 - SCIL-JHA - TEP"
                    },
                    {
                        "value": "C05124",
                        "companyCode": "1000",
                        "text": "C05124 - SCIL-JHA -SODIUM HYDROSULPHIDE (Nash)"
                    },
                    {
                        "value": "C05125",
                        "companyCode": "1000",
                        "text": "C05125 - SCIL-JHA -S. METALOCHLOR"
                    },
                    {
                        "value": "C05126",
                        "companyCode": "1000",
                        "text": "C05126 - SCIL-JHA DMPAT 14000"
                    },
                    {
                        "value": "C05127",
                        "companyCode": "1000",
                        "text": "C05127 - SCIL-JHA GF Plant 2"
                    },
                    {
                        "value": "C05128",
                        "companyCode": "1000",
                        "text": "C05128 - SCIL-JHA GF Plant 3"
                    },
                    {
                        "value": "C05129",
                        "companyCode": "1000",
                        "text": "C05129 - SCIL-JHA OMEGA"
                    },
                    {
                        "value": "C05130",
                        "companyCode": "1000",
                        "text": "C05130 - SCIL-JHA MANCOZEB – WDG D/R – Phase 2"
                    },
                    {
                        "value": "C05131",
                        "companyCode": "1000",
                        "text": "C05131 - SCIL-JHA CM 257"
                    },
                    {
                        "value": "C05132",
                        "companyCode": "1000",
                        "text": "C05132 - SCIL-JHA-MR20000"
                    },
                    {
                        "value": "C05133",
                        "companyCode": "1000",
                        "text": "C05133 - SCIL-JHA-ALE400"
                    },
                    {
                        "value": "C05201",
                        "companyCode": "1000",
                        "text": "C05201 - SCIL-JHA-ELECTRICAL SUB STATION"
                    },
                    {
                        "value": "C05203",
                        "companyCode": "1000",
                        "text": "C05203 - SCIL-JHA-STEAM"
                    },
                    {
                        "value": "C05205",
                        "companyCode": "1000",
                        "text": "C05205 - SCIL-JHA-D G HOUSE"
                    },
                    {
                        "value": "C05208",
                        "companyCode": "1000",
                        "text": "C05208 - SCIL-JHA-BOILER (STEAM PRODUCTION)"
                    },
                    {
                        "value": "C05209",
                        "companyCode": "1000",
                        "text": "C05209 - SCIL-JHA-NITROGEN"
                    },
                    {
                        "value": "C05210",
                        "companyCode": "1000",
                        "text": "C05210 - SCIL-JHA-DM WATER PLANT"
                    },
                    {
                        "value": "C05211",
                        "companyCode": "1000",
                        "text": "C05211 - SCIL-JHA- U.G.WATER TANK"
                    },
                    {
                        "value": "C05212",
                        "companyCode": "1000",
                        "text": "C05212 - Enviornment Department"
                    },
                    {
                        "value": "C05301",
                        "companyCode": "1000",
                        "text": "C05301 - SCIL-JHA-ENGINEERING - MECHANICAL"
                    },
                    {
                        "value": "C05302",
                        "companyCode": "1000",
                        "text": "C05302 - SCIL-JHA-ENGINEERING - ELECTRICAL"
                    },
                    {
                        "value": "C05303",
                        "companyCode": "1000",
                        "text": "C05303 - SCIL-JHA-ENGINEERING - INSTRUMENTATION"
                    },
                    {
                        "value": "C05304",
                        "companyCode": "1000",
                        "text": "C05304 - SCIL-JHA-ENGINEERING - CIVIL"
                    },
                    {
                        "value": "C05401",
                        "companyCode": "1000",
                        "text": "C05401 - SCIL-JHA-FACTORY ACCOUNTS/MIS"
                    },
                    {
                        "value": "C05402",
                        "companyCode": "1000",
                        "text": "C05402 - SCIL-JHA-FACTORY PURCHASE"
                    },
                    {
                        "value": "C05403",
                        "companyCode": "1000",
                        "text": "C05403 - SCIL-JHA-MATERIAL MGMT / STORES"
                    },
                    {
                        "value": "C05501",
                        "companyCode": "1000",
                        "text": "C05501 - SCIL-JHA-ADMINISTRATION"
                    },
                    {
                        "value": "C05502",
                        "companyCode": "1000",
                        "text": "C05502 - SCIL-JHA-SECURITY DEPARTMENT"
                    },
                    {
                        "value": "C05503",
                        "companyCode": "1000",
                        "text": "C05503 - Enviornment Department"
                    },
                    {
                        "value": "C05505",
                        "companyCode": "1000",
                        "text": "C05505 - SCIL-JHA-INFORMATION TECHNOLOGY"
                    },
                    {
                        "value": "C05507",
                        "companyCode": "1000",
                        "text": "C05507 - SCIL-JHA-QUALITY ASSURANCE LABORATORY"
                    },
                    {
                        "value": "C05508",
                        "companyCode": "1000",
                        "text": "C05508 - SCIL-JHA-SAFETY DEPARTMENT"
                    },
                    {
                        "value": "C05509",
                        "companyCode": "1000",
                        "text": "C05509 - SCIL-JHA-RESEARCH & DEVELOPMENT"
                    },
                    {
                        "value": "C05510",
                        "companyCode": "1000",
                        "text": "C05510 - SCIL-JHA-MAXPRO"
                    },
                    {
                        "value": "C05511",
                        "companyCode": "1000",
                        "text": "C05511 - SCIL-JHA-EFFLUENT TREATMENT PLANT"
                    },
                    {
                        "value": "C05512",
                        "companyCode": "1000",
                        "text": "C05512 - SCIL-JHA-MR205 PILOT PLANT"
                    },
                    {
                        "value": "C05513",
                        "companyCode": "1000",
                        "text": "C05513 - SCIL-JHA-EDA PILOT PLANT"
                    },
                    {
                        "value": "C05514",
                        "companyCode": "1000",
                        "text": "C05514 - SCIL-JHA-HR"
                    },
                    {
                        "value": "C05520",
                        "companyCode": "1000",
                        "text": "C05520 - SCIL-JHA-FACTORY MANAGEMENT"
                    },
                    {
                        "value": "C05521",
                        "companyCode": "1000",
                        "text": "C05521 - SCIL-JHA-HOUSEKEEPING"
                    },
                    {
                        "value": "C05523",
                        "companyCode": "1000",
                        "text": "C05523 - UPL-JHA-CORPORATE SOCIAL RESPONSIBILITY"
                    },
                    {
                        "value": "C05524",
                        "companyCode": "1000",
                        "text": "C05524 - UPL-JHA-GREEN CELL"
                    },
                    {
                        "value": "C05525",
                        "companyCode": "1000",
                        "text": "C05525 - Manufacturing Management Jhagadia"
                    },
                    {
                        "value": "C05601",
                        "companyCode": "1000",
                        "text": "C05601 - UPL-JHA-STANDSTILL & ELIMINATION COST"
                    },
                    {
                        "value": "C05602",
                        "companyCode": "1000",
                        "text": "C05602 - SCIL-JHA-FINISHED GOODS STORES (DESPATCH"
                    },
                    {
                        "value": "C05603",
                        "companyCode": "1000",
                        "text": "C05603 - SCIL-JHA-PROJECT PLANNING/TECHNICAL"
                    },
                    {
                        "value": "C05612",
                        "companyCode": "1000",
                        "text": "C05612 - SCIL-JHA-GEB POWER SALES"
                    },
                    {
                        "value": "C05613",
                        "companyCode": "1000",
                        "text": "C05613 - SCIL-JHA-EQUIPMENT YARD"
                    },
                    {
                        "value": "C06101",
                        "companyCode": "1000",
                        "text": "C06101 - SCIL-VAPI-PHOSPHORUS PENTAL CHLORIDE"
                    },
                    {
                        "value": "C06102",
                        "companyCode": "1000",
                        "text": "C06102 - SCIL-VAPI-HEDP"
                    },
                    {
                        "value": "C06103",
                        "companyCode": "1000",
                        "text": "C06103 - SCIL-VAPI-DENATONIUM BENZOAT -U GUARD"
                    },
                    {
                        "value": "C06104",
                        "companyCode": "1000",
                        "text": "C06104 - SCIL-VAPI-DENATONIUM SACCHARIDE-AMEREX"
                    },
                    {
                        "value": "C06201",
                        "companyCode": "1000",
                        "text": "C06201 - SCIL-VAPI-POWER"
                    },
                    {
                        "value": "C06202",
                        "companyCode": "1000",
                        "text": "C06202 - SCIL-VAPI-WATER"
                    },
                    {
                        "value": "C06203",
                        "companyCode": "1000",
                        "text": "C06203 - SCIL-VAPI-STEAM"
                    },
                    {
                        "value": "C06205",
                        "companyCode": "1000",
                        "text": "C06205 - SCIL-VAPI-D G HOUSE"
                    },
                    {
                        "value": "C06206",
                        "companyCode": "1000",
                        "text": "C06206 - SCIL-VAPI-UTILITIES"
                    },
                    {
                        "value": "C06208",
                        "companyCode": "1000",
                        "text": "C06208 - SCIL-VAPI-BOILER (STEAM PRODUCTION)"
                    },
                    {
                        "value": "C06212",
                        "companyCode": "1000",
                        "text": "C06212 - SCIL-VAPI-TRIPLE EFFECT EVAPORATOR"
                    },
                    {
                        "value": "C06301",
                        "companyCode": "1000",
                        "text": "C06301 - SCIL-VAPI-ENGINEERING - MECHANICAL"
                    },
                    {
                        "value": "C06302",
                        "companyCode": "1000",
                        "text": "C06302 - SCIL-VAPI-ENGINEERING - ELECTRICAL"
                    },
                    {
                        "value": "C06303",
                        "companyCode": "1000",
                        "text": "C06303 - SCIL-VAPI-ENGINEERING - INSTRUMENTATION"
                    },
                    {
                        "value": "C06304",
                        "companyCode": "1000",
                        "text": "C06304 - SCIL-VAPI-ENGINEERING - CIVIL"
                    },
                    {
                        "value": "C06401",
                        "companyCode": "1000",
                        "text": "C06401 - SCIL-VAPI-FACTORY ACCOUNTS/MIS"
                    },
                    {
                        "value": "C06403",
                        "companyCode": "1000",
                        "text": "C06403 - SCIL-VAPI-MATERIAL MGMT / STORES"
                    },
                    {
                        "value": "C06501",
                        "companyCode": "1000",
                        "text": "C06501 - SCIL-VAPI-ADMINISTRATION"
                    },
                    {
                        "value": "C06507",
                        "companyCode": "1000",
                        "text": "C06507 - SCIL-VAPI-QUALITY CONTROL LABORATORY"
                    },
                    {
                        "value": "C06508",
                        "companyCode": "1000",
                        "text": "C06508 - SCIL-VAPI-SAFETY DEPT"
                    },
                    {
                        "value": "C06511",
                        "companyCode": "1000",
                        "text": "C06511 - SCIL-VAPI-EFFLUENT TREATMENT PLANT"
                    },
                    {
                        "value": "C07101",
                        "companyCode": "1000",
                        "text": "C07101 - SCIL-VAPI-PHOSPHORUS OXYCHLORIDE"
                    },
                    {
                        "value": "C07102",
                        "companyCode": "1000",
                        "text": "C07102 - SCIL-VAPI-BOILER PRODUCTION COST CENTER"
                    },
                    {
                        "value": "C07201",
                        "companyCode": "1000",
                        "text": "C07201 - SCIL-VAPI-II-POWER"
                    },
                    {
                        "value": "C07202",
                        "companyCode": "1000",
                        "text": "C07202 - SCIL-VAPI-II-WATER"
                    },
                    {
                        "value": "C07203",
                        "companyCode": "1000",
                        "text": "C07203 - SCIL-VAPI-II-STEAM"
                    },
                    {
                        "value": "C07501",
                        "companyCode": "1000",
                        "text": "C07501 - SCIL-VAPI-II-ADMINISTRATION"
                    },
                    {
                        "value": "C07511",
                        "companyCode": "1000",
                        "text": "C07511 - SCIL-VAPI-2-ETP"
                    },
                    {
                        "value": "C08101",
                        "companyCode": "1000",
                        "text": "C08101 - UPL-JAMMU - FORMULATION"
                    },
                    {
                        "value": "C08201",
                        "companyCode": "1000",
                        "text": "C08201 - UPL-JAMMU-POWER"
                    },
                    {
                        "value": "C08203",
                        "companyCode": "1000",
                        "text": "C08203 - UPL-JAMMU-STEAM"
                    },
                    {
                        "value": "C08205",
                        "companyCode": "1000",
                        "text": "C08205 - UPL-JAMMU-D G HOUSE"
                    },
                    {
                        "value": "C08301",
                        "companyCode": "1000",
                        "text": "C08301 - UPL-JAMMU-ENGINEERING - MECHANICAL"
                    },
                    {
                        "value": "C08302",
                        "companyCode": "1000",
                        "text": "C08302 - UPL-JAMMU-ENG -ELECTRICAL"
                    },
                    {
                        "value": "C08303",
                        "companyCode": "1000",
                        "text": "C08303 - UPL-JAMMU-ENGINEERING - INSTRUMENTATION"
                    },
                    {
                        "value": "C08304",
                        "companyCode": "1000",
                        "text": "C08304 - UPL-JAMMU-ENGINEERING - CIVIL"
                    },
                    {
                        "value": "C08401",
                        "companyCode": "1000",
                        "text": "C08401 - UPL-JAMMU-ACCOUNTS"
                    },
                    {
                        "value": "C08403",
                        "companyCode": "1000",
                        "text": "C08403 - UPL-JAMMU-MATERIAL MGMT / STORES"
                    },
                    {
                        "value": "C08404",
                        "companyCode": "1000",
                        "text": "C08404 - UPL-JAMMU-COMMERCIAL"
                    },
                    {
                        "value": "C08501",
                        "companyCode": "1000",
                        "text": "C08501 - UPL-JAMMU-ADMINISTRATION"
                    },
                    {
                        "value": "C08502",
                        "companyCode": "1000",
                        "text": "C08502 - UPL-JAMMU-SECURITY"
                    },
                    {
                        "value": "C08503",
                        "companyCode": "1000",
                        "text": "C08503 - UPL-JAMMU-FACTORY PERSONNEL DEPT"
                    },
                    {
                        "value": "C08505",
                        "companyCode": "1000",
                        "text": "C08505 - UPL-JAMMU-INFORMATION TECHNOLOGY"
                    },
                    {
                        "value": "C08506",
                        "companyCode": "1000",
                        "text": "C08506 - UPL-JAMMU-CANTEEN + GEN WELFARE"
                    },
                    {
                        "value": "C08507",
                        "companyCode": "1000",
                        "text": "C08507 - UPL-JAMMU-QUALITY CONTROL LABORATORY"
                    },
                    {
                        "value": "C08508",
                        "companyCode": "1000",
                        "text": "C08508 - UPL-JAMMU-SAFETY DEPT"
                    },
                    {
                        "value": "C08513",
                        "companyCode": "1000",
                        "text": "C08513 - UPL-JAMMU-GUEST HOUSE"
                    },
                    {
                        "value": "C08523",
                        "companyCode": "1000",
                        "text": "C08523 - UPL-JAMMU-CORPORATE SOCIAL RESPONSIBILIT"
                    },
                    {
                        "value": "C08524",
                        "companyCode": "1000",
                        "text": "C08524 - ."
                    },
                    {
                        "value": "C08525",
                        "companyCode": "1000",
                        "text": "C08525 - Manufacturing Management Jammu"
                    },
                    {
                        "value": "C08601",
                        "companyCode": "1000",
                        "text": "C08601 - UPL-JAMMU-STANDSTILL & ELIMINATION COST"
                    },
                    {
                        "value": "C08602",
                        "companyCode": "1000",
                        "text": "C08602 - UPL-JAMMU-FINISHED GOODS STORES"
                    },
                    {
                        "value": "C08613",
                        "companyCode": "1000",
                        "text": "C08613 - UPL-JAMMU-RESEARCH & DEVEL - JAMMU FORM"
                    },
                    {
                        "value": "C09101",
                        "companyCode": "1000",
                        "text": "C09101 - HALDIA-TECHNICAL"
                    },
                    {
                        "value": "C09102",
                        "companyCode": "1000",
                        "text": "C09102 - HALDIA-SOLID/ACEPHATE FORMULATION"
                    },
                    {
                        "value": "C09103",
                        "companyCode": "1000",
                        "text": "C09103 - SW-HALDIA-LQ. FORM"
                    },
                    {
                        "value": "C09104",
                        "companyCode": "1000",
                        "text": "C09104 - HALDIA-ASULAM TECH"
                    },
                    {
                        "value": "C09201",
                        "companyCode": "1000",
                        "text": "C09201 - HALDIA-POWER"
                    },
                    {
                        "value": "C09202",
                        "companyCode": "1000",
                        "text": "C09202 - HALDIA-BOILER"
                    },
                    {
                        "value": "C09203",
                        "companyCode": "1000",
                        "text": "C09203 - HALDIA-REFRIGERATION"
                    },
                    {
                        "value": "C09204",
                        "companyCode": "1000",
                        "text": "C09204 - HAL-COOLING TOWER"
                    },
                    {
                        "value": "C09205",
                        "companyCode": "1000",
                        "text": "C09205 - HALDIA-DG SET"
                    },
                    {
                        "value": "C09206",
                        "companyCode": "1000",
                        "text": "C09206 - HALDIA-EFFLUENT TREATMENT PLANT"
                    },
                    {
                        "value": "C09301",
                        "companyCode": "1000",
                        "text": "C09301 - HALDIA-MAINTENANCE"
                    },
                    {
                        "value": "C09401",
                        "companyCode": "1000",
                        "text": "C09401 - HALDIA-ACCOUNTS"
                    },
                    {
                        "value": "C09402",
                        "companyCode": "1000",
                        "text": "C09402 - HALDIA-EXCISE"
                    },
                    {
                        "value": "C09403",
                        "companyCode": "1000",
                        "text": "C09403 - HALDIA-STORES"
                    },
                    {
                        "value": "C09404",
                        "companyCode": "1000",
                        "text": "C09404 - HALDIA-PURCHASE"
                    },
                    {
                        "value": "C09501",
                        "companyCode": "1000",
                        "text": "C09501 - SWAL-HALDIA-ADMIN"
                    },
                    {
                        "value": "C09502",
                        "companyCode": "1000",
                        "text": "C09502 - HALDIA-FACTORY MANAGEMENT"
                    },
                    {
                        "value": "C09503",
                        "companyCode": "1000",
                        "text": "C09503 - HALDIA-LABORATORY"
                    },
                    {
                        "value": "C09504",
                        "companyCode": "1000",
                        "text": "C09504 - HALDIA-TOWNSHIP - RESIDENTIAL COMPL"
                    },
                    {
                        "value": "C09505",
                        "companyCode": "1000",
                        "text": "C09505 - HALDIA-GUEST HOUSE"
                    },
                    {
                        "value": "C09506",
                        "companyCode": "1000",
                        "text": "C09506 - HALDIA-SAFETY & ENVIRONMENT"
                    },
                    {
                        "value": "C09507",
                        "companyCode": "1000",
                        "text": "C09507 - HALDIA-WATER TREATMENT PLANT"
                    },
                    {
                        "value": "C09508",
                        "companyCode": "1000",
                        "text": "C09508 - HALDIA-STANDSTILL"
                    },
                    {
                        "value": "C09509",
                        "companyCode": "1000",
                        "text": "C09509 - SWAL-HALDIA-MERGING WITH UPL"
                    },
                    {
                        "value": "C09523",
                        "companyCode": "1000",
                        "text": "C09523 - HALDIA-CORPORATE SOCIAL RESPONSIBILITY"
                    },
                    {
                        "value": "C09524",
                        "companyCode": "1000",
                        "text": "C09524 - ."
                    },
                    {
                        "value": "C09525",
                        "companyCode": "1000",
                        "text": "C09525 - Manufacturing Management Haldia"
                    },
                    {
                        "value": "C09601",
                        "companyCode": "1000",
                        "text": "C09601 - HALDIA-STANDSTILL & ELIMINATION COST"
                    },
                    {
                        "value": "C10101",
                        "companyCode": "1000",
                        "text": "C10101 - UPL-TARAPUR-TRIZANONE"
                    },
                    {
                        "value": "C10102",
                        "companyCode": "1000",
                        "text": "C10102 - UPL-TARAPUR-AMMONIUM SULPHATE"
                    },
                    {
                        "value": "C10201",
                        "companyCode": "1000",
                        "text": "C10201 - UPL-TARAPUR-POWER"
                    },
                    {
                        "value": "C10202",
                        "companyCode": "1000",
                        "text": "C10202 - UPL-TARAPUR-WATER"
                    },
                    {
                        "value": "C10203",
                        "companyCode": "1000",
                        "text": "C10203 - UPL-TARAPUR-STEAM"
                    },
                    {
                        "value": "C10204",
                        "companyCode": "1000",
                        "text": "C10204 - UPL-TARAPUR-COOLING WATER"
                    },
                    {
                        "value": "C10205",
                        "companyCode": "1000",
                        "text": "C10205 - UPL-TARAPUR-D G HOUSE"
                    },
                    {
                        "value": "C10207",
                        "companyCode": "1000",
                        "text": "C10207 - UPL-TARAPUR-CHILLED WATER"
                    },
                    {
                        "value": "C10208",
                        "companyCode": "1000",
                        "text": "C10208 - UPL-TARAPUR-BOILER (STEAM PRODUCTION)"
                    },
                    {
                        "value": "C10209",
                        "companyCode": "1000",
                        "text": "C10209 - UPL-TARAPUR-COMPRESSED AIR"
                    },
                    {
                        "value": "C10301",
                        "companyCode": "1000",
                        "text": "C10301 - UPL-TARAPUR-ENGINEERING - MECHANICAL"
                    },
                    {
                        "value": "C10302",
                        "companyCode": "1000",
                        "text": "C10302 - UPL-TARAPUR-ENGINEERING - ELECTRICAL"
                    },
                    {
                        "value": "C10303",
                        "companyCode": "1000",
                        "text": "C10303 - UPL-TARAPUR-ENGINEERING-INSTRUMENTATION"
                    },
                    {
                        "value": "C10304",
                        "companyCode": "1000",
                        "text": "C10304 - UPL-TARAPUR-ENGINEERING - CIVIL"
                    },
                    {
                        "value": "C10401",
                        "companyCode": "1000",
                        "text": "C10401 - UPL-TARAPUR-FACTORY ACCOUNTS/MIS"
                    },
                    {
                        "value": "C10403",
                        "companyCode": "1000",
                        "text": "C10403 - UPL-TARAPUR-MATERIAL MGMT / STORES"
                    },
                    {
                        "value": "C10501",
                        "companyCode": "1000",
                        "text": "C10501 - UPL-TARAPUR-ADMINISTRATION"
                    },
                    {
                        "value": "C10502",
                        "companyCode": "1000",
                        "text": "C10502 - UPL-TARAPUR-SECURITY"
                    },
                    {
                        "value": "C10503",
                        "companyCode": "1000",
                        "text": "C10503 - UPL-TARAPUR-FACTORY PERSONNEL DEPT"
                    },
                    {
                        "value": "C10505",
                        "companyCode": "1000",
                        "text": "C10505 - UPL-TARAPUR-INFORMATION TECHNOLOGY"
                    },
                    {
                        "value": "C10506",
                        "companyCode": "1000",
                        "text": "C10506 - UPL-TARAPUR-CANTEEN + GEN WELFARE"
                    },
                    {
                        "value": "C10507",
                        "companyCode": "1000",
                        "text": "C10507 - UPL-TARAPUR-QUALITY CONTROL LABORATORY"
                    },
                    {
                        "value": "C10508",
                        "companyCode": "1000",
                        "text": "C10508 - UPL-TARAPUR-SAFETY DEPARTMENT"
                    },
                    {
                        "value": "C10509",
                        "companyCode": "1000",
                        "text": "C10509 - UPL-TARAPUR-RESEARCH & DEVELOPMENT"
                    },
                    {
                        "value": "C10511",
                        "companyCode": "1000",
                        "text": "C10511 - UPL-TARAPUR-EFFLUENT TREATMENT PLANT"
                    },
                    {
                        "value": "C10524",
                        "companyCode": "1000",
                        "text": "C10524 - ."
                    },
                    {
                        "value": "C10525",
                        "companyCode": "1000",
                        "text": "C10525 - Manufacturing Management Tarapur"
                    },
                    {
                        "value": "C10601",
                        "companyCode": "1000",
                        "text": "C10601 - UPL-TARAPUR-STANDSTILL &ELIMINATION COST"
                    },
                    {
                        "value": "C10602",
                        "companyCode": "1000",
                        "text": "C10602 - UPL-TARAPUR-FINISHED GOODS STORES"
                    },
                    {
                        "value": "C11101",
                        "companyCode": "1000",
                        "text": "C11101 - UPL-ANKPL11--ACEPHATE 97 DF"
                    },
                    {
                        "value": "C11102",
                        "companyCode": "1000",
                        "text": "C11102 - UPL-ANKPL11-Seed FS Plant"
                    },
                    {
                        "value": "C11103",
                        "companyCode": "1000",
                        "text": "C11103 - UPL-ANKPL11-Acemida"
                    },
                    {
                        "value": "C11104",
                        "companyCode": "1000",
                        "text": "C11104 - UPL-ANKPL11-Acenthrin"
                    },
                    {
                        "value": "C11201",
                        "companyCode": "1000",
                        "text": "C11201 - UPL-ANKPL11--POWER"
                    },
                    {
                        "value": "C11202",
                        "companyCode": "1000",
                        "text": "C11202 - UPL-ANKPL11--STEAM"
                    },
                    {
                        "value": "C11204",
                        "companyCode": "1000",
                        "text": "C11204 - UPL-ANKPL11-Common Utilities"
                    },
                    {
                        "value": "C11301",
                        "companyCode": "1000",
                        "text": "C11301 - UPL-ANKPL11--ENG-MECHANICAL"
                    },
                    {
                        "value": "C11401",
                        "companyCode": "1000",
                        "text": "C11401 - UPL-ANKPL11--COMMERCIAL"
                    },
                    {
                        "value": "C11402",
                        "companyCode": "1000",
                        "text": "C11402 - UPL-ANKPL11--STORES"
                    },
                    {
                        "value": "C11501",
                        "companyCode": "1000",
                        "text": "C11501 - UPL-ANKPL11-ADMINISTRATION"
                    },
                    {
                        "value": "C11524",
                        "companyCode": "1000",
                        "text": "C11524 - ."
                    },
                    {
                        "value": "C11525",
                        "companyCode": "1000",
                        "text": "C11525 - Manufacturing Management ANK11"
                    },
                    {
                        "value": "C11601",
                        "companyCode": "1000",
                        "text": "C11601 - UPL-ANKPL11-STANDSTILL & ELIMINA COST"
                    },
                    {
                        "value": "C11602",
                        "companyCode": "1000",
                        "text": "C11602 - UPL-ANK11-FINISHED GOODS STORES"
                    },
                    {
                        "value": "C12101",
                        "companyCode": "1000",
                        "text": "C12101 - UPL-PL12- Sodium Cynide"
                    },
                    {
                        "value": "C12102",
                        "companyCode": "1000",
                        "text": "C12102 - UPL-PL12- Sodium Ferro cyanide"
                    },
                    {
                        "value": "C12103",
                        "companyCode": "1000",
                        "text": "C12103 - UPL-PL12- PTC"
                    },
                    {
                        "value": "C12104",
                        "companyCode": "1000",
                        "text": "C12104 - UPL-PL12- HCN"
                    },
                    {
                        "value": "C12105",
                        "companyCode": "1000",
                        "text": "C12105 - UPL-PL12- Cyanuric Chloride"
                    },
                    {
                        "value": "C12106",
                        "companyCode": "1000",
                        "text": "C12106 - UPL-PL12- Phosgene"
                    },
                    {
                        "value": "C12107",
                        "companyCode": "1000",
                        "text": "C12107 - UPL-PL12- CAP-365"
                    },
                    {
                        "value": "C12108",
                        "companyCode": "1000",
                        "text": "C12108 - UPL-PL12- UPI-20"
                    },
                    {
                        "value": "C12201",
                        "companyCode": "1000",
                        "text": "C12201 - UPL-PL12-POWER"
                    },
                    {
                        "value": "C12202",
                        "companyCode": "1000",
                        "text": "C12202 - UPL-PL12-STEAM"
                    },
                    {
                        "value": "C12203",
                        "companyCode": "1000",
                        "text": "C12203 - UPL-PL12-Water"
                    },
                    {
                        "value": "C12301",
                        "companyCode": "1000",
                        "text": "C12301 - UPL-PL12-MECHANICAL"
                    },
                    {
                        "value": "C12302",
                        "companyCode": "1000",
                        "text": "C12302 - UPL-PL12-ELECTRICAL"
                    },
                    {
                        "value": "C12303",
                        "companyCode": "1000",
                        "text": "C12303 - UPL-PL12-INSTRUMENT"
                    },
                    {
                        "value": "C12304",
                        "companyCode": "1000",
                        "text": "C12304 - UPL-PL12-CIVIL"
                    },
                    {
                        "value": "C12401",
                        "companyCode": "1000",
                        "text": "C12401 - UPL-PL12-ACCOUNTS"
                    },
                    {
                        "value": "C12403",
                        "companyCode": "1000",
                        "text": "C12403 - UPL-PL12-STORES"
                    },
                    {
                        "value": "C12404",
                        "companyCode": "1000",
                        "text": "C12404 - UPL-PL12-COMMERCIAL"
                    },
                    {
                        "value": "C12501",
                        "companyCode": "1000",
                        "text": "C12501 - UPL-PL12-ADMIN"
                    },
                    {
                        "value": "C12502",
                        "companyCode": "1000",
                        "text": "C12502 - UPL-PL12-SECURITY"
                    },
                    {
                        "value": "C12503",
                        "companyCode": "1000",
                        "text": "C12503 - UPL-PL12-HR"
                    },
                    {
                        "value": "C12506",
                        "companyCode": "1000",
                        "text": "C12506 - UPL-PL12-GREEN CELL & ENERGY"
                    },
                    {
                        "value": "C12507",
                        "companyCode": "1000",
                        "text": "C12507 - UPL-PL12-QC LAB"
                    },
                    {
                        "value": "C12508",
                        "companyCode": "1000",
                        "text": "C12508 - UPL-PL12-SAFETY"
                    },
                    {
                        "value": "C12509",
                        "companyCode": "1000",
                        "text": "C12509 - UPL-PL12-RESEARCH & DEVELOPMENT"
                    },
                    {
                        "value": "C12510",
                        "companyCode": "1000",
                        "text": "C12510 - UPL-PL12-MAX PRO"
                    },
                    {
                        "value": "C12511",
                        "companyCode": "1000",
                        "text": "C12511 - UPL-PL12-ETP"
                    },
                    {
                        "value": "C12520",
                        "companyCode": "1000",
                        "text": "C12520 - UPL-PL12-Fact Mgmt"
                    },
                    {
                        "value": "C12521",
                        "companyCode": "1000",
                        "text": "C12521 - UPL-PL12-HOUSEKEEPING"
                    },
                    {
                        "value": "C12523",
                        "companyCode": "1000",
                        "text": "C12523 - UPL-PL12-CORPORATE SOCIAL RESPONSIBILITY"
                    },
                    {
                        "value": "C12525",
                        "companyCode": "1000",
                        "text": "C12525 - Manufacturing Management Dahej PL12"
                    },
                    {
                        "value": "C12601",
                        "companyCode": "1000",
                        "text": "C12601 - UPL-PL12-STANDSTILL"
                    },
                    {
                        "value": "C12602",
                        "companyCode": "1000",
                        "text": "C12602 - UPL-PL12-DESPATCH"
                    },
                    {
                        "value": "C12603",
                        "companyCode": "1000",
                        "text": "C12603 - UPL-DAHEJ-PROJECT PLANNING/TECHNICAL"
                    },
                    {
                        "value": "C13101",
                        "companyCode": "1000",
                        "text": "C13101 - UPL-PL13-WDG Plant"
                    },
                    {
                        "value": "C13102",
                        "companyCode": "1000",
                        "text": "C13102 - UPL-PL13-SPD"
                    },
                    {
                        "value": "C13201",
                        "companyCode": "1000",
                        "text": "C13201 - UPL-PL13-POWER"
                    },
                    {
                        "value": "C13301",
                        "companyCode": "1000",
                        "text": "C13301 - UPL-PL13-MECHANICAL"
                    },
                    {
                        "value": "C13401",
                        "companyCode": "1000",
                        "text": "C13401 - UPL-PL13-ACCOUNTS"
                    },
                    {
                        "value": "C13403",
                        "companyCode": "1000",
                        "text": "C13403 - UPL-PL13-STORES"
                    },
                    {
                        "value": "C13404",
                        "companyCode": "1000",
                        "text": "C13404 - UPL-PL13-COMMERCIAL"
                    },
                    {
                        "value": "C13501",
                        "companyCode": "1000",
                        "text": "C13501 - UPL-PL13-ADMIN"
                    },
                    {
                        "value": "C13502",
                        "companyCode": "1000",
                        "text": "C13502 - UPL-PL13-SECURITY"
                    },
                    {
                        "value": "C13503",
                        "companyCode": "1000",
                        "text": "C13503 - UPL-PL13-PERSONNEL"
                    },
                    {
                        "value": "C13506",
                        "companyCode": "1000",
                        "text": "C13506 - UPL-PL13-WELFARE & CANTEEN"
                    },
                    {
                        "value": "C13507",
                        "companyCode": "1000",
                        "text": "C13507 - UPL-PL13-QC LAB"
                    },
                    {
                        "value": "C13508",
                        "companyCode": "1000",
                        "text": "C13508 - UPL-PL13-SAFETY"
                    },
                    {
                        "value": "C13511",
                        "companyCode": "1000",
                        "text": "C13511 - UPL-PL13-ETP"
                    },
                    {
                        "value": "C13524",
                        "companyCode": "1000",
                        "text": "C13524 - ."
                    },
                    {
                        "value": "C13525",
                        "companyCode": "1000",
                        "text": "C13525 - Manufacturing Management Dahej PL13"
                    },
                    {
                        "value": "C13601",
                        "companyCode": "1000",
                        "text": "C13601 - UPL-PL13-STANDSTILL"
                    },
                    {
                        "value": "C13602",
                        "companyCode": "1000",
                        "text": "C13602 - UPL-PL13-DESPATCH"
                    },
                    {
                        "value": "C14101",
                        "companyCode": "1000",
                        "text": "C14101 - PL14-REPACKING"
                    },
                    {
                        "value": "C14404",
                        "companyCode": "1000",
                        "text": "C14404 - PL14-COMMERCIAL"
                    },
                    {
                        "value": "C14501",
                        "companyCode": "1000",
                        "text": "C14501 - PL14-ADMIN"
                    },
                    {
                        "value": "C14602",
                        "companyCode": "1000",
                        "text": "C14602 - PL14-DESPATCH"
                    },
                    {
                        "value": "C20101",
                        "companyCode": "1400",
                        "text": "C20101 - OPTIMA-JAMMU PRODUCTION"
                    },
                    {
                        "value": "C20301",
                        "companyCode": "1400",
                        "text": "C20301 - OPTIMA-JAMMU-ENGINEERING - MECHANICAL"
                    },
                    {
                        "value": "C20302",
                        "companyCode": "1400",
                        "text": "C20302 - OPTIMA-JAMMU-ENG -ELECTRICAL"
                    },
                    {
                        "value": "C20304",
                        "companyCode": "1400",
                        "text": "C20304 - OPTIMA-JAMMU-ENGINEERING - CIVIL"
                    },
                    {
                        "value": "C20401",
                        "companyCode": "1400",
                        "text": "C20401 - OPTIMAL-JAMMU-ACCOUNTS"
                    },
                    {
                        "value": "C20403",
                        "companyCode": "1400",
                        "text": "C20403 - OPTIMA-JAMMU-MATERIAL MGMT / STORES"
                    },
                    {
                        "value": "C20404",
                        "companyCode": "1400",
                        "text": "C20404 - OPTIMA-JAMMU-COMMERCIAL"
                    },
                    {
                        "value": "C20501",
                        "companyCode": "1400",
                        "text": "C20501 - OPTIMA-JAMMU-ADMINISTRATION"
                    },
                    {
                        "value": "C20502",
                        "companyCode": "1400",
                        "text": "C20502 - OPTIMA-JAMMU-SECURITY"
                    },
                    {
                        "value": "C20503",
                        "companyCode": "1400",
                        "text": "C20503 - OPTIMA-JAMMU-FACTORY PERSONNEL DEPT"
                    },
                    {
                        "value": "C20505",
                        "companyCode": "1400",
                        "text": "C20505 - OPTIMA-JAMMU-INFORMATION TECHNOLOGY"
                    },
                    {
                        "value": "C20507",
                        "companyCode": "1400",
                        "text": "C20507 - OPTIMA-JAMMU-QUALITY CONTROL LABORATORY"
                    },
                    {
                        "value": "C20508",
                        "companyCode": "1400",
                        "text": "C20508 - OPTIMA-JAMMU-SAFETY DEPT"
                    },
                    {
                        "value": "C20524",
                        "companyCode": "1400",
                        "text": "C20524 - ."
                    },
                    {
                        "value": "C20525",
                        "companyCode": "1400",
                        "text": "C20525 - Manufacturing Management Optima"
                    },
                    {
                        "value": "C20601",
                        "companyCode": "1400",
                        "text": "C20601 - OPTIMA-JAMMU-STANDSTILL & ELIMIN COST"
                    },
                    {
                        "value": "C20701",
                        "companyCode": "1400",
                        "text": "C20701 - UPL-MKTG-MARKETING - ATCA"
                    },
                    {
                        "value": "C20702",
                        "companyCode": "1400",
                        "text": "C20702 - UPL-MKTG-INDIA REGION AF"
                    },
                    {
                        "value": "C20703",
                        "companyCode": "1400",
                        "text": "C20703 - UPL-MKTG-Agro ZEBA & BIOLOGICAL"
                    },
                    {
                        "value": "C20704",
                        "companyCode": "1400",
                        "text": "C20704 - UPL-MKTG-MARKETING - AGRO"
                    },
                    {
                        "value": "C20705",
                        "companyCode": "1400",
                        "text": "C20705 - UPL-MKTG-AGRO-SBU1"
                    },
                    {
                        "value": "C20706",
                        "companyCode": "1400",
                        "text": "C20706 - UPL-MKTG-AGRO-SBU4"
                    },
                    {
                        "value": "C20707",
                        "companyCode": "1400",
                        "text": "C20707 - UPL-MKTG-AGRO-SBU2"
                    },
                    {
                        "value": "C20708",
                        "companyCode": "1400",
                        "text": "C20708 - UPL-MKTG-AGRO-SBU3"
                    },
                    {
                        "value": "C20709",
                        "companyCode": "1400",
                        "text": "C20709 - UPL-MKTG-PRODUCT PROMOTION"
                    },
                    {
                        "value": "C20710",
                        "companyCode": "1400",
                        "text": "C20710 - UPL-MKTG-AGRO-VECTOR CONTROL"
                    },
                    {
                        "value": "C20711",
                        "companyCode": "1400",
                        "text": "C20711 - UPL-MKTG-AGRO-PROJECT T3"
                    },
                    {
                        "value": "C20712",
                        "companyCode": "1400",
                        "text": "C20712 - UPL-MKTG-AGRO-PRODUCT DVELOPMENT-AF"
                    },
                    {
                        "value": "C20713",
                        "companyCode": "1400",
                        "text": "C20713 - UPL-MKTG-AGRO-BUSINESS TO BUSINESS"
                    },
                    {
                        "value": "C20714",
                        "companyCode": "1400",
                        "text": "C20714 - Mother Godown - Hissar"
                    },
                    {
                        "value": "C20715",
                        "companyCode": "1400",
                        "text": "C20715 - Mother Godown - Akola"
                    },
                    {
                        "value": "C20716",
                        "companyCode": "1400",
                        "text": "C20716 - UPL-MKTG-UPL DIGITAL PLATFORM"
                    },
                    {
                        "value": "C20717",
                        "companyCode": "1400",
                        "text": "C20717 - UNIMART - JANDIALA GURU"
                    },
                    {
                        "value": "C20718",
                        "companyCode": "1400",
                        "text": "C20718 - UNIMART - HANSI"
                    },
                    {
                        "value": "C20719",
                        "companyCode": "1400",
                        "text": "C20719 - UNIMART"
                    },
                    {
                        "value": "C20720",
                        "companyCode": "1400",
                        "text": "C20720 - UNIMART - MHOW"
                    },
                    {
                        "value": "C20721",
                        "companyCode": "1400",
                        "text": "C20721 - UNIMART - ABOHAR"
                    },
                    {
                        "value": "C20722",
                        "companyCode": "1400",
                        "text": "C20722 - SARKHEJ ZONAL OFFICE"
                    },
                    {
                        "value": "C20723",
                        "companyCode": "1400",
                        "text": "C20723 - SARKHEJ"
                    },
                    {
                        "value": "C20724",
                        "companyCode": "1400",
                        "text": "C20724 - BARODA"
                    },
                    {
                        "value": "C20725",
                        "companyCode": "1400",
                        "text": "C20725 - SURENDRANAGAR"
                    },
                    {
                        "value": "C20726",
                        "companyCode": "1400",
                        "text": "C20726 - DHORAJI"
                    },
                    {
                        "value": "C20727",
                        "companyCode": "1400",
                        "text": "C20727 - INDORE [ SOYA ZONE ]"
                    },
                    {
                        "value": "C20728",
                        "companyCode": "1400",
                        "text": "C20728 - INDORE"
                    },
                    {
                        "value": "C20729",
                        "companyCode": "1400",
                        "text": "C20729 - JABALPUR"
                    },
                    {
                        "value": "C20730",
                        "companyCode": "1400",
                        "text": "C20730 - BHOPAL"
                    },
                    {
                        "value": "C20731",
                        "companyCode": "1400",
                        "text": "C20731 - CUTTACK"
                    },
                    {
                        "value": "C20732",
                        "companyCode": "1400",
                        "text": "C20732 - RAIPUR [ RICE ZONE ]"
                    },
                    {
                        "value": "C20733",
                        "companyCode": "1400",
                        "text": "C20733 - RAIPUR"
                    },
                    {
                        "value": "C20734",
                        "companyCode": "1400",
                        "text": "C20734 - BHATINDA - ZONAL OFFICE"
                    },
                    {
                        "value": "C20735",
                        "companyCode": "1400",
                        "text": "C20735 - AMRITSAR"
                    },
                    {
                        "value": "C20736",
                        "companyCode": "1400",
                        "text": "C20736 - BHATINDA"
                    },
                    {
                        "value": "C20737",
                        "companyCode": "1400",
                        "text": "C20737 - JALANDHAR"
                    },
                    {
                        "value": "C20738",
                        "companyCode": "1400",
                        "text": "C20738 - HP-J&K"
                    },
                    {
                        "value": "C20739",
                        "companyCode": "1400",
                        "text": "C20739 - LUDHIANA"
                    },
                    {
                        "value": "C20740",
                        "companyCode": "1400",
                        "text": "C20740 - HISSAR"
                    },
                    {
                        "value": "C20741",
                        "companyCode": "1400",
                        "text": "C20741 - KARNAL"
                    },
                    {
                        "value": "C20742",
                        "companyCode": "1400",
                        "text": "C20742 - Rohtak"
                    },
                    {
                        "value": "C20743",
                        "companyCode": "1400",
                        "text": "C20743 - RAJASTHAN ZONAL OFFICE"
                    },
                    {
                        "value": "C20744",
                        "companyCode": "1400",
                        "text": "C20744 - JAIPUR"
                    },
                    {
                        "value": "C20745",
                        "companyCode": "1400",
                        "text": "C20745 - SRIGANGANAGAR"
                    },
                    {
                        "value": "C20746",
                        "companyCode": "1400",
                        "text": "C20746 - Jodhpur"
                    },
                    {
                        "value": "C20747",
                        "companyCode": "1400",
                        "text": "C20747 - LUCKNOW ZONAL OFFICE"
                    },
                    {
                        "value": "C20748",
                        "companyCode": "1400",
                        "text": "C20748 - AGRA"
                    },
                    {
                        "value": "C20749",
                        "companyCode": "1400",
                        "text": "C20749 - BAREILLY"
                    },
                    {
                        "value": "C20750",
                        "companyCode": "1400",
                        "text": "C20750 - GAZIABAD"
                    },
                    {
                        "value": "C20751",
                        "companyCode": "1400",
                        "text": "C20751 - LUCKNOW DEPOT"
                    },
                    {
                        "value": "C20752",
                        "companyCode": "1400",
                        "text": "C20752 - RUDRAPUR"
                    },
                    {
                        "value": "C20753",
                        "companyCode": "1400",
                        "text": "C20753 - VARANASI"
                    },
                    {
                        "value": "C20754",
                        "companyCode": "1400",
                        "text": "C20754 - BANGALORE ZONAL OFFICE"
                    },
                    {
                        "value": "C20755",
                        "companyCode": "1400",
                        "text": "C20755 - BANGALORE"
                    },
                    {
                        "value": "C20756",
                        "companyCode": "1400",
                        "text": "C20756 - BELLARY"
                    },
                    {
                        "value": "C20757",
                        "companyCode": "1400",
                        "text": "C20757 - DAVANAGERE"
                    },
                    {
                        "value": "C20758",
                        "companyCode": "1400",
                        "text": "C20758 - COCHIN"
                    },
                    {
                        "value": "C20759",
                        "companyCode": "1400",
                        "text": "C20759 - COIMBATORE"
                    },
                    {
                        "value": "C20760",
                        "companyCode": "1400",
                        "text": "C20760 - CALCUTTA ZONAL OFFICE"
                    },
                    {
                        "value": "C20761",
                        "companyCode": "1400",
                        "text": "C20761 - CALCUTTA"
                    },
                    {
                        "value": "C20762",
                        "companyCode": "1400",
                        "text": "C20762 - CENTRAL BENGAL"
                    },
                    {
                        "value": "C20763",
                        "companyCode": "1400",
                        "text": "C20763 - SOUTH BENGAL"
                    },
                    {
                        "value": "C20764",
                        "companyCode": "1400",
                        "text": "C20764 - North Bengal"
                    },
                    {
                        "value": "C20765",
                        "companyCode": "1400",
                        "text": "C20765 - GUWAHATI"
                    },
                    {
                        "value": "C20766",
                        "companyCode": "1400",
                        "text": "C20766 - PATNA"
                    },
                    {
                        "value": "C20767",
                        "companyCode": "1400",
                        "text": "C20767 - Ranchi"
                    },
                    {
                        "value": "C20768",
                        "companyCode": "1400",
                        "text": "C20768 - GUNTUR"
                    },
                    {
                        "value": "C20769",
                        "companyCode": "1400",
                        "text": "C20769 - KURNOOL"
                    },
                    {
                        "value": "C20770",
                        "companyCode": "1400",
                        "text": "C20770 - VIJAYWADA"
                    },
                    {
                        "value": "C20771",
                        "companyCode": "1400",
                        "text": "C20771 - Nellore"
                    },
                    {
                        "value": "C20772",
                        "companyCode": "1400",
                        "text": "C20772 - RAJAMUNDRY"
                    },
                    {
                        "value": "C20773",
                        "companyCode": "1400",
                        "text": "C20773 - GUNTUR ZONAL OFFICE"
                    },
                    {
                        "value": "C20774",
                        "companyCode": "1400",
                        "text": "C20774 - HYDERABAD ZONAL OFFICE"
                    },
                    {
                        "value": "C20775",
                        "companyCode": "1400",
                        "text": "C20775 - NIZAMABAD"
                    },
                    {
                        "value": "C20776",
                        "companyCode": "1400",
                        "text": "C20776 - HYDERABAD"
                    },
                    {
                        "value": "C20777",
                        "companyCode": "1400",
                        "text": "C20777 - Pune Zonal Office"
                    },
                    {
                        "value": "C20778",
                        "companyCode": "1400",
                        "text": "C20778 - AKOLA"
                    },
                    {
                        "value": "C20779",
                        "companyCode": "1400",
                        "text": "C20779 - AURANGABAD"
                    },
                    {
                        "value": "C20780",
                        "companyCode": "1400",
                        "text": "C20780 - Nagpur"
                    },
                    {
                        "value": "C20781",
                        "companyCode": "1400",
                        "text": "C20781 - Nasik"
                    },
                    {
                        "value": "C20782",
                        "companyCode": "1400",
                        "text": "C20782 - NANDED"
                    },
                    {
                        "value": "C20783",
                        "companyCode": "1400",
                        "text": "C20783 - PUNE"
                    },
                    {
                        "value": "C20784",
                        "companyCode": "1400",
                        "text": "C20784 - UPL-CORP- PROJECT DIWALI"
                    },
                    {
                        "value": "C20785",
                        "companyCode": "1400",
                        "text": "C20785 - UPL-AURANGABAD_AF"
                    },
                    {
                        "value": "C20786",
                        "companyCode": "1400",
                        "text": "C20786 - UPL-BANGALORE_AF"
                    },
                    {
                        "value": "C20787",
                        "companyCode": "1400",
                        "text": "C20787 - UPL-BELLARY_AF"
                    },
                    {
                        "value": "C20788",
                        "companyCode": "1400",
                        "text": "C20788 - UPL-BHOPAL_AF"
                    },
                    {
                        "value": "C20789",
                        "companyCode": "1400",
                        "text": "C20789 - UPL-CENTRAL_BENGAL_AF"
                    },
                    {
                        "value": "C20790",
                        "companyCode": "1400",
                        "text": "C20790 - UPL-COIMBATORE_AF"
                    },
                    {
                        "value": "C20791",
                        "companyCode": "1400",
                        "text": "C20791 - UPL-GUNTUR_AF"
                    },
                    {
                        "value": "C20792",
                        "companyCode": "1400",
                        "text": "C20792 - UPL-GUWAHATI_AF"
                    },
                    {
                        "value": "C20793",
                        "companyCode": "1400",
                        "text": "C20793 - UPL-HYDERABAD_AF"
                    },
                    {
                        "value": "C20794",
                        "companyCode": "1400",
                        "text": "C20794 - UPL-INDORE_AF"
                    },
                    {
                        "value": "C20795",
                        "companyCode": "1400",
                        "text": "C20795 - UPL-JABALPUR_AF"
                    },
                    {
                        "value": "C20796",
                        "companyCode": "1400",
                        "text": "C20796 - UPL-KURNOOL_AF"
                    },
                    {
                        "value": "C20797",
                        "companyCode": "1400",
                        "text": "C20797 - UPL-NAGPUR_AF"
                    },
                    {
                        "value": "C20798",
                        "companyCode": "1400",
                        "text": "C20798 - UPL-NASHIK_AF"
                    },
                    {
                        "value": "C20799",
                        "companyCode": "1400",
                        "text": "C20799 - UPL-NIZAMABAD_WARANGAL_AF"
                    },
                    {
                        "value": "C20800",
                        "companyCode": "1400",
                        "text": "C20800 - UPL-PATNA_AF"
                    },
                    {
                        "value": "C20801",
                        "companyCode": "1400",
                        "text": "C20801 - UPL-PUNE_AF"
                    },
                    {
                        "value": "C20802",
                        "companyCode": "1400",
                        "text": "C20802 - UPL-RAJAHMUNDRY_AF"
                    },
                    {
                        "value": "C20803",
                        "companyCode": "1400",
                        "text": "C20803 - UPL-SOU_BENGAL_&_ODIS_AF"
                    },
                    {
                        "value": "C20804",
                        "companyCode": "1400",
                        "text": "C20804 - UPL-VIJAYWADA_AF"
                    },
                    {
                        "value": "C20805",
                        "companyCode": "1400",
                        "text": "C20805 - UPL-AHMEDABAD_AF"
                    },
                    {
                        "value": "C20806",
                        "companyCode": "1400",
                        "text": "C20806 - UPL-RAJKOT_AF"
                    },
                    {
                        "value": "C20807",
                        "companyCode": "1400",
                        "text": "C20807 - UPL-BHATINDA_AF"
                    },
                    {
                        "value": "C20808",
                        "companyCode": "1400",
                        "text": "C20808 - UPL-LUDHIANA_AF"
                    },
                    {
                        "value": "C20809",
                        "companyCode": "1400",
                        "text": "C20809 - UPL-HISSAR_AF"
                    },
                    {
                        "value": "C20810",
                        "companyCode": "1400",
                        "text": "C20810 - UPL-JAIPUR_AF"
                    },
                    {
                        "value": "C20811",
                        "companyCode": "1400",
                        "text": "C20811 - UPL-JODHPUR_AF"
                    },
                    {
                        "value": "C20812",
                        "companyCode": "1400",
                        "text": "C20812 - UPL-LUCKNOW_AF"
                    },
                    {
                        "value": "C20813",
                        "companyCode": "1400",
                        "text": "C20813 - UPL-GHAZIABAD_AF"
                    },
                    {
                        "value": "C20814",
                        "companyCode": "1400",
                        "text": "C20814 - UPL-RAIPUR_AF"
                    },
                    {
                        "value": "C20815",
                        "companyCode": "1400",
                        "text": "C20815 - UPL-SRIGANGANAGAR_AF"
                    },
                    {
                        "value": "C20816",
                        "companyCode": "1400",
                        "text": "C20816 - UPL-SILIGURI_AF"
                    },
                    {
                        "value": "C20817",
                        "companyCode": "1400",
                        "text": "C20817 - Ground Nut Projects"
                    },
                    {
                        "value": "C20818",
                        "companyCode": "1400",
                        "text": "C20818 - Bhatinda Cotton_Agro Formulation"
                    },
                    {
                        "value": "C20819",
                        "companyCode": "1400",
                        "text": "C20819 - Haryana Cotton_Agro Formulation"
                    },
                    {
                        "value": "C20820",
                        "companyCode": "1400",
                        "text": "C20820 - Sriganganagar Cotton_Agro Formulation"
                    },
                    {
                        "value": "C20821",
                        "companyCode": "1400",
                        "text": "C20821 - Punjab Paddy_Agro Formulation"
                    },
                    {
                        "value": "C20822",
                        "companyCode": "1400",
                        "text": "C20822 - Haryana Paddy_Agro Formulation"
                    },
                    {
                        "value": "C20823",
                        "companyCode": "1400",
                        "text": "C20823 - North Bengal_Agro Formulation"
                    },
                    {
                        "value": "C20824",
                        "companyCode": "1400",
                        "text": "C20824 - Odisha_Agro Formulation"
                    },
                    {
                        "value": "C20825",
                        "companyCode": "1400",
                        "text": "C20825 - SBU5"
                    },
                    {
                        "value": "C20826",
                        "companyCode": "1400",
                        "text": "C20826 - Regulatory-AF-IN"
                    },
                    {
                        "value": "C20827",
                        "companyCode": "1400",
                        "text": "C20827 - Field R&D-AF-IN"
                    },
                    {
                        "value": "C20828",
                        "companyCode": "1400",
                        "text": "C20828 - UPL-IND-Marketing"
                    },
                    {
                        "value": "C20829",
                        "companyCode": "1400",
                        "text": "C20829 - UPL-IND-Sales"
                    },
                    {
                        "value": "C20830",
                        "companyCode": "1400",
                        "text": "C20830 - UPL-IND-Finance"
                    },
                    {
                        "value": "C20831",
                        "companyCode": "1400",
                        "text": "C20831 - UPL-IND-Human Resources"
                    },
                    {
                        "value": "C20832",
                        "companyCode": "1400",
                        "text": "C20832 - UPL-IND-Marketing"
                    },
                    {
                        "value": "C20833",
                        "companyCode": "1400",
                        "text": "C20833 - UPL-IND-Sales"
                    },
                    {
                        "value": "C20834",
                        "companyCode": "1400",
                        "text": "C20834 - UPL-IND-Finance"
                    },
                    {
                        "value": "C20835",
                        "companyCode": "1400",
                        "text": "C20835 - UPL-IND-Human Resources"
                    },
                    {
                        "value": "C20836",
                        "companyCode": "1400",
                        "text": "C20836 - UPL-IND-Logistic"
                    },
                    {
                        "value": "C20837",
                        "companyCode": "1400",
                        "text": "C20837 - UPL-IND-Marketing"
                    },
                    {
                        "value": "C20838",
                        "companyCode": "1400",
                        "text": "C20838 - UPL-IND-Sales"
                    },
                    {
                        "value": "C20839",
                        "companyCode": "1400",
                        "text": "C20839 - UPL-IND-Finance"
                    },
                    {
                        "value": "C20840",
                        "companyCode": "1400",
                        "text": "C20840 - UPL-IND-Human Resources"
                    },
                    {
                        "value": "C20841",
                        "companyCode": "1400",
                        "text": "C20841 - UPL-IND-Logistic"
                    },
                    {
                        "value": "C20842",
                        "companyCode": "1400",
                        "text": "C20842 - Jammu & Kashmir_AF Zn"
                    },
                    {
                        "value": "C20843",
                        "companyCode": "1400",
                        "text": "C20843 - Jalgaon _AF Zn"
                    },
                    {
                        "value": "C20844",
                        "companyCode": "1400",
                        "text": "C20844 - UPL -HYDERABAD DEPOT"
                    },
                    {
                        "value": "C20845",
                        "companyCode": "1400",
                        "text": "C20845 - UPL-WARANGAL DEPOT"
                    },
                    {
                        "value": "C20846",
                        "companyCode": "1400",
                        "text": "C20846 - UPL-MKTG-MKTG-ATCA"
                    },
                    {
                        "value": "C20847",
                        "companyCode": "1400",
                        "text": "C20847 - ALP MKTG"
                    },
                    {
                        "value": "C20848",
                        "companyCode": "1400",
                        "text": "C20848 - DECCO/OORJA MKTG"
                    },
                    {
                        "value": "C20849",
                        "companyCode": "1400",
                        "text": "C20849 - UPL-MKTG-INDIA REGION ALP"
                    },
                    {
                        "value": "C20850",
                        "companyCode": "1400",
                        "text": "C20850 - ZIRAKPUR"
                    },
                    {
                        "value": "C20851",
                        "companyCode": "1400",
                        "text": "C20851 - UPL-MKTG-INDIA REGION SWAL"
                    },
                    {
                        "value": "C20852",
                        "companyCode": "1400",
                        "text": "C20852 - UPL-MKTG-INDIA REGION AT"
                    },
                    {
                        "value": "C20853",
                        "companyCode": "1400",
                        "text": "C20853 - SWAL Marketing"
                    },
                    {
                        "value": "C20854",
                        "companyCode": "1400",
                        "text": "C20854 - SWAL Sales"
                    },
                    {
                        "value": "C20855",
                        "companyCode": "1400",
                        "text": "C20855 - SWAL Finance"
                    },
                    {
                        "value": "C20856",
                        "companyCode": "1400",
                        "text": "C20856 - SWAL Human Resources"
                    },
                    {
                        "value": "C20857",
                        "companyCode": "1400",
                        "text": "C20857 - SWAL Logistic"
                    },
                    {
                        "value": "C20901",
                        "companyCode": "1400",
                        "text": "C20901 - OPTIMA-CORP-FINANCE & ACCOUNTS"
                    },
                    {
                        "value": "C20902",
                        "companyCode": "1400",
                        "text": "C20902 - OPTIMA-CORP-SECRETARIAL"
                    },
                    {
                        "value": "C20903",
                        "companyCode": "1400",
                        "text": "C20903 - UPL- Inter Co - Dom"
                    },
                    {
                        "value": "C20904",
                        "companyCode": "1400",
                        "text": "C20904 - UPL-MKTG-INDIA REGION AF"
                    },
                    {
                        "value": "C25101",
                        "companyCode": "1300",
                        "text": "C25101 - UP(INDIA)-LLP-WDG 10 TPD"
                    },
                    {
                        "value": "C25102",
                        "companyCode": "1300",
                        "text": "C25102 - UP(INDIA)-LLP--Acephate 40 TPD"
                    },
                    {
                        "value": "C25103",
                        "companyCode": "1300",
                        "text": "C25103 - WDG 2 TPD"
                    },
                    {
                        "value": "C25104",
                        "companyCode": "1300",
                        "text": "C25104 - '-"
                    },
                    {
                        "value": "C25201",
                        "companyCode": "1300",
                        "text": "C25201 - UP(INDIA)-LLP--POWER"
                    },
                    {
                        "value": "C25202",
                        "companyCode": "1300",
                        "text": "C25202 - UP(INDIA)-LLP--STEAM"
                    },
                    {
                        "value": "C25301",
                        "companyCode": "1300",
                        "text": "C25301 - UP(INDIA)-LLP--ENG-MECHANICAL"
                    },
                    {
                        "value": "C25401",
                        "companyCode": "1300",
                        "text": "C25401 - UP(INDIA)-LLP--COMMERCIAL"
                    },
                    {
                        "value": "C25402",
                        "companyCode": "1300",
                        "text": "C25402 - UP(INDIA)-LLP--STORES"
                    },
                    {
                        "value": "C25501",
                        "companyCode": "1300",
                        "text": "C25501 - UP(INDIA)-LLP-ADMINISTRATION"
                    },
                    {
                        "value": "C25524",
                        "companyCode": "1300",
                        "text": "C25524 - ."
                    },
                    {
                        "value": "C25525",
                        "companyCode": "1300",
                        "text": "C25525 - Manufacturing Management ANK25"
                    },
                    {
                        "value": "C25601",
                        "companyCode": "1300",
                        "text": "C25601 - UPL(INDIA)-LLP-STANDSTILL & ELIMINA COST"
                    },
                    {
                        "value": "C25602",
                        "companyCode": "1300",
                        "text": "C25602 - UP(INDIA)-LLP-FINISHED GOODS STORES"
                    },
                    {
                        "value": "C25901",
                        "companyCode": "1300",
                        "text": "C25901 - UP(INDIA)-LLP-CORP-FINANCE & ACCOUNTS"
                    },
                    {
                        "value": "C25902",
                        "companyCode": "1300",
                        "text": "C25902 - UP(INDIA)-LLP-CORP-LOGISTICS"
                    },
                    {
                        "value": "C25903",
                        "companyCode": "1300",
                        "text": "C25903 - UP(INDIA)-LLP-BRAZIL [ DVA ]"
                    },
                    {
                        "value": "C25904",
                        "companyCode": "1300",
                        "text": "C25904 - UP(INDIA)-LLP-ARGENTINA"
                    },
                    {
                        "value": "C26101",
                        "companyCode": "1300",
                        "text": "C26101 - UPL-(INDIA)-LLP-PL26--ACEPHATE 97 DF"
                    },
                    {
                        "value": "C26102",
                        "companyCode": "1300",
                        "text": "C26102 - UPL-(INDIA)-LLP-PL26--Seed FS Plant"
                    },
                    {
                        "value": "C26103",
                        "companyCode": "1300",
                        "text": "C26103 - UPL-LLP-PL26-Acemida"
                    },
                    {
                        "value": "C26104",
                        "companyCode": "1300",
                        "text": "C26104 - UPL-LLP-PL26-Acenthrin"
                    },
                    {
                        "value": "C26201",
                        "companyCode": "1300",
                        "text": "C26201 - UPL-(INDIA)-LLP-PL26--POWER"
                    },
                    {
                        "value": "C26202",
                        "companyCode": "1300",
                        "text": "C26202 - UPL-(INDIA)-LLP-PL26--STEAM"
                    },
                    {
                        "value": "C26204",
                        "companyCode": "1300",
                        "text": "C26204 - UPL-LLP-PL26-Common Utilities"
                    },
                    {
                        "value": "C26301",
                        "companyCode": "1300",
                        "text": "C26301 - UPL-(INDIA)-LLP-PL26--ENG-MECHANICAL"
                    },
                    {
                        "value": "C26401",
                        "companyCode": "1300",
                        "text": "C26401 - UPL-(INDIA)-LLP-PL26--COMMERCIAL"
                    },
                    {
                        "value": "C26402",
                        "companyCode": "1300",
                        "text": "C26402 - UPL-(INDIA)-LLP-PL26--STORES"
                    },
                    {
                        "value": "C26501",
                        "companyCode": "1300",
                        "text": "C26501 - UPL-(INDIA)-LLP-PL26-ADMINISTRATION"
                    },
                    {
                        "value": "C26508",
                        "companyCode": "1300",
                        "text": "C26508 - UPL-LLP-PL26-SAFETY DEPARTMENT"
                    },
                    {
                        "value": "C26524",
                        "companyCode": "1300",
                        "text": "C26524 - ."
                    },
                    {
                        "value": "C26525",
                        "companyCode": "1300",
                        "text": "C26525 - Manufacturing Management ANK26"
                    },
                    {
                        "value": "C26601",
                        "companyCode": "1300",
                        "text": "C26601 - UPL-(INDIA)-LLP-PL26-STANDSTILL & ELIMIN"
                    },
                    {
                        "value": "C26602",
                        "companyCode": "1300",
                        "text": "C26602 - UPL-(INDIA)-LLP-PL26-FINISHED GOODS STOR"
                    },
                    {
                        "value": "C26603",
                        "companyCode": "1300",
                        "text": "C26603 - UPL- Inter Co - Dom"
                    },
                    {
                        "value": "C26901",
                        "companyCode": "1300",
                        "text": "C26901 - UP(INDIA)-LLP-CORP-FINANCE & ACCOUNTS"
                    },
                    {
                        "value": "C26902",
                        "companyCode": "1300",
                        "text": "C26902 - UP(INDIA)-LLP-CORP-LOGISTICS"
                    },
                    {
                        "value": "C26903",
                        "companyCode": "1300",
                        "text": "C26903 - UPL-MKTG-Exp-Thailand"
                    },
                    {
                        "value": "C51101",
                        "companyCode": "1000",
                        "text": "C51101 - UPL-TP-AHMEDABAD OFFICE"
                    },
                    {
                        "value": "C51102",
                        "companyCode": "1000",
                        "text": "C51102 - UPL-TP-JOB WORK GENERAL"
                    },
                    {
                        "value": "C52101",
                        "companyCode": "1000",
                        "text": "C52101 - UPL-MKTG-MARKETING - AGRO"
                    },
                    {
                        "value": "C52102",
                        "companyCode": "1000",
                        "text": "C52102 - GLOBAL FIELD R&D FIELD STATIONS (INDIA)"
                    },
                    {
                        "value": "C52103",
                        "companyCode": "1000",
                        "text": "C52103 - UPL-MKTG-PRODUCT PROMOTION"
                    },
                    {
                        "value": "C52104",
                        "companyCode": "1000",
                        "text": "C52104 - UPL-MKTG-MARKETING - ATCA"
                    },
                    {
                        "value": "C52105",
                        "companyCode": "1000",
                        "text": "C52105 - UPL-MKTG-EXPORT SUBSIDIARIES"
                    },
                    {
                        "value": "C52106",
                        "companyCode": "1000",
                        "text": "C52106 - UPL-MKTG-MARKETING - EXPORT"
                    },
                    {
                        "value": "C52107",
                        "companyCode": "1000",
                        "text": "C52107 - UPL-MKTG-REGISTRATION - EXPORT"
                    },
                    {
                        "value": "C52108",
                        "companyCode": "1000",
                        "text": "C52108 - UPL-MKTG-IC Domestic"
                    },
                    {
                        "value": "C52109",
                        "companyCode": "1000",
                        "text": "C52109 - UPL-MKTG-GAS DETECTION EQUIPMENTS"
                    },
                    {
                        "value": "C52110",
                        "companyCode": "1000",
                        "text": "C52110 - UPL-MKTG SEEDS"
                    },
                    {
                        "value": "C52111",
                        "companyCode": "1000",
                        "text": "C52111 - UPL-MKTG-Exports Non Subs - Ind. Chem."
                    },
                    {
                        "value": "C52112",
                        "companyCode": "1000",
                        "text": "C52112 - UPL-MKTG-EXP LATIN AMERICA"
                    },
                    {
                        "value": "C52113",
                        "companyCode": "1000",
                        "text": "C52113 - UPL-MKTG-INTEGRATED BUSINESS"
                    },
                    {
                        "value": "C52116",
                        "companyCode": "1000",
                        "text": "C52116 - Domestic Mkt. Food Crops"
                    },
                    {
                        "value": "C52117",
                        "companyCode": "1000",
                        "text": "C52117 - Domestic Mkt.Vegetable Crops"
                    },
                    {
                        "value": "C52118",
                        "companyCode": "1000",
                        "text": "C52118 - UPL-MKTG-Exports-Vietnam"
                    },
                    {
                        "value": "C52119",
                        "companyCode": "1000",
                        "text": "C52119 - UPL-MKTG-EXP-ASIA HO"
                    },
                    {
                        "value": "C52120",
                        "companyCode": "1000",
                        "text": "C52120 - UPL-MKTG-Exports-AFRICA & MIDDLE EAST"
                    },
                    {
                        "value": "C52121",
                        "companyCode": "1000",
                        "text": "C52121 - UPL-MKTG-Exports MIDDLE EAST"
                    },
                    {
                        "value": "C52122",
                        "companyCode": "1000",
                        "text": "C52122 - UPL-MKTG-MARKETING - CA"
                    },
                    {
                        "value": "C52123",
                        "companyCode": "1000",
                        "text": "C52123 - UPL-MKTG-EXPORTS-INSTITUTIONAL SALES"
                    },
                    {
                        "value": "C52124",
                        "companyCode": "1000",
                        "text": "C52124 - UPL-MKTG-AGRO-BUSINESS TO BUSINESS"
                    },
                    {
                        "value": "C52125",
                        "companyCode": "1000",
                        "text": "C52125 - UPL-MKTG-PROD DEV & REGUL. AFFAIRS - FC"
                    },
                    {
                        "value": "C52126",
                        "companyCode": "1000",
                        "text": "C52126 - UPL-MKTG-PROD DEV & REGUL. AFFAIRS - VC"
                    },
                    {
                        "value": "C52127",
                        "companyCode": "1000",
                        "text": "C52127 - UPL-MKTG-AGRO-VECTOR CONTROL"
                    },
                    {
                        "value": "C52128",
                        "companyCode": "1000",
                        "text": "C52128 - UPL-MKTG-AGRO-PROJECT T3"
                    },
                    {
                        "value": "C52129",
                        "companyCode": "1000",
                        "text": "C52129 - UPL-MKTG-AGRO-CONTRACT SPRAYING"
                    },
                    {
                        "value": "C52130",
                        "companyCode": "1000",
                        "text": "C52130 - UPL-MKTG-AGRO-PRODUCT DVELOPMENT-AF"
                    },
                    {
                        "value": "C52131",
                        "companyCode": "1000",
                        "text": "C52131 - UPL-MKTG-FC-BUSINESS TO BUSINESS"
                    },
                    {
                        "value": "C52132",
                        "companyCode": "1000",
                        "text": "C52132 - UPL-MKTG-TAIWAN"
                    },
                    {
                        "value": "C52133",
                        "companyCode": "1000",
                        "text": "C52133 - UPL-MKTG-VC-BUSINESS TO BUSINESS"
                    },
                    {
                        "value": "C52134",
                        "companyCode": "1000",
                        "text": "C52134 - UPL-MKTG-FC-HO"
                    },
                    {
                        "value": "C52135",
                        "companyCode": "1000",
                        "text": "C52135 - UPL-MKTG-VC-HO"
                    },
                    {
                        "value": "C52136",
                        "companyCode": "1000",
                        "text": "C52136 - UPL-MKTG-VC-CUSTOM PRODUCTION BUSINESS"
                    },
                    {
                        "value": "C52137",
                        "companyCode": "1000",
                        "text": "C52137 - UPL-MKTG-VC-CROP LEAD INTERNATL BUSINESS"
                    },
                    {
                        "value": "C52138",
                        "companyCode": "1000",
                        "text": "C52138 - UPL-MKTG-AGRO-SBU1"
                    },
                    {
                        "value": "C52139",
                        "companyCode": "1000",
                        "text": "C52139 - UPL-MKTG-AGRO-SBU2"
                    },
                    {
                        "value": "C52140",
                        "companyCode": "1000",
                        "text": "C52140 - UPL-MKTG-INDIA REGION AF"
                    },
                    {
                        "value": "C52141",
                        "companyCode": "1000",
                        "text": "C52141 - UPL-MKTG-INDIA REGION AT"
                    },
                    {
                        "value": "C52142",
                        "companyCode": "1000",
                        "text": "C52142 - UPL-MKTG-INDIA REGION SWAL"
                    },
                    {
                        "value": "C52143",
                        "companyCode": "1000",
                        "text": "C52143 - UPL-MKTG-Agro ZEBA & BIOLOGICAL"
                    },
                    {
                        "value": "C52144",
                        "companyCode": "1000",
                        "text": "C52144 - UPL-MKTG-Exports-EAST AFRICA"
                    },
                    {
                        "value": "C52145",
                        "companyCode": "1000",
                        "text": "C52145 - UPL-MKTG-Exports-WEST AFRICA"
                    },
                    {
                        "value": "C52146",
                        "companyCode": "1000",
                        "text": "C52146 - UPL-MKTG-Exports-NIGERIA"
                    },
                    {
                        "value": "C52147",
                        "companyCode": "1000",
                        "text": "C52147 - UPL-MKTG-Exports-NORTH AFRICA"
                    },
                    {
                        "value": "C52148",
                        "companyCode": "1000",
                        "text": "C52148 - UPL-MKTG-Exports-SOUTHERN AFRICA"
                    },
                    {
                        "value": "C52149",
                        "companyCode": "1000",
                        "text": "C52149 - UPL-MKTG-Exports-TURKEY ZIRAAT"
                    },
                    {
                        "value": "C52150",
                        "companyCode": "1000",
                        "text": "C52150 - UPL-MKTG-Exports-TURKEY AGROMED"
                    },
                    {
                        "value": "C52151",
                        "companyCode": "1000",
                        "text": "C52151 - UPL-MKTG-Exports-SOUTH KOREA"
                    },
                    {
                        "value": "C52152",
                        "companyCode": "1000",
                        "text": "C52152 - UPL-MKTG-Exp-AUS/NZ"
                    },
                    {
                        "value": "C52153",
                        "companyCode": "1000",
                        "text": "C52153 - UPL-MKTG-Exp-PT Catur"
                    },
                    {
                        "value": "C52154",
                        "companyCode": "1000",
                        "text": "C52154 - UPL-MKTG-Exp-China"
                    },
                    {
                        "value": "C52155",
                        "companyCode": "1000",
                        "text": "C52155 - UPL-MKTG-Exp-PHILIPPINES"
                    },
                    {
                        "value": "C52156",
                        "companyCode": "1000",
                        "text": "C52156 - UPL-MKTG-Exp-PT UPL INDONESIA"
                    },
                    {
                        "value": "C52157",
                        "companyCode": "1000",
                        "text": "C52157 - UPL-MKTG-Exp-NUFARM BUS."
                    },
                    {
                        "value": "C52158",
                        "companyCode": "1000",
                        "text": "C52158 - UPL-MKTG-Exp-JAPAN"
                    },
                    {
                        "value": "C52159",
                        "companyCode": "1000",
                        "text": "C52159 - UPL-MKTG-Exp-Thailand/Myanmar"
                    },
                    {
                        "value": "C52160",
                        "companyCode": "1000",
                        "text": "C52160 - UPL-MKTG-Exp-Singapore/Malaysia"
                    },
                    {
                        "value": "C52161",
                        "companyCode": "1000",
                        "text": "C52161 - UPL-SUPPLY CHAIN - VIETNAM"
                    },
                    {
                        "value": "C52162",
                        "companyCode": "1000",
                        "text": "C52162 - UPL-MKTG-AGRO-SBU3"
                    },
                    {
                        "value": "C52163",
                        "companyCode": "1000",
                        "text": "C52163 - UPL-MKTG-Exp-SEA CORP"
                    },
                    {
                        "value": "C52164",
                        "companyCode": "1000",
                        "text": "C52164 - UPL-MKTG-AGRO-SBU4"
                    },
                    {
                        "value": "C52165",
                        "companyCode": "1000",
                        "text": "C52165 - UPL-MKTG-INDIA REGION ALP"
                    },
                    {
                        "value": "C52166",
                        "companyCode": "1000",
                        "text": "C52166 - UPL ASIA-Regualtory PCA"
                    },
                    {
                        "value": "C52167",
                        "companyCode": "1000",
                        "text": "C52167 - UPL- BANGLADESH REGULATORY"
                    },
                    {
                        "value": "C52168",
                        "companyCode": "1000",
                        "text": "C52168 - UPL- SRILANKA REGULATORY"
                    },
                    {
                        "value": "C521687",
                        "companyCode": "1000",
                        "text": "C521687 - UPL- BANGLADESH REGULATORY"
                    },
                    {
                        "value": "C52169",
                        "companyCode": "1000",
                        "text": "C52169 - UPL- Inter Co - Dom"
                    },
                    {
                        "value": "C52170",
                        "companyCode": "1700",
                        "text": "C52170 - UPL-MKTG-AFS AGTECH"
                    },
                    {
                        "value": "C52171",
                        "companyCode": "1000",
                        "text": "C52171 - UPL-MKTG-AFS AGTECH"
                    },
                    {
                        "value": "C52301",
                        "companyCode": "1000",
                        "text": "C52301 - UPL-CORP-FINANCE & ACCOUNTS"
                    },
                    {
                        "value": "C52302",
                        "companyCode": "1000",
                        "text": "C52302 - UPL-PURCHASE"
                    },
                    {
                        "value": "C52303",
                        "companyCode": "1000",
                        "text": "C52303 - UPL-CORP-PERSONNEL & HRD"
                    },
                    {
                        "value": "C52304",
                        "companyCode": "1000",
                        "text": "C52304 - UPL-CORP-INFORMATION TECHNOLOGY"
                    },
                    {
                        "value": "C52305",
                        "companyCode": "1000",
                        "text": "C52305 - UPL-CORP-MANAGEMENT"
                    },
                    {
                        "value": "C52306",
                        "companyCode": "1000",
                        "text": "C52306 - UPL-CORP-DIRECTORS"
                    },
                    {
                        "value": "C52307",
                        "companyCode": "1000",
                        "text": "C52307 - UPL-CORP-ADMIN-UNIPHOS HOUSE"
                    },
                    {
                        "value": "C52308",
                        "companyCode": "1000",
                        "text": "C52308 - UPL-CORP-ADMIN-WORLI OFFICE"
                    },
                    {
                        "value": "C52309",
                        "companyCode": "1000",
                        "text": "C52309 - UPL-CORP-SECRETARIAL"
                    },
                    {
                        "value": "C52310",
                        "companyCode": "1000",
                        "text": "C52310 - UPL-CORP-LEGAL DEPARTMENT"
                    },
                    {
                        "value": "C52311",
                        "companyCode": "1000",
                        "text": "C52311 - UPL-CORP-INTERNAL AUDIT"
                    },
                    {
                        "value": "C52312",
                        "companyCode": "1000",
                        "text": "C52312 - UPL-LOGISTICS"
                    },
                    {
                        "value": "C52313",
                        "companyCode": "1000",
                        "text": "C52313 - UPL-CORP-TECHNICAL"
                    },
                    {
                        "value": "C52314",
                        "companyCode": "1000",
                        "text": "C52314 - UPL-CORP-IPR"
                    },
                    {
                        "value": "C52315",
                        "companyCode": "1000",
                        "text": "C52315 - UPL-CORP-SAP GLOBAL ROLLOUT(INTL SUBS)"
                    },
                    {
                        "value": "C52316",
                        "companyCode": "1000",
                        "text": "C52316 - UPL-CORP- R&D THANE"
                    },
                    {
                        "value": "C52317",
                        "companyCode": "1000",
                        "text": "C52317 - UPL-CORP-GUEST HOUSE"
                    },
                    {
                        "value": "C52318",
                        "companyCode": "1000",
                        "text": "C52318 - UPL-CORP-ADMIN-JAYANT VILLA"
                    },
                    {
                        "value": "C52319",
                        "companyCode": "1000",
                        "text": "C52319 - UPL-CORP-GYM-JAYANT VILLA"
                    },
                    {
                        "value": "C52320",
                        "companyCode": "1000",
                        "text": "C52320 - Global Marketing Communications"
                    },
                    {
                        "value": "C52321",
                        "companyCode": "1000",
                        "text": "C52321 - UPL-SUPPLY CH - PLANING & CONTROL"
                    },
                    {
                        "value": "C52322",
                        "companyCode": "1000",
                        "text": "C52322 - UPL-CORP-GORAI DUMP PROJECT"
                    },
                    {
                        "value": "C52323",
                        "companyCode": "1000",
                        "text": "C52323 - UPL-SUPPLY CHAIN MANAGEMENT"
                    },
                    {
                        "value": "C52324",
                        "companyCode": "1000",
                        "text": "C52324 - UPL-CORP-GHARPURE ENGG. & CONSTRUCTION"
                    },
                    {
                        "value": "C52325",
                        "companyCode": "1000",
                        "text": "C52325 - UPL-CORP-Global Projects [ Formulation ]"
                    },
                    {
                        "value": "C52326",
                        "companyCode": "1000",
                        "text": "C52326 - UPL-MKTG-INSTITUTIONAL BUSINESS"
                    },
                    {
                        "value": "C52327",
                        "companyCode": "1000",
                        "text": "C52327 - UPL-CORP-HELICOPTER EXPENSES"
                    },
                    {
                        "value": "C52328",
                        "companyCode": "1000",
                        "text": "C52328 - UPL-CORP-INTERNATIONAL MAXPRO"
                    },
                    {
                        "value": "C52329",
                        "companyCode": "1000",
                        "text": "C52329 - UPL-CORP-EUROPE SUBS"
                    },
                    {
                        "value": "C52330",
                        "companyCode": "1000",
                        "text": "C52330 - UPL-CORP-UPL DO BRAZIL [ DVA ]"
                    },
                    {
                        "value": "C52331",
                        "companyCode": "1000",
                        "text": "C52331 - UPL-CORP-NORTH AMERICA SUBS"
                    },
                    {
                        "value": "C52332",
                        "companyCode": "1000",
                        "text": "C52332 - UPL-CORP-RICECO SUBS"
                    },
                    {
                        "value": "C52333",
                        "companyCode": "1000",
                        "text": "C52333 - UPL-CORP-DECCO SUBS"
                    },
                    {
                        "value": "C52334",
                        "companyCode": "1000",
                        "text": "C52334 - Free Trade Warehouse Zone"
                    },
                    {
                        "value": "C52335",
                        "companyCode": "1000",
                        "text": "C52335 - UPL-CORP-MANAGEMENT GROUP CO"
                    },
                    {
                        "value": "C52336",
                        "companyCode": "1000",
                        "text": "C52336 - UPL-CORP-MANAGEMENT OTHERS"
                    },
                    {
                        "value": "C52337",
                        "companyCode": "1000",
                        "text": "C52337 - UPL-CORP-LOCAL SUBS"
                    },
                    {
                        "value": "C52338",
                        "companyCode": "1000",
                        "text": "C52338 - UPL-CORP-CORPORATE SOCIAL RESPONSIBILITY"
                    },
                    {
                        "value": "C52339",
                        "companyCode": "1000",
                        "text": "C52339 - UPL-CORP-CUSTOMER SERVICE & DEMAND PLANN"
                    },
                    {
                        "value": "C52340",
                        "companyCode": "1000",
                        "text": "C52340 - UPL-MKTG-UPL DIGITAL PLATFORM"
                    },
                    {
                        "value": "C52341",
                        "companyCode": "1000",
                        "text": "C52341 - UPL-CORP-ADMIN-NEW HEAD OFFICE - BANDRA"
                    },
                    {
                        "value": "C52342",
                        "companyCode": "1000",
                        "text": "C52342 - UPL-CORP-EUROPE SUBS-FRANCE"
                    },
                    {
                        "value": "C52343",
                        "companyCode": "1000",
                        "text": "C52343 - UPL-CORP-ANDEAN-LATIN AMERICA"
                    },
                    {
                        "value": "C52344",
                        "companyCode": "1000",
                        "text": "C52344 - UPL-CORP-ARGENTINA-LATIN AMERICA"
                    },
                    {
                        "value": "C52345",
                        "companyCode": "1000",
                        "text": "C52345 - UPL-CORP-CENTRAL AMERICA-LATIN AMERICA"
                    },
                    {
                        "value": "C52346",
                        "companyCode": "1000",
                        "text": "C52346 - UPL-CORP-SOUTH CONE-LATIN AMERICA"
                    },
                    {
                        "value": "C52347",
                        "companyCode": "1000",
                        "text": "C52347 - UPL-CORP-MAXICO-LATIN AMERICA"
                    },
                    {
                        "value": "C52348",
                        "companyCode": "1000",
                        "text": "C52348 - UPL-CORP-PROJECTS"
                    },
                    {
                        "value": "C52349",
                        "companyCode": "1000",
                        "text": "C52349 - Sustainable Solutions (Zeba)"
                    },
                    {
                        "value": "C52350",
                        "companyCode": "1000",
                        "text": "C52350 - UPL-CORP-ZEBA INTERNATION"
                    },
                    {
                        "value": "C52351",
                        "companyCode": "1000",
                        "text": "C52351 - UPL-CORP-Governance Risk and Compliance"
                    },
                    {
                        "value": "C52352",
                        "companyCode": "1000",
                        "text": "C52352 - UPL Corp Applications"
                    },
                    {
                        "value": "C52353",
                        "companyCode": "1000",
                        "text": "C52353 - UPL-Corporate Management (SCPC)"
                    },
                    {
                        "value": "C52354",
                        "companyCode": "1000",
                        "text": "C52354 - UPL-CORP- PROJECT DIWALI"
                    },
                    {
                        "value": "C52355",
                        "companyCode": "1000",
                        "text": "C52355 - UPL-CORP-IT Digital Projects"
                    },
                    {
                        "value": "C52356",
                        "companyCode": "1000",
                        "text": "C52356 - UPL-CORP-CHILE & PERU"
                    },
                    {
                        "value": "C52357",
                        "companyCode": "1000",
                        "text": "C52357 - UPL-GLOBAL R&D PMO"
                    },
                    {
                        "value": "C52358",
                        "companyCode": "1000",
                        "text": "C52358 - UPL- CORP- GLOBAL REGULATORY"
                    },
                    {
                        "value": "C52359",
                        "companyCode": "1000",
                        "text": "C52359 - UPL-CORP-Global Field R&D"
                    },
                    {
                        "value": "C52360",
                        "companyCode": "1000",
                        "text": "C52360 - UPL-Corp- Asia Field R&D"
                    },
                    {
                        "value": "C52361",
                        "companyCode": "1000",
                        "text": "C52361 - UPL-CORP-Business Excellence"
                    },
                    {
                        "value": "C52362",
                        "companyCode": "1000",
                        "text": "C52362 - UPL-CORP-Sales Commercial"
                    },
                    {
                        "value": "C52363",
                        "companyCode": "1000",
                        "text": "C52363 - Global Sustainable Solutions"
                    },
                    {
                        "value": "C52364",
                        "companyCode": "1000",
                        "text": "C52364 - UPL-CORP-Busi Transformation-Accenture"
                    },
                    {
                        "value": "C52365",
                        "companyCode": "1000",
                        "text": "C52365 - UPL-corp-Stewardship & Compliance"
                    },
                    {
                        "value": "C52401",
                        "companyCode": "1000",
                        "text": "C52401 - UPL-CORP-FINANCE COST"
                    },
                    {
                        "value": "C52402",
                        "companyCode": "1000",
                        "text": "C52402 - SCIL-CORP-FINANCE COST"
                    },
                    {
                        "value": "C52440",
                        "companyCode": "1000",
                        "text": "C52440 - UPL-CORP-UPL DIGITAL PLATFORM"
                    },
                    {
                        "value": "C52501",
                        "companyCode": "1000",
                        "text": "C52501 - UPL-CORP-ARYSTA INTEGRATION"
                    },
                    {
                        "value": "C52502",
                        "companyCode": "1000",
                        "text": "C52502 - UPL-SUPPLY CHAIN ARYSTA INTEGRATION"
                    },
                    {
                        "value": "C52503",
                        "companyCode": "1000",
                        "text": "C52503 - UPL-IT ARYSTA INTEGRATION"
                    },
                    {
                        "value": "C52504",
                        "companyCode": "1000",
                        "text": "C52504 - UPL-IT ARYSTA SUPPORT"
                    },
                    {
                        "value": "C52505",
                        "companyCode": "1000",
                        "text": "C52505 - North Europe business"
                    },
                    {
                        "value": "C52506",
                        "companyCode": "1000",
                        "text": "C52506 - South Europe business"
                    },
                    {
                        "value": "C52507",
                        "companyCode": "1000",
                        "text": "C52507 - UPL-CORP-Differentiated Solutions"
                    },
                    {
                        "value": "C52508",
                        "companyCode": "1000",
                        "text": "C52508 - ."
                    },
                    {
                        "value": "C52509",
                        "companyCode": "1000",
                        "text": "C52509 - ."
                    },
                    {
                        "value": "C52510",
                        "companyCode": "1000",
                        "text": "C52510 - ."
                    },
                    {
                        "value": "C52511",
                        "companyCode": "1000",
                        "text": "C52511 - ."
                    },
                    {
                        "value": "C52512",
                        "companyCode": "1000",
                        "text": "C52512 - UPL-MKTG-AFS"
                    },
                    {
                        "value": "C52513",
                        "companyCode": "1000",
                        "text": "C52513 - European Supply Chain – Corporate costs"
                    },
                    {
                        "value": "C52514",
                        "companyCode": "1000",
                        "text": "C52514 - UPL-Regulatory-Myanmar"
                    },
                    {
                        "value": "C52515",
                        "companyCode": "1000",
                        "text": "C52515 - ASEANZ Corporate - REGIONAL HEAD"
                    },
                    {
                        "value": "C52998",
                        "companyCode": "1000",
                        "text": "C52998 - Dummy for Budget"
                    },
                    {
                        "value": "C52999",
                        "companyCode": "1000",
                        "text": "C52999 - UPL-DUMMY"
                    },
                    {
                        "value": "C53100",
                        "companyCode": "1000",
                        "text": "C53100 - CALCUTTA ZONAL OFFICE"
                    },
                    {
                        "value": "C53101",
                        "companyCode": "1000",
                        "text": "C53101 - CALCUTTA"
                    },
                    {
                        "value": "C53102",
                        "companyCode": "1000",
                        "text": "C53102 - CUTTACK"
                    },
                    {
                        "value": "C53103",
                        "companyCode": "1000",
                        "text": "C53103 - GUWAHATI"
                    },
                    {
                        "value": "C53110",
                        "companyCode": "1000",
                        "text": "C53110 - BHATINDA - ZONAL OFFICE"
                    },
                    {
                        "value": "C53111",
                        "companyCode": "1000",
                        "text": "C53111 - BHATINDA"
                    },
                    {
                        "value": "C53112",
                        "companyCode": "1000",
                        "text": "C53112 - HISSAR"
                    },
                    {
                        "value": "C53113",
                        "companyCode": "1000",
                        "text": "C53113 - JAIPUR"
                    },
                    {
                        "value": "C53114",
                        "companyCode": "1000",
                        "text": "C53114 - LUDHIANA"
                    },
                    {
                        "value": "C53115",
                        "companyCode": "1000",
                        "text": "C53115 - SRIGANGANAGAR"
                    },
                    {
                        "value": "C53116",
                        "companyCode": "1000",
                        "text": "C53116 - KARNAL"
                    },
                    {
                        "value": "C53120",
                        "companyCode": "1000",
                        "text": "C53120 - LUCKNOW ZONAL OFFICE"
                    },
                    {
                        "value": "C53121",
                        "companyCode": "1000",
                        "text": "C53121 - LUCKNOW DEPOT"
                    },
                    {
                        "value": "C53122",
                        "companyCode": "1000",
                        "text": "C53122 - RAMPUR"
                    },
                    {
                        "value": "C53123",
                        "companyCode": "1000",
                        "text": "C53123 - RUDRAPUR"
                    },
                    {
                        "value": "C53124",
                        "companyCode": "1000",
                        "text": "C53124 - GAZIABAD"
                    },
                    {
                        "value": "C53125",
                        "companyCode": "1000",
                        "text": "C53125 - PATNA"
                    },
                    {
                        "value": "C53130",
                        "companyCode": "1000",
                        "text": "C53130 - SARKHEJ ZONAL OFFICE"
                    },
                    {
                        "value": "C53131",
                        "companyCode": "1000",
                        "text": "C53131 - AKOLA"
                    },
                    {
                        "value": "C53132",
                        "companyCode": "1000",
                        "text": "C53132 - PUNE"
                    },
                    {
                        "value": "C53133",
                        "companyCode": "1000",
                        "text": "C53133 - INDORE"
                    },
                    {
                        "value": "C53134",
                        "companyCode": "1000",
                        "text": "C53134 - RAIPUR"
                    },
                    {
                        "value": "C53135",
                        "companyCode": "1000",
                        "text": "C53135 - SARKHEJ"
                    },
                    {
                        "value": "C53136",
                        "companyCode": "1000",
                        "text": "C53136 - Pune Zonal Office"
                    },
                    {
                        "value": "C53140",
                        "companyCode": "1000",
                        "text": "C53140 - HYDERABAD ZONAL OFFICE"
                    },
                    {
                        "value": "C53141",
                        "companyCode": "1000",
                        "text": "C53141 - GUNTUR"
                    },
                    {
                        "value": "C53142",
                        "companyCode": "1000",
                        "text": "C53142 - NIZAMABAD"
                    },
                    {
                        "value": "C53143",
                        "companyCode": "1000",
                        "text": "C53143 - VIJAYWADA"
                    },
                    {
                        "value": "C53144",
                        "companyCode": "1000",
                        "text": "C53144 - KURNOOL"
                    },
                    {
                        "value": "C53145",
                        "companyCode": "1000",
                        "text": "C53145 - HYDERABAD"
                    },
                    {
                        "value": "C53149",
                        "companyCode": "1000",
                        "text": "C53149 - BANGALORE"
                    },
                    {
                        "value": "C53150",
                        "companyCode": "1000",
                        "text": "C53150 - BANGALORE ZONAL OFFICE"
                    },
                    {
                        "value": "C53151",
                        "companyCode": "1000",
                        "text": "C53151 - BELLARY"
                    },
                    {
                        "value": "C53152",
                        "companyCode": "1000",
                        "text": "C53152 - GULBARGA"
                    },
                    {
                        "value": "C53153",
                        "companyCode": "1000",
                        "text": "C53153 - DAVANAGERE"
                    },
                    {
                        "value": "C53154",
                        "companyCode": "1000",
                        "text": "C53154 - COIMBATORE"
                    },
                    {
                        "value": "C53155",
                        "companyCode": "1000",
                        "text": "C53155 - COCHIN"
                    },
                    {
                        "value": "C53160",
                        "companyCode": "1000",
                        "text": "C53160 - DELHI"
                    },
                    {
                        "value": "C53161",
                        "companyCode": "1000",
                        "text": "C53161 - ZIRAKPUR"
                    },
                    {
                        "value": "C53162",
                        "companyCode": "1000",
                        "text": "C53162 - KUNDLI"
                    },
                    {
                        "value": "C53170",
                        "companyCode": "1000",
                        "text": "C53170 - KERALA MATCHES"
                    },
                    {
                        "value": "C53171",
                        "companyCode": "1000",
                        "text": "C53171 - S V RANGASWAMY & CO"
                    },
                    {
                        "value": "C53172",
                        "companyCode": "1000",
                        "text": "C53172 - FRANCIS LESLIE & CO PVT LTD"
                    },
                    {
                        "value": "C53173",
                        "companyCode": "1000",
                        "text": "C53173 - BABU BROTHERS"
                    },
                    {
                        "value": "C53180",
                        "companyCode": "1000",
                        "text": "C53180 - DAMAN"
                    },
                    {
                        "value": "C53181",
                        "companyCode": "1000",
                        "text": "C53181 - SATTUR"
                    },
                    {
                        "value": "C53182",
                        "companyCode": "1000",
                        "text": "C53182 - UPL (CENTRAL) GODOWN"
                    },
                    {
                        "value": "C53183",
                        "companyCode": "1000",
                        "text": "C53183 - JACTO / UNISPRAY PUMPS"
                    },
                    {
                        "value": "C53184",
                        "companyCode": "1000",
                        "text": "C53184 - SUGARCANE PROJECT"
                    },
                    {
                        "value": "C53185",
                        "companyCode": "1000",
                        "text": "C53185 - COTTON MISSION II - PROJECT"
                    },
                    {
                        "value": "C53186",
                        "companyCode": "1000",
                        "text": "C53186 - ZAMBIA"
                    },
                    {
                        "value": "C53187",
                        "companyCode": "1000",
                        "text": "C53187 - DECCO/OORJA - MARKETING"
                    },
                    {
                        "value": "C53188",
                        "companyCode": "1000",
                        "text": "C53188 - LIASONING OFFICE - DELHI"
                    },
                    {
                        "value": "C53189",
                        "companyCode": "1000",
                        "text": "C53189 - Ranchi"
                    },
                    {
                        "value": "C53190",
                        "companyCode": "1000",
                        "text": "C53190 - Hyderabad (HIS6) - SCIL"
                    },
                    {
                        "value": "C53191",
                        "companyCode": "1000",
                        "text": "C53191 - Secundrabad Field Crop"
                    },
                    {
                        "value": "C53192",
                        "companyCode": "1000",
                        "text": "C53192 - Bhatinda Food Crop"
                    },
                    {
                        "value": "C53193",
                        "companyCode": "1000",
                        "text": "C53193 - Bhatinda Vegetable Crop"
                    },
                    {
                        "value": "C53194",
                        "companyCode": "1000",
                        "text": "C53194 - Calcutta Food Crop"
                    },
                    {
                        "value": "C53195",
                        "companyCode": "1000",
                        "text": "C53195 - Calcutta Vegetable Crop"
                    },
                    {
                        "value": "C53196",
                        "companyCode": "1000",
                        "text": "C53196 - Sarkhej Food Crop"
                    },
                    {
                        "value": "C53197",
                        "companyCode": "1000",
                        "text": "C53197 - Sarkhej Vegetable Crop"
                    },
                    {
                        "value": "C53198",
                        "companyCode": "1000",
                        "text": "C53198 - Pune Food Crop"
                    },
                    {
                        "value": "C53199",
                        "companyCode": "1000",
                        "text": "C53199 - Pune Vegetable Crop"
                    },
                    {
                        "value": "C53200",
                        "companyCode": "1000",
                        "text": "C53200 - Lucknow Food Crop"
                    },
                    {
                        "value": "C53201",
                        "companyCode": "1000",
                        "text": "C53201 - Lucknow Vegetable Crop"
                    },
                    {
                        "value": "C53202",
                        "companyCode": "1000",
                        "text": "C53202 - Hyderabad Food Crop"
                    },
                    {
                        "value": "C53203",
                        "companyCode": "1000",
                        "text": "C53203 - Hyderabad Vegetable Crop"
                    },
                    {
                        "value": "C53205",
                        "companyCode": "1000",
                        "text": "C53205 - Secundrabad Vegetable Crop"
                    },
                    {
                        "value": "C53206",
                        "companyCode": "1000",
                        "text": "C53206 - Banglore Food Crop"
                    },
                    {
                        "value": "C53207",
                        "companyCode": "1000",
                        "text": "C53207 - Bellary Vegetable Cr"
                    },
                    {
                        "value": "C53208",
                        "companyCode": "1000",
                        "text": "C53208 - AMRITSAR"
                    },
                    {
                        "value": "C53209",
                        "companyCode": "1000",
                        "text": "C53209 - JALANDHAR"
                    },
                    {
                        "value": "C53210",
                        "companyCode": "1000",
                        "text": "C53210 - AGRA"
                    },
                    {
                        "value": "C53211",
                        "companyCode": "1000",
                        "text": "C53211 - BAREILLY"
                    },
                    {
                        "value": "C53212",
                        "companyCode": "1000",
                        "text": "C53212 - VARANASI"
                    },
                    {
                        "value": "C53213",
                        "companyCode": "1000",
                        "text": "C53213 - UNIMART"
                    },
                    {
                        "value": "C53214",
                        "companyCode": "1000",
                        "text": "C53214 - JAIPUR Field Crop"
                    },
                    {
                        "value": "C53215",
                        "companyCode": "1000",
                        "text": "C53215 - LUDHIANA Field Crop"
                    },
                    {
                        "value": "C53216",
                        "companyCode": "1000",
                        "text": "C53216 - SRIGANGANAGAR Field Crop"
                    },
                    {
                        "value": "C53217",
                        "companyCode": "1000",
                        "text": "C53217 - AMRITSAR Field Crop"
                    },
                    {
                        "value": "C53218",
                        "companyCode": "1000",
                        "text": "C53218 - JALANDHAR Field Crop"
                    },
                    {
                        "value": "C53219",
                        "companyCode": "1000",
                        "text": "C53219 - CUTTACK Field Crop"
                    },
                    {
                        "value": "C53220",
                        "companyCode": "1000",
                        "text": "C53220 - GUWAHATI Field Crop"
                    },
                    {
                        "value": "C53221",
                        "companyCode": "1000",
                        "text": "C53221 - PATNA Field Crop"
                    },
                    {
                        "value": "C53222",
                        "companyCode": "1000",
                        "text": "C53222 - RANCHI Field Crop"
                    },
                    {
                        "value": "C53223",
                        "companyCode": "1000",
                        "text": "C53223 - INDORE Field Crop"
                    },
                    {
                        "value": "C53224",
                        "companyCode": "1000",
                        "text": "C53224 - RAIPUR Field Crop"
                    },
                    {
                        "value": "C53225",
                        "companyCode": "1000",
                        "text": "C53225 - AKOLA Field Crop"
                    },
                    {
                        "value": "C53226",
                        "companyCode": "1000",
                        "text": "C53226 - HISSAR Field Crop"
                    },
                    {
                        "value": "C53227",
                        "companyCode": "1000",
                        "text": "C53227 - KARNAL Field Crop"
                    },
                    {
                        "value": "C53228",
                        "companyCode": "1000",
                        "text": "C53228 - RUDRAPUR Field Crop"
                    },
                    {
                        "value": "C53229",
                        "companyCode": "1000",
                        "text": "C53229 - AGRA Field Crop"
                    },
                    {
                        "value": "C53230",
                        "companyCode": "1000",
                        "text": "C53230 - BAREILLY Field Crop"
                    },
                    {
                        "value": "C53231",
                        "companyCode": "1000",
                        "text": "C53231 - VARANASI Field Crop"
                    },
                    {
                        "value": "C53232",
                        "companyCode": "1000",
                        "text": "C53232 - GUNTUR Field Crop"
                    },
                    {
                        "value": "C53233",
                        "companyCode": "1000",
                        "text": "C53233 - TADEPALLIGUDEM Field Crop"
                    },
                    {
                        "value": "C53234",
                        "companyCode": "1000",
                        "text": "C53234 - NANDYAL Field Crop"
                    },
                    {
                        "value": "C53235",
                        "companyCode": "1000",
                        "text": "C53235 - WARANGAL Field Crop"
                    },
                    {
                        "value": "C53236",
                        "companyCode": "1000",
                        "text": "C53236 - BANGALORE Field Crop"
                    },
                    {
                        "value": "C53237",
                        "companyCode": "1000",
                        "text": "C53237 - HUBLI Field Crop"
                    },
                    {
                        "value": "C53238",
                        "companyCode": "1000",
                        "text": "C53238 - COIMABTORE Field Crop"
                    },
                    {
                        "value": "C53239",
                        "companyCode": "1000",
                        "text": "C53239 - KOTTAYAM Field Crop"
                    },
                    {
                        "value": "C53240",
                        "companyCode": "1000",
                        "text": "C53240 - JAIPUR Vegetable Crop"
                    },
                    {
                        "value": "C53241",
                        "companyCode": "1000",
                        "text": "C53241 - LUDHIANA Vegetable Crop"
                    },
                    {
                        "value": "C53242",
                        "companyCode": "1000",
                        "text": "C53242 - SRIGANGANAGAR Vegetable Crop"
                    },
                    {
                        "value": "C53243",
                        "companyCode": "1000",
                        "text": "C53243 - AMRITSAR Vegetable Crop"
                    },
                    {
                        "value": "C53244",
                        "companyCode": "1000",
                        "text": "C53244 - JALANDHAR Vegetable Crop"
                    },
                    {
                        "value": "C53245",
                        "companyCode": "1000",
                        "text": "C53245 - CUTTACK Vegetable Crop"
                    },
                    {
                        "value": "C53246",
                        "companyCode": "1000",
                        "text": "C53246 - GUWAHATI Vegetable Crop"
                    },
                    {
                        "value": "C53247",
                        "companyCode": "1000",
                        "text": "C53247 - PATNA Vegetable Crop"
                    },
                    {
                        "value": "C53248",
                        "companyCode": "1000",
                        "text": "C53248 - RANCHI Vegetable Crop"
                    },
                    {
                        "value": "C53249",
                        "companyCode": "1000",
                        "text": "C53249 - INDORE Vegetable Crop"
                    },
                    {
                        "value": "C53250",
                        "companyCode": "1000",
                        "text": "C53250 - RAIPUR Vegetable Crop"
                    },
                    {
                        "value": "C53251",
                        "companyCode": "1000",
                        "text": "C53251 - Nasik Vegetable Crop"
                    },
                    {
                        "value": "C53252",
                        "companyCode": "1000",
                        "text": "C53252 - HISSAR Vegetable Crop"
                    },
                    {
                        "value": "C53253",
                        "companyCode": "1000",
                        "text": "C53253 - KARNAL Vegetable Crop"
                    },
                    {
                        "value": "C53254",
                        "companyCode": "1000",
                        "text": "C53254 - RUDRAPUR Vegetable Crop"
                    },
                    {
                        "value": "C53255",
                        "companyCode": "1000",
                        "text": "C53255 - AGRA Vegetable Crop"
                    },
                    {
                        "value": "C53256",
                        "companyCode": "1000",
                        "text": "C53256 - GAZIABAD Vegetable Crop"
                    },
                    {
                        "value": "C53257",
                        "companyCode": "1000",
                        "text": "C53257 - VARANASI Vegetable Crop"
                    },
                    {
                        "value": "C53258",
                        "companyCode": "1000",
                        "text": "C53258 - GUNTUR Vegetable Crop"
                    },
                    {
                        "value": "C53259",
                        "companyCode": "1000",
                        "text": "C53259 - TADEPALLIGUDEM Vegetable Crop"
                    },
                    {
                        "value": "C53260",
                        "companyCode": "1000",
                        "text": "C53260 - NANDYAL Vegetable Crop"
                    },
                    {
                        "value": "C53261",
                        "companyCode": "1000",
                        "text": "C53261 - WARANGAL Vegetable Crop"
                    },
                    {
                        "value": "C53262",
                        "companyCode": "1000",
                        "text": "C53262 - BANGALORE Vegetable Crop"
                    },
                    {
                        "value": "C53263",
                        "companyCode": "1000",
                        "text": "C53263 - HUBLI Vegetable Crop"
                    },
                    {
                        "value": "C53264",
                        "companyCode": "1000",
                        "text": "C53264 - COIMABTORE Vegetable Crop"
                    },
                    {
                        "value": "C53265",
                        "companyCode": "1000",
                        "text": "C53265 - KOTTAYAM Vegetable Crop"
                    },
                    {
                        "value": "C53266",
                        "companyCode": "1000",
                        "text": "C53266 - AURANGABAD"
                    },
                    {
                        "value": "C53267",
                        "companyCode": "1000",
                        "text": "C53267 - AURANGABAD Field Crop"
                    },
                    {
                        "value": "C53268",
                        "companyCode": "1000",
                        "text": "C53268 - RAJASTHAN ZONAL OFFICE"
                    },
                    {
                        "value": "C53269",
                        "companyCode": "1000",
                        "text": "C53269 - Mother Godown - Hissar"
                    },
                    {
                        "value": "C53270",
                        "companyCode": "1000",
                        "text": "C53270 - BHOPAL"
                    },
                    {
                        "value": "C53271",
                        "companyCode": "1000",
                        "text": "C53271 - BHOPAL - FIELD CROP"
                    },
                    {
                        "value": "C53272",
                        "companyCode": "1000",
                        "text": "C53272 - BHOPAL - VEGETABLE CROP"
                    },
                    {
                        "value": "C53273",
                        "companyCode": "1000",
                        "text": "C53273 - BHATINDA - ZONAL OFFICE - FIELD CROP"
                    },
                    {
                        "value": "C53274",
                        "companyCode": "1000",
                        "text": "C53274 - BHATINDA - ZONAL OFFICE - VEGETABLE CROP"
                    },
                    {
                        "value": "C53275",
                        "companyCode": "1000",
                        "text": "C53275 - RAJASTHAN ZONAL OFFICE - FIELD CROP"
                    },
                    {
                        "value": "C53276",
                        "companyCode": "1000",
                        "text": "C53276 - RAJASTHAN ZONAL OFFICE - VEGETABLE CROP"
                    },
                    {
                        "value": "C53277",
                        "companyCode": "1000",
                        "text": "C53277 - CALCUTTA ZONAL OFFICE - FIELD CROP"
                    },
                    {
                        "value": "C53278",
                        "companyCode": "1000",
                        "text": "C53278 - CALCUTTA ZONAL OFFICE - VEGETABLE CROP"
                    },
                    {
                        "value": "C53279",
                        "companyCode": "1000",
                        "text": "C53279 - SARKHEJ ZONAL OFFICE - FIELD CROP"
                    },
                    {
                        "value": "C53280",
                        "companyCode": "1000",
                        "text": "C53280 - SARKHEJ ZONAL OFFICE - VEGETABLE CROP"
                    },
                    {
                        "value": "C53281",
                        "companyCode": "1000",
                        "text": "C53281 - PUNE ZONZL OFFICE - FIELD CROP"
                    },
                    {
                        "value": "C53282",
                        "companyCode": "1000",
                        "text": "C53282 - PUNE ZONZL OFFICE - VEGETABLE CROP"
                    },
                    {
                        "value": "C53283",
                        "companyCode": "1000",
                        "text": "C53283 - LUCKNOW ZONAL OFFICE - FIELD CROP"
                    },
                    {
                        "value": "C53284",
                        "companyCode": "1000",
                        "text": "C53284 - LUCKNOW ZONAL OFFICE - VEGETABLE CROP"
                    },
                    {
                        "value": "C53285",
                        "companyCode": "1000",
                        "text": "C53285 - HYDERABAD ZONAL OFFICE - FIELD CROP"
                    },
                    {
                        "value": "C53286",
                        "companyCode": "1000",
                        "text": "C53286 - HYDERABAD ZONAL OFFICE - VEGETABLE CROP"
                    },
                    {
                        "value": "C53287",
                        "companyCode": "1000",
                        "text": "C53287 - BANGALORE ZONAL OFFICE - FIELD CROP"
                    },
                    {
                        "value": "C53288",
                        "companyCode": "1000",
                        "text": "C53288 - BANGALORE ZONAL OFFICE - VEGETABLE CROP"
                    },
                    {
                        "value": "C53289",
                        "companyCode": "1000",
                        "text": "C53289 - UNIMART - JANDIALA GURU"
                    },
                    {
                        "value": "C53290",
                        "companyCode": "1000",
                        "text": "C53290 - MAKKHAN GRASS - FIELD CROP"
                    },
                    {
                        "value": "C53291",
                        "companyCode": "1000",
                        "text": "C53291 - UNIMART - HANSI"
                    },
                    {
                        "value": "C53292",
                        "companyCode": "1000",
                        "text": "C53292 - CANOLA - FIELD CROP"
                    },
                    {
                        "value": "C53293",
                        "companyCode": "1000",
                        "text": "C53293 - Jodhpur"
                    },
                    {
                        "value": "C53294",
                        "companyCode": "1000",
                        "text": "C53294 - NAGPUR - VEGETABLE CROP"
                    },
                    {
                        "value": "C53295",
                        "companyCode": "1000",
                        "text": "C53295 - JABALPUR"
                    },
                    {
                        "value": "C53296",
                        "companyCode": "1000",
                        "text": "C53296 - BARODA"
                    },
                    {
                        "value": "C53297",
                        "companyCode": "1000",
                        "text": "C53297 - SURENDRANAGAR"
                    },
                    {
                        "value": "C53298",
                        "companyCode": "1000",
                        "text": "C53298 - DHORAJI"
                    },
                    {
                        "value": "C53299",
                        "companyCode": "1000",
                        "text": "C53299 - INDORE [ SOYA ZONE ]"
                    },
                    {
                        "value": "C53300",
                        "companyCode": "1000",
                        "text": "C53300 - RAIPUR [ RICE ZONE ]"
                    },
                    {
                        "value": "C53301",
                        "companyCode": "1000",
                        "text": "C53301 - CENTRAL BENGAL"
                    },
                    {
                        "value": "C53302",
                        "companyCode": "1000",
                        "text": "C53302 - SOUTH BENGAL"
                    },
                    {
                        "value": "C53303",
                        "companyCode": "1000",
                        "text": "C53303 - NANDED"
                    },
                    {
                        "value": "C53304",
                        "companyCode": "1000",
                        "text": "C53304 - UNIMART - MHOW"
                    },
                    {
                        "value": "C53305",
                        "companyCode": "1000",
                        "text": "C53305 - UNIMART - ABOHAR"
                    },
                    {
                        "value": "C53306",
                        "companyCode": "1000",
                        "text": "C53306 - Mother Godown - Akola"
                    },
                    {
                        "value": "C53307",
                        "companyCode": "1000",
                        "text": "C53307 - Nellore"
                    },
                    {
                        "value": "C53308",
                        "companyCode": "1000",
                        "text": "C53308 - Rohtak"
                    },
                    {
                        "value": "C53309",
                        "companyCode": "1000",
                        "text": "C53309 - HP-J&K"
                    },
                    {
                        "value": "C53310",
                        "companyCode": "1000",
                        "text": "C53310 - Faizabad - FC"
                    },
                    {
                        "value": "C53311",
                        "companyCode": "1000",
                        "text": "C53311 - Nagpur"
                    },
                    {
                        "value": "C53312",
                        "companyCode": "1000",
                        "text": "C53312 - Nasik"
                    },
                    {
                        "value": "C53313",
                        "companyCode": "1000",
                        "text": "C53313 - North Bengal"
                    },
                    {
                        "value": "C53314",
                        "companyCode": "1000",
                        "text": "C53314 - Bhagalpur - FC"
                    },
                    {
                        "value": "C53315",
                        "companyCode": "1000",
                        "text": "C53315 - RAJAMUNDRY"
                    },
                    {
                        "value": "C53316",
                        "companyCode": "1000",
                        "text": "C53316 - GUNTUR ZONAL OFFICE"
                    },
                    {
                        "value": "C53317",
                        "companyCode": "1000",
                        "text": "C53317 - ALP- MARKETING"
                    },
                    {
                        "value": "C53318",
                        "companyCode": "1000",
                        "text": "C53318 - UPL-AURANGABAD_AF"
                    },
                    {
                        "value": "C53319",
                        "companyCode": "1000",
                        "text": "C53319 - UPL-BANGALORE_AF"
                    },
                    {
                        "value": "C53320",
                        "companyCode": "1000",
                        "text": "C53320 - UPL-BELLARY_AF"
                    },
                    {
                        "value": "C53321",
                        "companyCode": "1000",
                        "text": "C53321 - UPL-BHOPAL_AF"
                    },
                    {
                        "value": "C53322",
                        "companyCode": "1000",
                        "text": "C53322 - UPL-CENTRAL_BENGAL_AF"
                    },
                    {
                        "value": "C53323",
                        "companyCode": "1000",
                        "text": "C53323 - UPL-COIMBATORE_AF"
                    },
                    {
                        "value": "C53324",
                        "companyCode": "1000",
                        "text": "C53324 - UPL-GUNTUR_AF"
                    },
                    {
                        "value": "C53325",
                        "companyCode": "1000",
                        "text": "C53325 - UPL-GUWAHATI_AF"
                    },
                    {
                        "value": "C53326",
                        "companyCode": "1000",
                        "text": "C53326 - UPL-HYDERABAD_AF"
                    },
                    {
                        "value": "C53327",
                        "companyCode": "1000",
                        "text": "C53327 - UPL-INDORE_AF"
                    },
                    {
                        "value": "C53328",
                        "companyCode": "1000",
                        "text": "C53328 - UPL-JABALPUR_AF"
                    },
                    {
                        "value": "C53329",
                        "companyCode": "1000",
                        "text": "C53329 - UPL-KURNOOL_AF"
                    },
                    {
                        "value": "C53330",
                        "companyCode": "1000",
                        "text": "C53330 - UPL-NAGPUR_AF"
                    },
                    {
                        "value": "C53331",
                        "companyCode": "1000",
                        "text": "C53331 - UPL-NASHIK_AF"
                    },
                    {
                        "value": "C53332",
                        "companyCode": "1000",
                        "text": "C53332 - UPL-NIZAMABAD_WARANGAL_AF"
                    },
                    {
                        "value": "C53333",
                        "companyCode": "1000",
                        "text": "C53333 - UPL-PATNA_AF"
                    },
                    {
                        "value": "C53334",
                        "companyCode": "1000",
                        "text": "C53334 - UPL-PUNE_AF"
                    },
                    {
                        "value": "C53335",
                        "companyCode": "1000",
                        "text": "C53335 - UPL-RAJAHMUNDRY_AF"
                    },
                    {
                        "value": "C53336",
                        "companyCode": "1000",
                        "text": "C53336 - UPL-SOU_BENGAL_&_ODIS_AF"
                    },
                    {
                        "value": "C53337",
                        "companyCode": "1000",
                        "text": "C53337 - UPL-VIJAYWADA_AF"
                    },
                    {
                        "value": "C53338",
                        "companyCode": "1000",
                        "text": "C53338 - UPL-AHMEDABAD_AF"
                    },
                    {
                        "value": "C53339",
                        "companyCode": "1000",
                        "text": "C53339 - UPL-RAJKOT_AF"
                    },
                    {
                        "value": "C53340",
                        "companyCode": "1000",
                        "text": "C53340 - UPL-BHATINDA_AF"
                    },
                    {
                        "value": "C53341",
                        "companyCode": "1000",
                        "text": "C53341 - UPL-LUDHIANA_AF"
                    },
                    {
                        "value": "C53342",
                        "companyCode": "1000",
                        "text": "C53342 - UPL-HISSAR_AF"
                    },
                    {
                        "value": "C53343",
                        "companyCode": "1000",
                        "text": "C53343 - UPL-SRIGANGANAGAR_AF"
                    },
                    {
                        "value": "C53344",
                        "companyCode": "1000",
                        "text": "C53344 - UPL-JAIPUR_AF"
                    },
                    {
                        "value": "C53345",
                        "companyCode": "1000",
                        "text": "C53345 - UPL-JODHPUR_AF"
                    },
                    {
                        "value": "C53346",
                        "companyCode": "1000",
                        "text": "C53346 - UPL-LUCKNOW_AF"
                    },
                    {
                        "value": "C53347",
                        "companyCode": "1000",
                        "text": "C53347 - UPL-GHAZIABAD_AF"
                    },
                    {
                        "value": "C53348",
                        "companyCode": "1000",
                        "text": "C53348 - UPL-RAIPUR_AF"
                    },
                    {
                        "value": "C53349",
                        "companyCode": "1000",
                        "text": "C53349 - UPL-SILIGURI_AF"
                    },
                    {
                        "value": "C53350",
                        "companyCode": "1000",
                        "text": "C53350 - JABALPUR OFFICE - FIELD CROP"
                    },
                    {
                        "value": "C53351",
                        "companyCode": "1000",
                        "text": "C53351 - Ground Nut Projects"
                    },
                    {
                        "value": "C53352",
                        "companyCode": "1000",
                        "text": "C53352 - Regulatory-Swal-IN"
                    },
                    {
                        "value": "C53353",
                        "companyCode": "1000",
                        "text": "C53353 - Field R&D-Swal-IN"
                    },
                    {
                        "value": "C53354",
                        "companyCode": "1000",
                        "text": "C53354 - Regulatory-AF-IN"
                    },
                    {
                        "value": "C53355",
                        "companyCode": "1000",
                        "text": "C53355 - Field R&D-AF-IN"
                    },
                    {
                        "value": "C53356",
                        "companyCode": "1000",
                        "text": "C53356 - Business Lead_Forages"
                    },
                    {
                        "value": "C53357",
                        "companyCode": "1000",
                        "text": "C53357 - Ludhiana Forages"
                    },
                    {
                        "value": "C53358",
                        "companyCode": "1000",
                        "text": "C53358 - Hissar Forages"
                    },
                    {
                        "value": "C53359",
                        "companyCode": "1000",
                        "text": "C53359 - Jabalpur Forages"
                    },
                    {
                        "value": "C53360",
                        "companyCode": "1000",
                        "text": "C53360 - Faizabad Forages"
                    },
                    {
                        "value": "C53361",
                        "companyCode": "1000",
                        "text": "C53361 - Barelly Forages"
                    },
                    {
                        "value": "C53362",
                        "companyCode": "1000",
                        "text": "C53362 - Merut Forages"
                    },
                    {
                        "value": "C53363",
                        "companyCode": "1000",
                        "text": "C53363 - Ahmedabad Forages"
                    },
                    {
                        "value": "C53364",
                        "companyCode": "1000",
                        "text": "C53364 - Aurangabad Forages"
                    },
                    {
                        "value": "C53365",
                        "companyCode": "1000",
                        "text": "C53365 - Bangalore Forages"
                    },
                    {
                        "value": "C53366",
                        "companyCode": "1000",
                        "text": "C53366 - Warangal Forages"
                    },
                    {
                        "value": "C53367",
                        "companyCode": "1000",
                        "text": "C53367 - Patna Forages"
                    },
                    {
                        "value": "C53368",
                        "companyCode": "1000",
                        "text": "C53368 - Raipur Forages"
                    },
                    {
                        "value": "C53369",
                        "companyCode": "1000",
                        "text": "C53369 - Ranchi Forages"
                    },
                    {
                        "value": "C53370",
                        "companyCode": "1000",
                        "text": "C53370 - SAIB Forages"
                    },
                    {
                        "value": "C53371",
                        "companyCode": "1000",
                        "text": "C53371 - Cuttack Forages"
                    },
                    {
                        "value": "C53372",
                        "companyCode": "1000",
                        "text": "C53372 - Guwahati Forages"
                    },
                    {
                        "value": "C53373",
                        "companyCode": "1000",
                        "text": "C53373 - TD Forages"
                    },
                    {
                        "value": "C53374",
                        "companyCode": "1000",
                        "text": "C53374 - Bhatinda Cotton_Agro Formulation"
                    },
                    {
                        "value": "C53375",
                        "companyCode": "1000",
                        "text": "C53375 - Haryana Cotton_Agro Formulation"
                    },
                    {
                        "value": "C53376",
                        "companyCode": "1000",
                        "text": "C53376 - Sriganganagar Cotton_Agro Formulation"
                    },
                    {
                        "value": "C53377",
                        "companyCode": "1000",
                        "text": "C53377 - Punjab Paddy_Agro Formulation"
                    },
                    {
                        "value": "C53378",
                        "companyCode": "1000",
                        "text": "C53378 - Haryana Paddy_Agro Formulation"
                    },
                    {
                        "value": "C53379",
                        "companyCode": "1000",
                        "text": "C53379 - North Bengal_Agro Formulation"
                    },
                    {
                        "value": "C53380",
                        "companyCode": "1000",
                        "text": "C53380 - Odisha_Agro Formulation"
                    },
                    {
                        "value": "C53381",
                        "companyCode": "1000",
                        "text": "C53381 - SBU5"
                    },
                    {
                        "value": "C53382",
                        "companyCode": "1000",
                        "text": "C53382 - UPL-IND-Marketing"
                    },
                    {
                        "value": "C53383",
                        "companyCode": "1000",
                        "text": "C53383 - UPL-IND-Sales"
                    },
                    {
                        "value": "C53384",
                        "companyCode": "1000",
                        "text": "C53384 - UPL-IND-Finance"
                    },
                    {
                        "value": "C53385",
                        "companyCode": "1000",
                        "text": "C53385 - UPL-IND-Human Resources"
                    },
                    {
                        "value": "C53386",
                        "companyCode": "1000",
                        "text": "C53386 - UPL-IND-Marketing"
                    },
                    {
                        "value": "C53387",
                        "companyCode": "1000",
                        "text": "C53387 - UPL-IND-Sales"
                    },
                    {
                        "value": "C53388",
                        "companyCode": "1000",
                        "text": "C53388 - UPL-IND-Finance"
                    },
                    {
                        "value": "C53389",
                        "companyCode": "1000",
                        "text": "C53389 - UPL-IND-Human Resources"
                    },
                    {
                        "value": "C53390",
                        "companyCode": "1000",
                        "text": "C53390 - UPL-IND-Logistic"
                    },
                    {
                        "value": "C53391",
                        "companyCode": "1000",
                        "text": "C53391 - UPL-IND-Marketing"
                    },
                    {
                        "value": "C53392",
                        "companyCode": "1000",
                        "text": "C53392 - UPL-IND-Sales"
                    },
                    {
                        "value": "C53393",
                        "companyCode": "1000",
                        "text": "C53393 - UPL-IND-Finance"
                    },
                    {
                        "value": "C53394",
                        "companyCode": "1000",
                        "text": "C53394 - UPL-IND-Human Resources"
                    },
                    {
                        "value": "C53395",
                        "companyCode": "1000",
                        "text": "C53395 - UPL-IND-Marketing"
                    },
                    {
                        "value": "C53396",
                        "companyCode": "1000",
                        "text": "C53396 - UPL-IND-Sales"
                    },
                    {
                        "value": "C53397",
                        "companyCode": "1000",
                        "text": "C53397 - UPL-IND-Finance"
                    },
                    {
                        "value": "C53398",
                        "companyCode": "1000",
                        "text": "C53398 - UPL-IND-Human Resources"
                    },
                    {
                        "value": "C53399",
                        "companyCode": "1000",
                        "text": "C53399 - UPL-IND-Logistic"
                    },
                    {
                        "value": "C53400",
                        "companyCode": "1000",
                        "text": "C53400 - UPL-IND-Marketing"
                    },
                    {
                        "value": "C53401",
                        "companyCode": "1000",
                        "text": "C53401 - UPL-IND-Sales"
                    },
                    {
                        "value": "C53402",
                        "companyCode": "1000",
                        "text": "C53402 - UPL-IND-Finance"
                    },
                    {
                        "value": "C53403",
                        "companyCode": "1000",
                        "text": "C53403 - UPL-IND-Human Resources"
                    },
                    {
                        "value": "C53404",
                        "companyCode": "1000",
                        "text": "C53404 - UPL-CORP-CORP.ENVIRONMENT RESPONSIBILITY"
                    },
                    {
                        "value": "C53405",
                        "companyCode": "1000",
                        "text": "C53405 - Akola Vegetable Crops"
                    },
                    {
                        "value": "C53406",
                        "companyCode": "1000",
                        "text": "C53406 - Ahmednagar Fld Crops"
                    },
                    {
                        "value": "C53407",
                        "companyCode": "1000",
                        "text": "C53407 - Meerut Field Crop"
                    },
                    {
                        "value": "C53408",
                        "companyCode": "1000",
                        "text": "C53408 - Surat Field Crop"
                    },
                    {
                        "value": "C53409",
                        "companyCode": "1000",
                        "text": "C53409 - Forage South West"
                    },
                    {
                        "value": "C53410",
                        "companyCode": "1000",
                        "text": "C53410 - SWAL Marketing"
                    },
                    {
                        "value": "C53411",
                        "companyCode": "1000",
                        "text": "C53411 - SWAL Sales"
                    },
                    {
                        "value": "C53412",
                        "companyCode": "1000",
                        "text": "C53412 - SWAL Finance"
                    },
                    {
                        "value": "C53413",
                        "companyCode": "1000",
                        "text": "C53413 - SWAL Human Resources"
                    },
                    {
                        "value": "C53414",
                        "companyCode": "1000",
                        "text": "C53414 - SWAL Logistics"
                    },
                    {
                        "value": "C53415",
                        "companyCode": "1200",
                        "text": "C53415 - SWAL Aurangabad Depot"
                    },
                    {
                        "value": "C53416",
                        "companyCode": "1200",
                        "text": "C53416 - SWAL Bhopal Depot"
                    },
                    {
                        "value": "C53417",
                        "companyCode": "1000",
                        "text": "C53417 - Innovation Fund-India"
                    },
                    {
                        "value": "C53418",
                        "companyCode": "1000",
                        "text": "C53418 - Innovation Fund-Nepal"
                    },
                    {
                        "value": "C53419",
                        "companyCode": "1000",
                        "text": "C53419 - Jammu & Kashmir_AF Zn"
                    },
                    {
                        "value": "C53420",
                        "companyCode": "1000",
                        "text": "C53420 - Jalgaon_AF Zn"
                    },
                    {
                        "value": "C53421",
                        "companyCode": "1000",
                        "text": "C53421 - HYDERABAD ZONE AF"
                    },
                    {
                        "value": "C53422",
                        "companyCode": "1000",
                        "text": "C53422 - NIZAMABAD_WARANGAL ZONE"
                    },
                    {
                        "value": "C53423",
                        "companyCode": "1000",
                        "text": "C53423 - DERDEPOORT Factory"
                    },
                    {
                        "value": "C53424",
                        "companyCode": "1000",
                        "text": "C53424 - Telesense Project"
                    },
                    {
                        "value": "C53425",
                        "companyCode": "1000",
                        "text": "C53425 - Bargarh_AF"
                    },
                    {
                        "value": "C53426",
                        "companyCode": "1000",
                        "text": "C53426 - UPL-CORP-NORTH AMERICA SUPPLY CHAIN"
                    },
                    {
                        "value": "C53427",
                        "companyCode": "1000",
                        "text": "C53427 - ADV Forage Crops E-com"
                    },
                    {
                        "value": "C53428",
                        "companyCode": "1000",
                        "text": "C53428 - ADV Field Crops E-Com"
                    },
                    {
                        "value": "C53429",
                        "companyCode": "1000",
                        "text": "C53429 - ADV Vegetable Crops E-com"
                    },
                    {
                        "value": "C61101",
                        "companyCode": "1600",
                        "text": "C61101 - Decco- Product"
                    },
                    {
                        "value": "C61102",
                        "companyCode": "1600",
                        "text": "C61102 - NPPL – Biological Products"
                    },
                    {
                        "value": "C61201",
                        "companyCode": "1600",
                        "text": "C61201 - UPL-PL61-POWER"
                    },
                    {
                        "value": "C61205",
                        "companyCode": "1600",
                        "text": "C61205 - UPL-PL61-DG HOUSE"
                    },
                    {
                        "value": "C61213",
                        "companyCode": "1600",
                        "text": "C61213 - UPL-PL61-GENERATOR HOUSE"
                    },
                    {
                        "value": "C61301",
                        "companyCode": "1600",
                        "text": "C61301 - UPL-PL61-MECHANICAL"
                    },
                    {
                        "value": "C61303",
                        "companyCode": "1600",
                        "text": "C61303 - UPL-PL61-INSTRUMENT"
                    },
                    {
                        "value": "C61304",
                        "companyCode": "1600",
                        "text": "C61304 - UPL-PL61-CIVIL"
                    },
                    {
                        "value": "C61401",
                        "companyCode": "1600",
                        "text": "C61401 - UPL-PL61-ACCOUNTS"
                    },
                    {
                        "value": "C61403",
                        "companyCode": "1600",
                        "text": "C61403 - UPL-PL61-STORES"
                    },
                    {
                        "value": "C61404",
                        "companyCode": "1600",
                        "text": "C61404 - UPL-PL61-COMMERCIAL"
                    },
                    {
                        "value": "C61501",
                        "companyCode": "1600",
                        "text": "C61501 - UPL-PL61-ADMIN"
                    },
                    {
                        "value": "C61502",
                        "companyCode": "1600",
                        "text": "C61502 - UPL-PL61-SECURITY"
                    },
                    {
                        "value": "C61503",
                        "companyCode": "1600",
                        "text": "C61503 - UPL-PL61-PERSONNEL"
                    },
                    {
                        "value": "C61505",
                        "companyCode": "1600",
                        "text": "C61505 - UPL-PL61-IT"
                    },
                    {
                        "value": "C61506",
                        "companyCode": "1600",
                        "text": "C61506 - UPL-PL61-WELFARE & CANTEEN"
                    },
                    {
                        "value": "C61507",
                        "companyCode": "1600",
                        "text": "C61507 - UPL-PL61-QC LAB"
                    },
                    {
                        "value": "C61508",
                        "companyCode": "1600",
                        "text": "C61508 - UPL-PL61-SAFETY"
                    },
                    {
                        "value": "C61509",
                        "companyCode": "1600",
                        "text": "C61509 - NPPL - R&D expenses"
                    },
                    {
                        "value": "C61510",
                        "companyCode": "1600",
                        "text": "C61510 - UPL-PL61-MAX PRO"
                    },
                    {
                        "value": "C61511",
                        "companyCode": "1600",
                        "text": "C61511 - UPL-PL61-ETP"
                    },
                    {
                        "value": "C61514",
                        "companyCode": "1600",
                        "text": "C61514 - UPL-PL61-CONTRACT MANUFACTURING"
                    },
                    {
                        "value": "C61523",
                        "companyCode": "1600",
                        "text": "C61523 - UPL-PL61-CSR"
                    },
                    {
                        "value": "C61525",
                        "companyCode": "1600",
                        "text": "C61525 - Manufacturing Management Banglore PL61"
                    },
                    {
                        "value": "C61601",
                        "companyCode": "1600",
                        "text": "C61601 - UPL-PL61-STANDSTILL"
                    },
                    {
                        "value": "C61602",
                        "companyCode": "1600",
                        "text": "C61602 - UPL-PL61-DESPATCH"
                    },
                    {
                        "value": "C61614",
                        "companyCode": "1600",
                        "text": "C61614 - UPL-PL61-PACK DEV"
                    },
                    {
                        "value": "C70000",
                        "companyCode": "1200",
                        "text": "C70000 - SWAL -HALDIA- TECHNICAL"
                    },
                    {
                        "value": "C70001",
                        "companyCode": "1200",
                        "text": "C70001 - SWAL-HALDIA-SOLID/ACEPHATE FORMULATION"
                    },
                    {
                        "value": "C70002",
                        "companyCode": "1200",
                        "text": "C70002 - SWAL-HALDIA-LIQUID FORMULATION"
                    },
                    {
                        "value": "C70011",
                        "companyCode": "1200",
                        "text": "C70011 - SWAL-HALDIA-POWER"
                    },
                    {
                        "value": "C70012",
                        "companyCode": "1200",
                        "text": "C70012 - SWAL-HALDIA-BOILER"
                    },
                    {
                        "value": "C70013",
                        "companyCode": "1200",
                        "text": "C70013 - SWAL-HALDIA-REFRIGERATION"
                    },
                    {
                        "value": "C70014",
                        "companyCode": "1200",
                        "text": "C70014 - SWAL-HALDIA-COOLING TOWER"
                    },
                    {
                        "value": "C70015",
                        "companyCode": "1200",
                        "text": "C70015 - SWAL-HALDIA-DG SET"
                    },
                    {
                        "value": "C70018",
                        "companyCode": "1200",
                        "text": "C70018 - SWAL-HALDIA-MAINTENANCE"
                    },
                    {
                        "value": "C70021",
                        "companyCode": "1200",
                        "text": "C70021 - SWAL-HALDIA-ACCOUNTS"
                    },
                    {
                        "value": "C70022",
                        "companyCode": "1200",
                        "text": "C70022 - SWAL-HALDIA-STORES"
                    },
                    {
                        "value": "C70023",
                        "companyCode": "1200",
                        "text": "C70023 - SWAL-HALDIA-EXCISE"
                    },
                    {
                        "value": "C70024",
                        "companyCode": "1200",
                        "text": "C70024 - SWAL-HALDIA-PURCHASE"
                    },
                    {
                        "value": "C70028",
                        "companyCode": "1200",
                        "text": "C70028 - SWAL-HALDIA-ADMINISTRATION"
                    },
                    {
                        "value": "C70029",
                        "companyCode": "1200",
                        "text": "C70029 - SWAL-HALDIA-FACTORY MANAGEMENT"
                    },
                    {
                        "value": "C70030",
                        "companyCode": "1200",
                        "text": "C70030 - SWAL-HALDIA-EFFLUENT TREATMENT PLANT"
                    },
                    {
                        "value": "C70031",
                        "companyCode": "1200",
                        "text": "C70031 - SWAL-HALDIA-LABORATORY"
                    },
                    {
                        "value": "C70032",
                        "companyCode": "1200",
                        "text": "C70032 - SWAL-HALDIA-TOWNSHIP - RESIDENTIAL COMPL"
                    },
                    {
                        "value": "C70033",
                        "companyCode": "1200",
                        "text": "C70033 - SWAL-HALDIA-GUEST HOUSE"
                    },
                    {
                        "value": "C70034",
                        "companyCode": "1200",
                        "text": "C70034 - SWAL-HALDIA-SAFETY & ENVIRONMENT"
                    },
                    {
                        "value": "C70035",
                        "companyCode": "1200",
                        "text": "C70035 - SWAL-HALDIA-WATER TREATMENT PLANT"
                    },
                    {
                        "value": "C70036",
                        "companyCode": "1200",
                        "text": "C70036 - SWAL-HALDIA-MERGING WITH UPL"
                    },
                    {
                        "value": "C70039",
                        "companyCode": "1200",
                        "text": "C70039 - SWAL-HALDIA-STANDSTILL"
                    },
                    {
                        "value": "C70040",
                        "companyCode": "1200",
                        "text": "C70040 - SWAL-KARAMADAI -FERTILISER"
                    },
                    {
                        "value": "C70041",
                        "companyCode": "1200",
                        "text": "C70041 - SWAL - KARAMADAI- ADMINISTRATION"
                    },
                    {
                        "value": "C70045",
                        "companyCode": "1200",
                        "text": "C70045 - SWAL-KOTTAYAM -FERTILISER"
                    },
                    {
                        "value": "C70046",
                        "companyCode": "1200",
                        "text": "C70046 - SWAL - KOTTAYAM - ADMINISTRATION"
                    },
                    {
                        "value": "C70051",
                        "companyCode": "1200",
                        "text": "C70051 - SWAL-CALICUT-FERTILISER"
                    },
                    {
                        "value": "C70052",
                        "companyCode": "1200",
                        "text": "C70052 - SWAL - CALICUT- ADMINISTRATION"
                    },
                    {
                        "value": "C70053",
                        "companyCode": "1200",
                        "text": "C70053 - SWAL-NASHIK -FERTILISER"
                    },
                    {
                        "value": "C70054",
                        "companyCode": "1200",
                        "text": "C70054 - SWAL-NASHIK-ADMINISTRATION"
                    },
                    {
                        "value": "C70055",
                        "companyCode": "1200",
                        "text": "C70055 - SWAL-KANNUR-FERTLISER"
                    },
                    {
                        "value": "C70056",
                        "companyCode": "1200",
                        "text": "C70056 - SWAL-KANNUR-ADMINISTRATION"
                    },
                    {
                        "value": "C70060",
                        "companyCode": "1200",
                        "text": "C70060 - SW-CORP-FINANCE & ACCOUNTS"
                    },
                    {
                        "value": "C70061",
                        "companyCode": "1200",
                        "text": "C70061 - SW-CORP-PURCHASE"
                    },
                    {
                        "value": "C70062",
                        "companyCode": "1200",
                        "text": "C70062 - SW-CORP-INFORMATION & SYSTEM"
                    },
                    {
                        "value": "C70063",
                        "companyCode": "1200",
                        "text": "C70063 - SW-CORP-DIRECTOR"
                    },
                    {
                        "value": "C70064",
                        "companyCode": "1200",
                        "text": "C70064 - SW-CORP-FINANCE COST"
                    },
                    {
                        "value": "C70065",
                        "companyCode": "1200",
                        "text": "C70065 - SW-CORP-FERTILISER"
                    },
                    {
                        "value": "C70068",
                        "companyCode": "1200",
                        "text": "C70068 - SWAL- AGRO MARKETING"
                    },
                    {
                        "value": "C70069",
                        "companyCode": "1200",
                        "text": "C70069 - SWAL- FERT MARKETING"
                    },
                    {
                        "value": "C70070",
                        "companyCode": "1200",
                        "text": "C70070 - Chandigarh Zonal office"
                    },
                    {
                        "value": "C70071",
                        "companyCode": "1200",
                        "text": "C70071 - SWAL - HISSAR DEPOT"
                    },
                    {
                        "value": "C70072",
                        "companyCode": "1200",
                        "text": "C70072 - SWAL- BHATINDA DEPOT"
                    },
                    {
                        "value": "C70073",
                        "companyCode": "1200",
                        "text": "C70073 - SWAL-GAZIABAD DEPOT"
                    },
                    {
                        "value": "C70075",
                        "companyCode": "1200",
                        "text": "C70075 - Kolkta Zonal office"
                    },
                    {
                        "value": "C70076",
                        "companyCode": "1200",
                        "text": "C70076 - SWAL- GUWAHATI DEPOT"
                    },
                    {
                        "value": "C70077",
                        "companyCode": "1200",
                        "text": "C70077 - SWAL- SILIGURI DEPOT"
                    },
                    {
                        "value": "C70078",
                        "companyCode": "1200",
                        "text": "C70078 - SWAL-KOLKATTA DEPOT"
                    },
                    {
                        "value": "C70079",
                        "companyCode": "1200",
                        "text": "C70079 - Pune Zonal office"
                    },
                    {
                        "value": "C70080",
                        "companyCode": "1200",
                        "text": "C70080 - SWAL-AKOLA DEPOT"
                    },
                    {
                        "value": "C70081",
                        "companyCode": "1200",
                        "text": "C70081 - SWAL-RAJKOT DEPOT"
                    },
                    {
                        "value": "C70082",
                        "companyCode": "1200",
                        "text": "C70082 - SWAL-INDORE DEPOT"
                    },
                    {
                        "value": "C70083",
                        "companyCode": "1200",
                        "text": "C70083 - SWAL-RAIPUR DEPOT"
                    },
                    {
                        "value": "C70084",
                        "companyCode": "1200",
                        "text": "C70084 - SWAL-AHEMEDABAD DEPOT"
                    },
                    {
                        "value": "C70085",
                        "companyCode": "1200",
                        "text": "C70085 - SWAL-NASHIK DEPOT"
                    },
                    {
                        "value": "C70086",
                        "companyCode": "1200",
                        "text": "C70086 - Hyderabad Zonal office"
                    },
                    {
                        "value": "C70087",
                        "companyCode": "1200",
                        "text": "C70087 - SWAL-HYDERABAD DEPOT"
                    },
                    {
                        "value": "C70088",
                        "companyCode": "1200",
                        "text": "C70088 - SWAL-VIJAYAWADA DEPOT"
                    },
                    {
                        "value": "C70089",
                        "companyCode": "1200",
                        "text": "C70089 - SWAL-KURNOOL DEPOT"
                    },
                    {
                        "value": "C70090",
                        "companyCode": "1200",
                        "text": "C70090 - SWAL-JAIPUR"
                    },
                    {
                        "value": "C70091",
                        "companyCode": "1200",
                        "text": "C70091 - SWAL-SRIGANGANAGAR"
                    },
                    {
                        "value": "C70093",
                        "companyCode": "1200",
                        "text": "C70093 - Kottayam Zonal office"
                    },
                    {
                        "value": "C70094",
                        "companyCode": "1200",
                        "text": "C70094 - SWAL-KOTTAYAM"
                    },
                    {
                        "value": "C70095",
                        "companyCode": "1200",
                        "text": "C70095 - SWAL-CALICUT"
                    },
                    {
                        "value": "C70096",
                        "companyCode": "1200",
                        "text": "C70096 - SWAL-KARAMADAI"
                    },
                    {
                        "value": "C70097",
                        "companyCode": "1200",
                        "text": "C70097 - SWAL - HUBLI"
                    },
                    {
                        "value": "C70098",
                        "companyCode": "1200",
                        "text": "C70098 - SWAL-KANNUR-MARKETING"
                    },
                    {
                        "value": "C70100",
                        "companyCode": "1200",
                        "text": "C70100 - Swal-MKTG-Exports Non Subs - Agro"
                    },
                    {
                        "value": "C70101",
                        "companyCode": "1200",
                        "text": "C70101 - SWAL-KOTTAYAM -FERTILISER-QC LABORATORY"
                    },
                    {
                        "value": "C70102",
                        "companyCode": "1200",
                        "text": "C70102 - SWAL-CALI -FERTILISER-QC LABORATORY"
                    },
                    {
                        "value": "C70103",
                        "companyCode": "1200",
                        "text": "C70103 - SWAL-KANNUR -FERTILISER-QC LABORATORY"
                    },
                    {
                        "value": "C70104",
                        "companyCode": "1200",
                        "text": "C70104 - SWAL-KARMADAI -FERTILISER-QC LABORATORY"
                    },
                    {
                        "value": "C70105",
                        "companyCode": "1200",
                        "text": "C70105 - SWAL-CORP-LOGISTICS"
                    },
                    {
                        "value": "C70106",
                        "companyCode": "1200",
                        "text": "C70106 - SWAL-PATNA DEPOT (BIHAR)"
                    },
                    {
                        "value": "C70107",
                        "companyCode": "1200",
                        "text": "C70107 - SWAL-BHUBANESWAR DEPOT (ORISA)"
                    },
                    {
                        "value": "C70108",
                        "companyCode": "1200",
                        "text": "C70108 - SWAL-RUDRAPUR DEPOT [ UTTARANCHAL ]"
                    },
                    {
                        "value": "C70109",
                        "companyCode": "1200",
                        "text": "C70109 - SWAL-PUNE"
                    },
                    {
                        "value": "C70110",
                        "companyCode": "1200",
                        "text": "C70110 - SWAL-AHMEDABAD"
                    },
                    {
                        "value": "C70111",
                        "companyCode": "1200",
                        "text": "C70111 - SWAL - KARAMADAI - AGRO"
                    },
                    {
                        "value": "C70112",
                        "companyCode": "1200",
                        "text": "C70112 - SWAL - GHAZIABAD"
                    },
                    {
                        "value": "C70113",
                        "companyCode": "1200",
                        "text": "C70113 - SWAL-KOTTAYAM-FERTILISER SALES & MARKETI"
                    },
                    {
                        "value": "C70114",
                        "companyCode": "1200",
                        "text": "C70114 - SWAL-KARAMADAI-FERTILISER SALES & MARKET"
                    },
                    {
                        "value": "C70115",
                        "companyCode": "1200",
                        "text": "C70115 - SW-CORP-INTERNAL AUDIT"
                    },
                    {
                        "value": "C70116",
                        "companyCode": "1200",
                        "text": "C70116 - SW-CORP-DIRECTORS"
                    },
                    {
                        "value": "C70117",
                        "companyCode": "1200",
                        "text": "C70117 - SWAL-CORP-HR"
                    },
                    {
                        "value": "C70118",
                        "companyCode": "1200",
                        "text": "C70118 - SWAL-CORP-ADMIN"
                    },
                    {
                        "value": "C70119",
                        "companyCode": "1200",
                        "text": "C70119 - SWAL-LUDHIANA"
                    },
                    {
                        "value": "C70120",
                        "companyCode": "1200",
                        "text": "C70120 - Swal-Srinagar"
                    },
                    {
                        "value": "C70121",
                        "companyCode": "1200",
                        "text": "C70121 - SWAL-PUNE-PERTILISER"
                    },
                    {
                        "value": "C70122",
                        "companyCode": "1200",
                        "text": "C70122 - SWAL-URAN-FERTILISER"
                    },
                    {
                        "value": "C70123",
                        "companyCode": "1200",
                        "text": "C70123 - SWAL-ANKLESHWAR DEPOT"
                    },
                    {
                        "value": "C70124",
                        "companyCode": "1200",
                        "text": "C70124 - SWAL - HISSAR FERTILISER"
                    },
                    {
                        "value": "C70125",
                        "companyCode": "1200",
                        "text": "C70125 - SWAL- BHATINDA FERTILISER"
                    },
                    {
                        "value": "C70126",
                        "companyCode": "1200",
                        "text": "C70126 - SWAL-GAZIABAD FERTILISER"
                    },
                    {
                        "value": "C70127",
                        "companyCode": "1200",
                        "text": "C70127 - SWAL- GUWAHATI FERTILISER"
                    },
                    {
                        "value": "C70128",
                        "companyCode": "1200",
                        "text": "C70128 - SWAL- SILIGURI FERTILISER"
                    },
                    {
                        "value": "C70129",
                        "companyCode": "1200",
                        "text": "C70129 - SWAL-KOLKATTA FERTILISER"
                    },
                    {
                        "value": "C70130",
                        "companyCode": "1200",
                        "text": "C70130 - SWAL-AKOLA FERTILISER"
                    },
                    {
                        "value": "C70131",
                        "companyCode": "1200",
                        "text": "C70131 - SWAL-INDORE FERTILISER"
                    },
                    {
                        "value": "C70132",
                        "companyCode": "1200",
                        "text": "C70132 - SWAL-RAIPUR FERTILISER"
                    },
                    {
                        "value": "C70133",
                        "companyCode": "1200",
                        "text": "C70133 - SWAL-HYDERABAD FERTILISER"
                    },
                    {
                        "value": "C70134",
                        "companyCode": "1200",
                        "text": "C70134 - SWAL-VIJAYAWADA FERTILISER"
                    },
                    {
                        "value": "C70135",
                        "companyCode": "1200",
                        "text": "C70135 - SWAL-KURNOOL FERTILISER"
                    },
                    {
                        "value": "C70136",
                        "companyCode": "1200",
                        "text": "C70136 - SWAL-JAIPUR FERTILISER"
                    },
                    {
                        "value": "C70137",
                        "companyCode": "1200",
                        "text": "C70137 - SWAL-SRIGANGANAGAR FERTILISER"
                    },
                    {
                        "value": "C70138",
                        "companyCode": "1200",
                        "text": "C70138 - SWAL - HUBLI FERTILISER"
                    },
                    {
                        "value": "C70139",
                        "companyCode": "1200",
                        "text": "C70139 - SWAL-PATNA FERTILISER"
                    },
                    {
                        "value": "C70140",
                        "companyCode": "1200",
                        "text": "C70140 - SWAL-BHUBANESWAR FERT"
                    },
                    {
                        "value": "C70141",
                        "companyCode": "1200",
                        "text": "C70141 - SWAL-AHMEDABAD FERTILISER"
                    },
                    {
                        "value": "C70142",
                        "companyCode": "1200",
                        "text": "C70142 - SWAL-LUDHIANA FERTILISER"
                    },
                    {
                        "value": "C70143",
                        "companyCode": "1200",
                        "text": "C70143 - Swal-Srinagar FERTILISER"
                    },
                    {
                        "value": "C70144",
                        "companyCode": "1200",
                        "text": "C70144 - SWAL Indore Zone"
                    },
                    {
                        "value": "C70145",
                        "companyCode": "1200",
                        "text": "C70145 - SWAL Vijayawada Zone"
                    },
                    {
                        "value": "C70146",
                        "companyCode": "1200",
                        "text": "C70146 - SWAL Coimbatore Zone"
                    },
                    {
                        "value": "C70147",
                        "companyCode": "1200",
                        "text": "C70147 - SWAL-KARAMADAI -FERTILISER"
                    },
                    {
                        "value": "C70148",
                        "companyCode": "1200",
                        "text": "C70148 - SWAL - KARAMADAI- ADMINISTRATION"
                    },
                    {
                        "value": "C70149",
                        "companyCode": "1200",
                        "text": "C70149 - SWAL-KOTTAYAM -FERTILISER"
                    },
                    {
                        "value": "C70150",
                        "companyCode": "1200",
                        "text": "C70150 - SWAL - KOTTAYAM - ADMINISTRATION"
                    },
                    {
                        "value": "C70151",
                        "companyCode": "1200",
                        "text": "C70151 - SWAL-CALICUT-FERTILISER"
                    },
                    {
                        "value": "C70152",
                        "companyCode": "1200",
                        "text": "C70152 - SWAL - CALICUT- ADMINISTRATION"
                    },
                    {
                        "value": "C70153",
                        "companyCode": "1200",
                        "text": "C70153 - SWAL-NASHIK -FERTILISER"
                    },
                    {
                        "value": "C70154",
                        "companyCode": "1200",
                        "text": "C70154 - SWAL-NASHIK-ADMINISTRATION"
                    },
                    {
                        "value": "C70155",
                        "companyCode": "1200",
                        "text": "C70155 - SWAL-KANNUR-FERTLISER"
                    },
                    {
                        "value": "C70156",
                        "companyCode": "1200",
                        "text": "C70156 - SWAL-KANNUR-ADMINISTRATION"
                    },
                    {
                        "value": "C70157",
                        "companyCode": "1200",
                        "text": "C70157 - SWAL-KOTTAYAM -FERTILISER-QC LABORATORY"
                    },
                    {
                        "value": "C70158",
                        "companyCode": "1200",
                        "text": "C70158 - SWAL-CALI -FERTILISER-QC LABORATORY"
                    },
                    {
                        "value": "C70159",
                        "companyCode": "1200",
                        "text": "C70159 - SWAL-KANNUR -FERTILISER-QC LABORATORY"
                    },
                    {
                        "value": "C70160",
                        "companyCode": "1200",
                        "text": "C70160 - SWAL-KARMADAI -FERTILISER-QC LABORATORY"
                    },
                    {
                        "value": "C70161",
                        "companyCode": "1200",
                        "text": "C70161 - SWAL Coimbatore"
                    },
                    {
                        "value": "C70162",
                        "companyCode": "1200",
                        "text": "C70162 - SWAL LUCKNOW DEPOT"
                    },
                    {
                        "value": "C70163",
                        "companyCode": "1200",
                        "text": "C70163 - SWAL-JABALPUR DEPOT"
                    },
                    {
                        "value": "C70164",
                        "companyCode": "1200",
                        "text": "C70164 - SWAL LUCKNOW DEPOT - FERTILISER"
                    },
                    {
                        "value": "C70165",
                        "companyCode": "1200",
                        "text": "C70165 - SWAL-JABALPUR DEPOT - FERTILISER"
                    },
                    {
                        "value": "C70166",
                        "companyCode": "1200",
                        "text": "C70166 - SWAL- Inter Co - Dom"
                    },
                    {
                        "value": "C70167",
                        "companyCode": "1200",
                        "text": "C70167 - SWAL Marketing"
                    },
                    {
                        "value": "C70168",
                        "companyCode": "1200",
                        "text": "C70168 - SWAL Sales"
                    },
                    {
                        "value": "C70169",
                        "companyCode": "1200",
                        "text": "C70169 - SWAL Finance"
                    },
                    {
                        "value": "C70170",
                        "companyCode": "1200",
                        "text": "C70170 - SWAL Human Resources"
                    },
                    {
                        "value": "C70171",
                        "companyCode": "1200",
                        "text": "C70171 - SWAL Logistic"
                    },
                    {
                        "value": "C70172",
                        "companyCode": "1200",
                        "text": "C70172 - HYDERABAD REGION"
                    },
                    {
                        "value": "C70173",
                        "companyCode": "1200",
                        "text": "C70173 - WARANGAL REGION"
                    },
                    {
                        "value": "C70174",
                        "companyCode": "1200",
                        "text": "C70174 - TRICHY REGION"
                    },
                    {
                        "value": "C70175",
                        "companyCode": "1200",
                        "text": "C70175 - COIMBATORE REGION"
                    },
                    {
                        "value": "C70176",
                        "companyCode": "1200",
                        "text": "C70176 - Bargarh_SWAL"
                    },
                    {
                        "value": "C70177",
                        "companyCode": "1200",
                        "text": "C70177 - Guwahati_SWAL"
                    },
                    {
                        "value": "C75101",
                        "companyCode": "1200",
                        "text": "C75101 - SW21-REPACKING"
                    },
                    {
                        "value": "C75404",
                        "companyCode": "1200",
                        "text": "C75404 - SWAL-SW21-COMMERCIAL"
                    },
                    {
                        "value": "C75501",
                        "companyCode": "1200",
                        "text": "C75501 - SW21-ADMIN"
                    },
                    {
                        "value": "C75602",
                        "companyCode": "1200",
                        "text": "C75602 - SW21-DESPATCH"
                    },
                    {
                        "value": "C80001",
                        "companyCode": "1700",
                        "text": "C80001 - NURTURE.FARM Operational Expenses"
                    },
                    {
                        "value": "C80002",
                        "companyCode": "1700",
                        "text": "C80002 - Nurture.Farm Technology Expenses"
                    },
                    {
                        "value": "C80003",
                        "companyCode": "1700",
                        "text": "C80003 - Nurture.Farm Learning & Development"
                    },
                    {
                        "value": "C80004",
                        "companyCode": "1700",
                        "text": "C80004 - Nurture.Farm Office & Admin"
                    },
                    {
                        "value": "C80005",
                        "companyCode": "1700",
                        "text": "C80005 - Nurture.Farm Marketing Expenses"
                    },
                    {
                        "value": "C80006",
                        "companyCode": "1700",
                        "text": "C80006 - Nurture.Retail Operational Expenses"
                    },
                    {
                        "value": "C80007",
                        "companyCode": "1700",
                        "text": "C80007 - NURTURE.FARM Corporate Expenses"
                    },
                    {
                        "value": "C80008",
                        "companyCode": "1700",
                        "text": "C80008 - Nurture.Trade Operational Expenses"
                    },
                    {
                        "value": "C80009",
                        "companyCode": "1700",
                        "text": "C80009 - NURTURE.Sustain Operational Expenses"
                    },
                    {
                        "value": "C90001",
                        "companyCode": "1600",
                        "text": "C90001 - Liquid Formulation"
                    },
                    {
                        "value": "C90051",
                        "companyCode": "1600",
                        "text": "C90051 - NPP-ENG-ELECTRICAL"
                    },
                    {
                        "value": "C90052",
                        "companyCode": "1600",
                        "text": "C90052 - NPP-ENGINEERING - CIVIL"
                    },
                    {
                        "value": "C90061",
                        "companyCode": "1600",
                        "text": "C90061 - NPP-MATERIAL MGMT / STORES"
                    },
                    {
                        "value": "C90071",
                        "companyCode": "1600",
                        "text": "C90071 - NPP-COMMERCIAL"
                    },
                    {
                        "value": "C90072",
                        "companyCode": "1600",
                        "text": "C90072 - NPP-SECURITY"
                    },
                    {
                        "value": "C90073",
                        "companyCode": "1600",
                        "text": "C90073 - NPP-INFORMATION TECHNOLOGY"
                    },
                    {
                        "value": "C90074",
                        "companyCode": "1600",
                        "text": "C90074 - NPP-QUALITY CONTROL LABORATORY"
                    },
                    {
                        "value": "C90075",
                        "companyCode": "1600",
                        "text": "C90075 - NPP-SAFETY DEPT"
                    },
                    {
                        "value": "C90076",
                        "companyCode": "1600",
                        "text": "C90076 - NPP-PERSONNEL DEPT"
                    },
                    {
                        "value": "C90077",
                        "companyCode": "1600",
                        "text": "C90077 - NPP- R & D"
                    },
                    {
                        "value": "C90081",
                        "companyCode": "1600",
                        "text": "C90081 - NPP-STANDSTILL & ELIMIN COST"
                    },
                    {
                        "value": "C90091",
                        "companyCode": "1600",
                        "text": "C90091 - NPP-FINANCE & ACCOUNTS"
                    },
                    {
                        "value": "CSW20404",
                        "companyCode": "1200",
                        "text": "CSW20404 - SWAL-JAMMU-COMMERCIAL"
                    },
                    {
                        "value": "CSW20501",
                        "companyCode": "1200",
                        "text": "CSW20501 - SWAL-JAMMU-ADMINISTRATION"
                    },
                    {
                        "value": "R51101",
                        "companyCode": "1500",
                        "text": "R51101 - ARY-KALOL-DTA-LIQUID EC / SL"
                    },
                    {
                        "value": "R51102",
                        "companyCode": "1500",
                        "text": "R51102 - ARY-KALOL-DTA-LIQUID SC"
                    },
                    {
                        "value": "R51103",
                        "companyCode": "1500",
                        "text": "R51103 - ARY-KALOL-DTA-WP / WS"
                    },
                    {
                        "value": "R51104",
                        "companyCode": "1500",
                        "text": "R51104 - ARY-KALOL-DTA-SULPHUR"
                    },
                    {
                        "value": "R51105",
                        "companyCode": "1500",
                        "text": "R51105 - ARY-KALOL-DTA-HERBICIDE"
                    },
                    {
                        "value": "R51106",
                        "companyCode": "1500",
                        "text": "R51106 - ARY-KALOL-DTA-GR"
                    },
                    {
                        "value": "R51107",
                        "companyCode": "1500",
                        "text": "R51107 - ARY-KALOL-DTA-PACKING"
                    },
                    {
                        "value": "R51108",
                        "companyCode": "1500",
                        "text": "R51108 - ARY-KALOL-DTA-HERBICIDE-(SC/EW)"
                    },
                    {
                        "value": "R51109",
                        "companyCode": "1500",
                        "text": "R51109 - ARY-KALOL-DTA-HERBICIDE-GLUFOSINATE"
                    },
                    {
                        "value": "R51110",
                        "companyCode": "1500",
                        "text": "R51110 - ARY-KALOL-DTA-MANCOZEB BULE"
                    },
                    {
                        "value": "R51111",
                        "companyCode": "1500",
                        "text": "R51111 - ARY-KALOL-DTA-SAAF WP"
                    },
                    {
                        "value": "R51112",
                        "companyCode": "1500",
                        "text": "R51112 - ARY-KALOL-DTA-SAAF WS"
                    },
                    {
                        "value": "R51201",
                        "companyCode": "1500",
                        "text": "R51201 - ARY-KALOL-DTA-POWER"
                    },
                    {
                        "value": "R51202",
                        "companyCode": "1500",
                        "text": "R51202 - ARY-KALOL-DTA-DG SET"
                    },
                    {
                        "value": "R51301",
                        "companyCode": "1500",
                        "text": "R51301 - ARY-KALOL-DTA-ENGINEERING - MECHANICAL"
                    },
                    {
                        "value": "R51303",
                        "companyCode": "1500",
                        "text": "R51303 - ARY-KALOL-DTA-ENGINEERING - INSTRUMENTAT"
                    },
                    {
                        "value": "R51304",
                        "companyCode": "1500",
                        "text": "R51304 - ARY-KALOL-DTA-ENGINEERING - CIVIL"
                    },
                    {
                        "value": "R51305",
                        "companyCode": "1500",
                        "text": "R51305 - ARY-KALOL-DTA-ENGINEERING - ELECTRICAL"
                    },
                    {
                        "value": "R51401",
                        "companyCode": "1500",
                        "text": "R51401 - ARY-KALOL-DTA-FACTORY ACCOUNTS/MIS"
                    },
                    {
                        "value": "R51403",
                        "companyCode": "1500",
                        "text": "R51403 - ARY-KALOL-DTA-MATERIAL MGMT / STORES"
                    },
                    {
                        "value": "R51404",
                        "companyCode": "1500",
                        "text": "R51404 - ARY-KALOL-DTA-COMMERCIAL"
                    },
                    {
                        "value": "R51501",
                        "companyCode": "1500",
                        "text": "R51501 - ARY-KALOL-DTA-ADMINISTRATION"
                    },
                    {
                        "value": "R51502",
                        "companyCode": "1500",
                        "text": "R51502 - ARY-KALOL-DTA-SECURITY"
                    },
                    {
                        "value": "R51503",
                        "companyCode": "1500",
                        "text": "R51503 - ARY-KALOL-DTA-FACTORY PERSONNEL DEPT"
                    },
                    {
                        "value": "R51505",
                        "companyCode": "1500",
                        "text": "R51505 - ARY-KALOL-DTA-INFORMATION TECHNOLOGY"
                    },
                    {
                        "value": "R51506",
                        "companyCode": "1500",
                        "text": "R51506 - ARY-KALOL-DTA-CANTEEN + GEN WELFARE"
                    },
                    {
                        "value": "R51507",
                        "companyCode": "1500",
                        "text": "R51507 - ARY-KALOL-DTA-QUALITY CONTROL LABORATORY"
                    },
                    {
                        "value": "R51508",
                        "companyCode": "1500",
                        "text": "R51508 - ARY-KALOL-DTA-SAFETY DEPT"
                    },
                    {
                        "value": "R51513",
                        "companyCode": "1500",
                        "text": "R51513 - ARY-KALOL-DTA-EXTERNAL SUPPORTS"
                    },
                    {
                        "value": "R51514",
                        "companyCode": "1500",
                        "text": "R51514 - ARY-KALOL-DTA-CONTRACT MANUFACTURING"
                    },
                    {
                        "value": "R51523",
                        "companyCode": "1500",
                        "text": "R51523 - ARY-KALOL-DTA-CORPORATE SOCIAL RESPONSIB"
                    },
                    {
                        "value": "R51603",
                        "companyCode": "1500",
                        "text": "R51603 - ARY-KALOL-DTA-FINISHED GOODS STORES"
                    },
                    {
                        "value": "R51613",
                        "companyCode": "1500",
                        "text": "R51613 - ARY-KALOL-DTA-PROJECT PLANNING/TECHNICAL"
                    },
                    {
                        "value": "R51614",
                        "companyCode": "1500",
                        "text": "R51614 - ARY-KALOL-DTA-PACKAGING DEVELOPMENT"
                    },
                    {
                        "value": "R52101",
                        "companyCode": "1500",
                        "text": "R52101 - ARY-KALOL-EOU-LIQUID EC / SL"
                    },
                    {
                        "value": "R52102",
                        "companyCode": "1500",
                        "text": "R52102 - ARY-KALOL-EOU-LIQUID SC"
                    },
                    {
                        "value": "R52103",
                        "companyCode": "1500",
                        "text": "R52103 - ARY-KALOL-EOU-PACKING"
                    },
                    {
                        "value": "R52201",
                        "companyCode": "1500",
                        "text": "R52201 - ARY-KALOL-EOU-POWER"
                    },
                    {
                        "value": "R52301",
                        "companyCode": "1500",
                        "text": "R52301 - ARY-KALOL-EOU-ENGINEERING - MECHANICAL"
                    },
                    {
                        "value": "R52303",
                        "companyCode": "1500",
                        "text": "R52303 - ARY-KALOL-EOU-ENGINEERING - INSTRUMENTAT"
                    },
                    {
                        "value": "R52304",
                        "companyCode": "1500",
                        "text": "R52304 - ARY-KALOL-EOU-ENGINEERING - CIVIL"
                    },
                    {
                        "value": "R52305",
                        "companyCode": "1500",
                        "text": "R52305 - ARY-KALOL-EOU-ENGINEERING - ELECTRICAL"
                    },
                    {
                        "value": "R52401",
                        "companyCode": "1500",
                        "text": "R52401 - ARY-KALOL-EOU-FACTORY ACCOUNTS/MIS"
                    },
                    {
                        "value": "R52403",
                        "companyCode": "1500",
                        "text": "R52403 - ARY-KALOL-EOU-MATERIAL MGMT / STORES"
                    },
                    {
                        "value": "R52404",
                        "companyCode": "1500",
                        "text": "R52404 - ARY-KALOL-EOU-COMMERCIAL"
                    },
                    {
                        "value": "R52501",
                        "companyCode": "1500",
                        "text": "R52501 - ARY-KALOL-EOU-ADMINISTRATION"
                    },
                    {
                        "value": "R52502",
                        "companyCode": "1500",
                        "text": "R52502 - ARY-KALOL-EOU-SECURITY"
                    },
                    {
                        "value": "R52503",
                        "companyCode": "1500",
                        "text": "R52503 - ARY-KALOL-EOU-FACTORY PERSONNEL DEPT"
                    },
                    {
                        "value": "R52505",
                        "companyCode": "1500",
                        "text": "R52505 - ARY-KALOL-EOU-INFORMATION TECHNOLOGY"
                    },
                    {
                        "value": "R52506",
                        "companyCode": "1500",
                        "text": "R52506 - ARY-KALOL-EOU-CANTEEN + GEN WELFARE"
                    },
                    {
                        "value": "R52507",
                        "companyCode": "1500",
                        "text": "R52507 - ARY-KALOL-EOU-QUALITY CONTROL LABORATORY"
                    },
                    {
                        "value": "R52508",
                        "companyCode": "1500",
                        "text": "R52508 - ARY-KALOL-EOU-SAFETY DEPT"
                    },
                    {
                        "value": "R52513",
                        "companyCode": "1500",
                        "text": "R52513 - ARY-KALOL-EOU-EXTERNAL SUPPORTS"
                    },
                    {
                        "value": "R52514",
                        "companyCode": "1500",
                        "text": "R52514 - ARY-KALOL-EOU-CONTRACT MANUFACTURING"
                    },
                    {
                        "value": "R52603",
                        "companyCode": "1500",
                        "text": "R52603 - ARY-KALOL-EOU-FINISHED GOODS STORES"
                    },
                    {
                        "value": "R52614",
                        "companyCode": "1500",
                        "text": "R52614 - ARY-KALOL-EOU-PACKAGING DEVELOPMENT"
                    },
                    {
                        "value": "R53101",
                        "companyCode": "1500",
                        "text": "R53101 - ARY-KALOL-GARUDA-WDG"
                    },
                    {
                        "value": "R53102",
                        "companyCode": "1500",
                        "text": "R53102 - ARY-KALOL-GARUDA-PACKING"
                    },
                    {
                        "value": "R53201",
                        "companyCode": "1500",
                        "text": "R53201 - ARY-KALOL-GARUDA-POWER"
                    },
                    {
                        "value": "R53301",
                        "companyCode": "1500",
                        "text": "R53301 - ARY-KALOL-GARUDA-ENGINEERING - MECHANICA"
                    },
                    {
                        "value": "R53303",
                        "companyCode": "1500",
                        "text": "R53303 - ARY-KALOL-GARUDA-ENGINEERING - INSTRUMEN"
                    },
                    {
                        "value": "R53304",
                        "companyCode": "1500",
                        "text": "R53304 - ARY-KALOL-GARUDA-ENGINEERING - CIVIL"
                    },
                    {
                        "value": "R53305",
                        "companyCode": "1500",
                        "text": "R53305 - ARY-KALOL-GARUDA-ENGINEERING - ELECTRICA"
                    },
                    {
                        "value": "R53403",
                        "companyCode": "1500",
                        "text": "R53403 - ARY-KALOL-GARUDA-MATERIAL MGMT / STORES"
                    },
                    {
                        "value": "R53404",
                        "companyCode": "1500",
                        "text": "R53404 - ARY-KALOL-GARUDA-COMMERCIAL"
                    },
                    {
                        "value": "R53501",
                        "companyCode": "1500",
                        "text": "R53501 - ARY-KALOL-GARUDA-ADMINISTRATION"
                    },
                    {
                        "value": "R53502",
                        "companyCode": "1500",
                        "text": "R53502 - ARY-KALOL-GARUDA-SECURITY"
                    },
                    {
                        "value": "R53503",
                        "companyCode": "1500",
                        "text": "R53503 - ARY-KALOL-GARUDA-FACTORY PERSONNEL DEPT"
                    },
                    {
                        "value": "R53505",
                        "companyCode": "1500",
                        "text": "R53505 - ARY-KALOL-GARUDA-INFORMATION TECHNOLOGY"
                    },
                    {
                        "value": "R53507",
                        "companyCode": "1500",
                        "text": "R53507 - ARY-KALOL-GARUDA-QUALITY CONTROL LABORAT"
                    },
                    {
                        "value": "R53508",
                        "companyCode": "1500",
                        "text": "R53508 - ARY-KALOL-GARUDA-SAFETY DEPT"
                    },
                    {
                        "value": "R53513",
                        "companyCode": "1500",
                        "text": "R53513 - ARY-KALOL-GARUDA-EXTERNAL SUPPORTS"
                    },
                    {
                        "value": "R53514",
                        "companyCode": "1500",
                        "text": "R53514 - ARY-KALOL-GARUDA-CONTRACT MANUFACTURING"
                    },
                    {
                        "value": "R53603",
                        "companyCode": "1500",
                        "text": "R53603 - ARY-KALOL-GARUDA-FINISHED GOODS STORES"
                    },
                    {
                        "value": "R53613",
                        "companyCode": "1500",
                        "text": "R53613 - ARY-KALOL-GARUDA-PROJECT PLANNING/TECHNI"
                    },
                    {
                        "value": "R53614",
                        "companyCode": "1500",
                        "text": "R53614 - ARY-KALOL-GARUDA-PACKAGING DEVELOPMENT"
                    },
                    {
                        "value": "R53615",
                        "companyCode": "1500",
                        "text": "R53615 - ARYSTA-CORP-PURCHASE"
                    },
                    {
                        "value": "R53616",
                        "companyCode": "1500",
                        "text": "R53616 - ARYSTA-CORP-REGISTRATION"
                    },
                    {
                        "value": "R53617",
                        "companyCode": "1500",
                        "text": "R53617 - ALS-SUPPLY CHAIN MANAGEMENT"
                    },
                    {
                        "value": "R99100",
                        "companyCode": "1500",
                        "text": "R99100 - ARY-RAJKOT BRANCH"
                    },
                    {
                        "value": "R99101",
                        "companyCode": "1500",
                        "text": "R99101 - ARY-AKOLA BRANCH"
                    },
                    {
                        "value": "R99102",
                        "companyCode": "1500",
                        "text": "R99102 - ARY-PUNE BRANCH"
                    },
                    {
                        "value": "R99103",
                        "companyCode": "1500",
                        "text": "R99103 - ARY-INDORE BRANCH"
                    },
                    {
                        "value": "R99104",
                        "companyCode": "1500",
                        "text": "R99104 - ARY-PANJAB BRANCH"
                    },
                    {
                        "value": "R99105",
                        "companyCode": "1500",
                        "text": "R99105 - ARY-HARYANA BRANCH"
                    },
                    {
                        "value": "R99106",
                        "companyCode": "1500",
                        "text": "R99106 - ARY-UTTAR PRADESH BRANCH"
                    },
                    {
                        "value": "R99107",
                        "companyCode": "1500",
                        "text": "R99107 - ARY-WEST BENGAL BRANCH"
                    },
                    {
                        "value": "R99108",
                        "companyCode": "1500",
                        "text": "R99108 - ARY-ASSAM BRANCH"
                    },
                    {
                        "value": "R99109",
                        "companyCode": "1500",
                        "text": "R99109 - ARY-B2B"
                    },
                    {
                        "value": "R99110",
                        "companyCode": "1500",
                        "text": "R99110 - ARY-EXPORT"
                    },
                    {
                        "value": "R99111",
                        "companyCode": "1500",
                        "text": "R99111 - ARY-RAJASTAN BRANCH"
                    },
                    {
                        "value": "R99301",
                        "companyCode": "1500",
                        "text": "R99301 - ARY-CORP-FINANCE & ACCOUNTS"
                    },
                    {
                        "value": "R99302",
                        "companyCode": "1500",
                        "text": "R99302 - ARY-CORP-PURCHASE"
                    },
                    {
                        "value": "R99303",
                        "companyCode": "1500",
                        "text": "R99303 - ARY-CORP-PERSONNEL & HRD"
                    },
                    {
                        "value": "R99304",
                        "companyCode": "1500",
                        "text": "R99304 - ARY-CORP-INFORMATION TECHNOLOGY"
                    },
                    {
                        "value": "R99305",
                        "companyCode": "1500",
                        "text": "R99305 - ARY-CORP-MANAGEMENT"
                    },
                    {
                        "value": "R99306",
                        "companyCode": "1500",
                        "text": "R99306 - ARY-CORP-DIRECTORS"
                    },
                    {
                        "value": "R99307",
                        "companyCode": "1500",
                        "text": "R99307 - ARY-CORP-ADMIN"
                    },
                    {
                        "value": "R99308",
                        "companyCode": "1500",
                        "text": "R99308 - ARY-CORP-SECRETARIAL"
                    },
                    {
                        "value": "R99309",
                        "companyCode": "1500",
                        "text": "R99309 - ARY-CORP-LEGAL DEPARTMENT"
                    },
                    {
                        "value": "R99310",
                        "companyCode": "1500",
                        "text": "R99310 - ARY-CORP-MARKETING"
                    },
                    {
                        "value": "R99311",
                        "companyCode": "1500",
                        "text": "R99311 - ARY-CORP-REGISTRATION"
                    },
                    {
                        "value": "R99312",
                        "companyCode": "1500",
                        "text": "R99312 - ARY-CORP-EXPORT SALES"
                    },
                    {
                        "value": "R99313",
                        "companyCode": "1500",
                        "text": "R99313 - ARY-CORP-DOMESTIC SALES"
                    },
                    {
                        "value": "R99314",
                        "companyCode": "1500",
                        "text": "R99314 - ARY-BRD-FINANCE & ACCOUNTS"
                    },
                    {
                        "value": "R99315",
                        "companyCode": "1500",
                        "text": "R99315 - ARY-BRD-ADMIN"
                    },
                    {
                        "value": "R99316",
                        "companyCode": "1500",
                        "text": "R99316 - ARY-CORP-FIELD R&D"
                    },
                    {
                        "value": "R99317",
                        "companyCode": "1500",
                        "text": "R99317 - ARYSTA-CORP-REGISTRATION"
                    },
                    {
                        "value": "R99318",
                        "companyCode": "1500",
                        "text": "R99318 - ARY-MKTG-Exports MIDDLE EAST"
                    },
                    {
                        "value": "R99319",
                        "companyCode": "1500",
                        "text": "R99319 - ARY-MKTG-Exports-NORTH AFRICA"
                    },
                    {
                        "value": "R99320",
                        "companyCode": "1500",
                        "text": "R99320 - ARY-MKTG-MARKETING - ATCA"
                    },
                    {
                        "value": "R99321",
                        "companyCode": "1500",
                        "text": "R99321 - ARY-CORP-FINANCE & ACCOUNTS"
                    },
                    {
                        "value": "R99322",
                        "companyCode": "1500",
                        "text": "R99322 - ARY-CORP-FINANCE & ACCOUNTS"
                    },
                    {
                        "value": "R99323",
                        "companyCode": "1500",
                        "text": "R99323 - ARYSTA-CORP-INFORMATION TECHNOLOGY"
                    },
                    {
                        "value": "R99324",
                        "companyCode": "1500",
                        "text": "R99324 - ARY-CORP-MANAGEMENT."
                    },
                    {
                        "value": "R99325",
                        "companyCode": "1500",
                        "text": "R99325 - ARY-CORP-DIRECTORS"
                    },
                    {
                        "value": "R99326",
                        "companyCode": "1500",
                        "text": "R99326 - ARY-CORP-ADMIN"
                    },
                    {
                        "value": "R99327",
                        "companyCode": "1500",
                        "text": "R99327 - ARY-CORP-SECRETARIAL"
                    },
                    {
                        "value": "R99328",
                        "companyCode": "1500",
                        "text": "R99328 - CC INDIA -ARYSTA"
                    },
                    {
                        "value": "SC0201",
                        "companyCode": "1500",
                        "text": "SC0201"
                    },
                ]
            }
        case "TAX_CODE":
            return {
                "TAX_CODE": [
                    {
                        "value": "05",
                        "TaxType": "Input Tax",
                        "text": "05 - Purchase against Form F"
                    },
                    {
                        "value": "06",
                        "TaxType": "Input Tax",
                        "text": "06 - "
                    },
                    {
                        "value": "25",
                        "TaxType": "Output Tax",
                        "text": "25 - Sales - GST - 2%"
                    },
                    {
                        "value": "26",
                        "TaxType": "Output Tax",
                        "text": "26 - Sales - Gujarat Vat 4%"
                    },
                    {
                        "value": "27",
                        "TaxType": "Output Tax",
                        "text": "27 - Sales - GST - 5%"
                    },
                    {
                        "value": "28",
                        "TaxType": "Output Tax",
                        "text": "28 - Sales - GST -6%"
                    },
                    {
                        "value": "29",
                        "TaxType": "Output Tax",
                        "text": "29 - Sales - GST -8%"
                    },
                    {
                        "value": "30",
                        "TaxType": "Output Tax",
                        "text": "30 - Sales - Gujarat Vat 12.5 %"
                    },
                    {
                        "value": "31",
                        "TaxType": "Output Tax",
                        "text": "31 - Sales GST -0.25% agst form 26/40"
                    },
                    {
                        "value": "32",
                        "TaxType": "Output Tax",
                        "text": "32 - Sales Gujarat Vat 12.5% (Jhagadia)"
                    },
                    {
                        "value": "33",
                        "TaxType": "Output Tax",
                        "text": "33 - Sales - Gujarat Vat 4%  (Jhagadia)"
                    },
                    {
                        "value": "34",
                        "TaxType": "Output Tax",
                        "text": "34 - Sales - GST -0% IInd sale no tax"
                    },
                    {
                        "value": "35",
                        "TaxType": "Output Tax",
                        "text": "35 - Sales - 0% High sea sale"
                    },
                    {
                        "value": "36",
                        "TaxType": "Output Tax",
                        "text": "36 - Sales - GST/CST -0% Export Sale form H"
                    },
                    {
                        "value": "37",
                        "TaxType": "Output Tax",
                        "text": "37 - Sales - GST -0% Export Sales Other"
                    },
                    {
                        "value": "38",
                        "TaxType": "Output Tax",
                        "text": "38 - Sales - GST -0% Export Sales UPL MFG Goods"
                    },
                    {
                        "value": "39",
                        "TaxType": "Output Tax",
                        "text": "39 - Sales - APST - (IC/CA) -VAT 4%"
                    },
                    {
                        "value": "40",
                        "TaxType": "Output Tax",
                        "text": "40 - Sales  (IC/CA) - CST- 4%  Agnst form ' C '"
                    },
                    {
                        "value": "41",
                        "TaxType": "Output Tax",
                        "text": "41 - Sales  (IC/CA) - CST- 10% without form ' C '"
                    },
                    {
                        "value": "42",
                        "TaxType": "Output Tax",
                        "text": "42 - Sales - CST- 2% Agnst form ' C '"
                    },
                    {
                        "value": "43",
                        "TaxType": "Output Tax",
                        "text": "43 - Sales - Gujarat CST 4%  Agnst form ' C '"
                    },
                    {
                        "value": "44",
                        "TaxType": "Output Tax",
                        "text": "44 - Sales - Jhagadia CST- 4%  Agnst form ' C '"
                    },
                    {
                        "value": "45",
                        "TaxType": "Output Tax",
                        "text": "45 - Sales - CST- 6%  Without Form  C"
                    },
                    {
                        "value": "46",
                        "TaxType": "Output Tax",
                        "text": "46 - Sales - Gujarat  CST- 10%  Without Form  C"
                    },
                    {
                        "value": "47",
                        "TaxType": "Output Tax",
                        "text": "47 - Sales - Gujarat CST- 12.5 %  Without Form  C"
                    },
                    {
                        "value": "48",
                        "TaxType": "Output Tax",
                        "text": "48 - Sales - Jhagadia CST- 10% without Form C"
                    },
                    {
                        "value": "49",
                        "TaxType": "Output Tax",
                        "text": "49 - Sales - Jhagadia CST- 12.5% without Form C"
                    },
                    {
                        "value": "50",
                        "TaxType": "Output Tax",
                        "text": "50 - Sales - Andhra Pradesh- CST-4%"
                    },
                    {
                        "value": "51",
                        "TaxType": "Output Tax",
                        "text": "51 - Sales - Andhra Pradesh- VAT -4%"
                    },
                    {
                        "value": "52",
                        "TaxType": "Output Tax",
                        "text": "52 - Sales -Assam - CST-Non Regd - 10%"
                    },
                    {
                        "value": "53",
                        "TaxType": "Output Tax",
                        "text": "53 - Sales -Assam - CST- Regd - 4%"
                    },
                    {
                        "value": "54",
                        "TaxType": "Output Tax",
                        "text": "54 - Sales -Assam - VAT- 4%"
                    },
                    {
                        "value": "55",
                        "TaxType": "Output Tax",
                        "text": "55 - Sales -Bihar- CST-4%"
                    },
                    {
                        "value": "56",
                        "TaxType": "Output Tax",
                        "text": "56 - Sales -Bihar- VAT-4%"
                    },
                    {
                        "value": "57",
                        "TaxType": "Output Tax",
                        "text": "57 - Sales -Chhatisgarh - VAT - 4%"
                    },
                    {
                        "value": "58",
                        "TaxType": "Output Tax",
                        "text": "58 - Sales -Daman -CST - 2%"
                    },
                    {
                        "value": "59",
                        "TaxType": "Output Tax",
                        "text": "59 - Sales -Daman -CST -4%"
                    },
                    {
                        "value": "5X",
                        "TaxType": "Input Tax",
                        "text": "5X - Purchase VAT 5 % - VAP4 PLANT"
                    },
                    {
                        "value": "5Y",
                        "TaxType": "Input Tax",
                        "text": "5Y - PURCHASE  CST - 2%  AGAINST FORM C"
                    },
                    {
                        "value": "60",
                        "TaxType": "Output Tax",
                        "text": "60 - Sales -Daman -10% CST"
                    },
                    {
                        "value": "61",
                        "TaxType": "Output Tax",
                        "text": "61 - Sales -Haryana-CST - 2%"
                    },
                    {
                        "value": "62",
                        "TaxType": "Output Tax",
                        "text": "62 - Sales -Haryana-CST - 4%"
                    },
                    {
                        "value": "63",
                        "TaxType": "Output Tax",
                        "text": "63 - Sales -Haryana-CST - 10% Non Regd"
                    },
                    {
                        "value": "64",
                        "TaxType": "Output Tax",
                        "text": "64 - Sales -Haryana-VAT - 4%"
                    },
                    {
                        "value": "65",
                        "TaxType": "Output Tax",
                        "text": "65 - Sales -Karnataka- CST-4%"
                    },
                    {
                        "value": "66",
                        "TaxType": "Output Tax",
                        "text": "66 - Sales -Karnataka- VAT - 4%"
                    },
                    {
                        "value": "67",
                        "TaxType": "Output Tax",
                        "text": "67 - Sales -Kerala-VAT-4.04%"
                    },
                    {
                        "value": "68",
                        "TaxType": "Output Tax",
                        "text": "68 - Sales -M.P.-VAT -4%"
                    },
                    {
                        "value": "69",
                        "TaxType": "Output Tax",
                        "text": "69 - Sales -Maharashtra-VAT-4%"
                    },
                    {
                        "value": "70",
                        "TaxType": "Output Tax",
                        "text": "70 - Sales -Mumbai-VAT 4%"
                    },
                    {
                        "value": "71",
                        "TaxType": "Output Tax",
                        "text": "71 - Sales -Maharastra - CST - 4% Agnst Form ' C'"
                    },
                    {
                        "value": "72",
                        "TaxType": "Output Tax",
                        "text": "72 - Sales -Maharastra - CST - 10% without form  C"
                    },
                    {
                        "value": "73",
                        "TaxType": "Output Tax",
                        "text": "73 - Sales -Maharashtra-Export-Form 14 B"
                    },
                    {
                        "value": "74",
                        "TaxType": "Output Tax",
                        "text": "74 - Sales -Orissa- CST - 10% NON REGD"
                    },
                    {
                        "value": "75",
                        "TaxType": "Output Tax",
                        "text": "75 - Sales -Orissa- CST - 4% Regds Dealer"
                    },
                    {
                        "value": "76",
                        "TaxType": "Output Tax",
                        "text": "76 - Sales -Orissa- VAT- 4%"
                    },
                    {
                        "value": "77",
                        "TaxType": "Output Tax",
                        "text": "77 - Sales -Punjab - CST - 4%"
                    },
                    {
                        "value": "78",
                        "TaxType": "Output Tax",
                        "text": "78 - Sales -Punjab - CST - 0% NON REGD"
                    },
                    {
                        "value": "79",
                        "TaxType": "Output Tax",
                        "text": "79 - Sales -Punjab -  VAT 4%"
                    },
                    {
                        "value": "80",
                        "TaxType": "Output Tax",
                        "text": "80 - Sales -Rajasthan- CST- 4 %"
                    },
                    {
                        "value": "81",
                        "TaxType": "Output Tax",
                        "text": "81 - Sales -Rajasthan- LST - 4%"
                    },
                    {
                        "value": "82",
                        "TaxType": "Output Tax",
                        "text": "82 - Sales -Tamil Nadu-CST - 4%"
                    },
                    {
                        "value": "83",
                        "TaxType": "Output Tax",
                        "text": "83 - Sales -Tamil Nadu-VAT-4%"
                    },
                    {
                        "value": "84",
                        "TaxType": "Output Tax",
                        "text": "84 - Sales -Uttar Pradesh - CST-4%"
                    },
                    {
                        "value": "85",
                        "TaxType": "Output Tax",
                        "text": "85 - Sales -Uttar Pradesh - LST- 5% + 1% Dev Tax"
                    },
                    {
                        "value": "86",
                        "TaxType": "Output Tax",
                        "text": "86 - Sales -Uttaranchal -VAT- 4%"
                    },
                    {
                        "value": "87",
                        "TaxType": "Output Tax",
                        "text": "87 - Sales -West Bengal- CST- 10% Non Regd"
                    },
                    {
                        "value": "88",
                        "TaxType": "Output Tax",
                        "text": "88 - Sales -West Bengal- CST - 4% REGD"
                    },
                    {
                        "value": "89",
                        "TaxType": "Output Tax",
                        "text": "89 - Sales -West Bengal-(Calcutta-AF) VAT - 4%"
                    },
                    {
                        "value": "90",
                        "TaxType": "Output Tax",
                        "text": "90 - Sales - Stock Transfer Agst Form  F"
                    },
                    {
                        "value": "91",
                        "TaxType": "Output Tax",
                        "text": "91 - Sales -M.P.-LST- 4% + 15% S.C."
                    },
                    {
                        "value": "92",
                        "TaxType": "Output Tax",
                        "text": "92 - Sales - Jammu - 0% LOCAL VAT"
                    },
                    {
                        "value": "93",
                        "TaxType": "Output Tax",
                        "text": "93 - F Form Depot to Depot Transfer"
                    },
                    {
                        "value": "94",
                        "TaxType": "Output Tax",
                        "text": "94 - Sales - Punjab VAT - 0% (FOR IC/AT)"
                    },
                    {
                        "value": "95",
                        "TaxType": "Output Tax",
                        "text": "95 - Sales -Tamil Nadu-LST-3% + SC 5%"
                    },
                    {
                        "value": "96",
                        "TaxType": "Output Tax",
                        "text": "96 - Sales -Punjab - VAT  0%"
                    },
                    {
                        "value": "97",
                        "TaxType": "Output Tax",
                        "text": "97 - Sales -Jharkhand LST 4%"
                    },
                    {
                        "value": "98",
                        "TaxType": "Output Tax",
                        "text": "98 - Sales -M.P.-VAT - 4%"
                    },
                    {
                        "value": "99",
                        "TaxType": "Output Tax",
                        "text": "99 - Sales -Bihar- Export to Nepal"
                    },
                    {
                        "value": "A0",
                        "TaxType": "Output Tax",
                        "text": "A0 - Sales - 0%"
                    },
                    {
                        "value": "A1",
                        "TaxType": "Output Tax",
                        "text": "A1 - "
                    },
                    {
                        "value": "A2",
                        "TaxType": "Input Tax",
                        "text": "A2 - Purchases - GST - 5% (Non Vatable)"
                    },
                    {
                        "value": "A3",
                        "TaxType": "Input Tax",
                        "text": "A3 - Purchases - MST- 4% (Non Vatable)-MAHARASHTRA"
                    },
                    {
                        "value": "A4",
                        "TaxType": "Input Tax",
                        "text": "A4 - Purchases - MST- 6% (Non Vatable)-MAHARASHTRA"
                    },
                    {
                        "value": "A5",
                        "TaxType": "Input Tax",
                        "text": "A5 - PURCHASE MST 13.5% (Non Vatable)-MAHARASHTRA"
                    },
                    {
                        "value": "A6",
                        "TaxType": "Input Tax",
                        "text": "A6 - PURCHASE GST 15% (Non Vatable)"
                    },
                    {
                        "value": "A7",
                        "TaxType": "Input Tax",
                        "text": "A7 - PURCHASE MST 12.5% (Non Vatable)-MAHARASHTRA"
                    },
                    {
                        "value": "A8",
                        "TaxType": "Input Tax",
                        "text": "A8 - Fuel (Gas) Purch (Jhagadia) - VAT  12.5% + 2.5%"
                    },
                    {
                        "value": "A9",
                        "TaxType": "Input Tax",
                        "text": "A9 - PURCHASE CST 1% With Form C"
                    },
                    {
                        "value": "AA",
                        "TaxType": "Output Tax",
                        "text": "AA - Sales -Andhra Pradesh - VAT  0%"
                    },
                    {
                        "value": "AB",
                        "TaxType": "Output Tax",
                        "text": "AB - Sales -Assam - VAT  0%"
                    },
                    {
                        "value": "AC",
                        "TaxType": "Output Tax",
                        "text": "AC - Sales -Bihar - VAT  0%"
                    },
                    {
                        "value": "AD",
                        "TaxType": "Output Tax",
                        "text": "AD - Sales -Gujarat - VAT  0%"
                    },
                    {
                        "value": "AE",
                        "TaxType": "Output Tax",
                        "text": "AE - VAT DAMAN  0%"
                    },
                    {
                        "value": "AF",
                        "TaxType": "Output Tax",
                        "text": "AF - Sales -Himachal Pradesh - VAT  0%"
                    },
                    {
                        "value": "AG",
                        "TaxType": "Output Tax",
                        "text": "AG - VAT  0%"
                    },
                    {
                        "value": "AH",
                        "TaxType": "Output Tax",
                        "text": "AH - Sales - - VAT  0%"
                    },
                    {
                        "value": "AI",
                        "TaxType": "Output Tax",
                        "text": "AI - Sales - Kerala - VAT  0%"
                    },
                    {
                        "value": "AJ",
                        "TaxType": "Output Tax",
                        "text": "AJ - Sales - Madhya Pradesh - VAT  0%"
                    },
                    {
                        "value": "AK",
                        "TaxType": "Output Tax",
                        "text": "AK - Sales - Maharashtra - VAT  0%"
                    },
                    {
                        "value": "AL",
                        "TaxType": "Output Tax",
                        "text": "AL - Sales - Manipur - VAT  0%"
                    },
                    {
                        "value": "AM",
                        "TaxType": "Output Tax",
                        "text": "AM - Sales - Mizoram - VAT  0%"
                    },
                    {
                        "value": "AN",
                        "TaxType": "Output Tax",
                        "text": "AN - Sales - Orissa - VAT  0%"
                    },
                    {
                        "value": "AO",
                        "TaxType": "Output Tax",
                        "text": "AO - Sales -Rajasthan - VAT  0%"
                    },
                    {
                        "value": "AP",
                        "TaxType": "Output Tax",
                        "text": "AP - Sales -Tamil Nadu - VAT  0%"
                    },
                    {
                        "value": "AQ",
                        "TaxType": "Output Tax",
                        "text": "AQ - Sales -Tripura - VAT  0%"
                    },
                    {
                        "value": "AR",
                        "TaxType": "Output Tax",
                        "text": "AR - Sales -Uttar Pradesh - VAT  0%"
                    },
                    {
                        "value": "AS",
                        "TaxType": "Output Tax",
                        "text": "AS - Sales -West Bengal - VAT  0%"
                    },
                    {
                        "value": "AT",
                        "TaxType": "Output Tax",
                        "text": "AT - Sales -Chandigarh - VAT  0%"
                    },
                    {
                        "value": "AU",
                        "TaxType": "Output Tax",
                        "text": "AU - Sales -Delhi - VAT  0%"
                    },
                    {
                        "value": "AV",
                        "TaxType": "Output Tax",
                        "text": "AV - Sales -Jharkand - VAT  0%"
                    },
                    {
                        "value": "AW",
                        "TaxType": "Output Tax",
                        "text": "AW - Sales -Uttaranchal - VAT  0%"
                    },
                    {
                        "value": "AX",
                        "TaxType": "Output Tax",
                        "text": "AX - Sales -Chattisgarh - VAT  0%"
                    },
                    {
                        "value": "AY",
                        "TaxType": "Output Tax",
                        "text": "AY - Sales- without Excise against Form-  H(Local)"
                    },
                    {
                        "value": "AZ",
                        "TaxType": "Output Tax",
                        "text": "AZ - Sales- without Excise against Form - I"
                    },
                    {
                        "value": "B1",
                        "TaxType": "Input Tax",
                        "text": "B1 - West Bengal INPUT VAT -  (With Excise)"
                    },
                    {
                        "value": "B2",
                        "TaxType": "Input Tax",
                        "text": "B2 - West Bengal INPUT VAT PROJ  (With Excise)"
                    },
                    {
                        "value": "B3",
                        "TaxType": "Input Tax",
                        "text": "B3 - West Bengal INPUT VAT(HALDIA)   (Without Excise)"
                    },
                    {
                        "value": "B4",
                        "TaxType": "Input Tax",
                        "text": "B4 - West Bengal INPUT VAT  (Without  Excise)"
                    },
                    {
                        "value": "B5",
                        "TaxType": "Input Tax",
                        "text": "B5 - Purchases - MST- 5% (Non Vatable)-MAHARASHTRA"
                    },
                    {
                        "value": "B6",
                        "TaxType": "Input Tax",
                        "text": "B6 - Purchases - MST- 5.5% (Non Vatable)-MAHARASHTRA"
                    },
                    {
                        "value": "B8",
                        "TaxType": "Output Tax",
                        "text": "B8 - Free Sample with Excise"
                    },
                    {
                        "value": "B9",
                        "TaxType": "Input Tax",
                        "text": "B9 - Other -- Exp. Gujrat"
                    },
                    {
                        "value": "BA",
                        "TaxType": "Output Tax",
                        "text": "BA - Sales -Assam - CST  0%"
                    },
                    {
                        "value": "BB",
                        "TaxType": "Output Tax",
                        "text": "BB - Sales -Bihar - CST  0%"
                    },
                    {
                        "value": "BC",
                        "TaxType": "Output Tax",
                        "text": "BC - Sales -Gujarat - CST  0%"
                    },
                    {
                        "value": "BD",
                        "TaxType": "Output Tax",
                        "text": "BD - HARYANA CST 0%"
                    },
                    {
                        "value": "BE",
                        "TaxType": "Output Tax",
                        "text": "BE - Sales - Jammu - 0% CST"
                    },
                    {
                        "value": "BF",
                        "TaxType": "Output Tax",
                        "text": "BF - Sales - Kerala - CST  0%"
                    },
                    {
                        "value": "BG",
                        "TaxType": "Output Tax",
                        "text": "BG - Sales - Maharashtra - CST  0%"
                    },
                    {
                        "value": "BH",
                        "TaxType": "Output Tax",
                        "text": "BH - Sales -Punjab - CST  0%"
                    },
                    {
                        "value": "BI",
                        "TaxType": "Output Tax",
                        "text": "BI - Sales -Rajasthan - CST  0%"
                    },
                    {
                        "value": "BJ",
                        "TaxType": "Output Tax",
                        "text": "BJ - Sales -Tamil Nadu - CST  0%"
                    },
                    {
                        "value": "BK",
                        "TaxType": "Output Tax",
                        "text": "BK - Sales -Uttar Pradesh - CST  0%"
                    },
                    {
                        "value": "BL",
                        "TaxType": "Output Tax",
                        "text": "BL - Sales -West Bengal - CST  0%"
                    },
                    {
                        "value": "BM",
                        "TaxType": "Output Tax",
                        "text": "BM - DAMAN CST  0%"
                    },
                    {
                        "value": "BN",
                        "TaxType": "Output Tax",
                        "text": "BN - Sales - 0% High sea sale(Jhagadia)"
                    },
                    {
                        "value": "BP",
                        "TaxType": "Output Tax",
                        "text": "BP - Not to Use(deactivated)"
                    },
                    {
                        "value": "BR",
                        "TaxType": "Output Tax",
                        "text": "BR - Sales -Tamil Nadu VAT - (with Excise)"
                    },
                    {
                        "value": "BS",
                        "TaxType": "Output Tax",
                        "text": "BS - Sales -GAUWHATI- 4% without form  C"
                    },
                    {
                        "value": "BT",
                        "TaxType": "Output Tax",
                        "text": "BT - Sales -GAUWHATI- 5% without form  C"
                    },
                    {
                        "value": "BU",
                        "TaxType": "Output Tax",
                        "text": "BU - Sales under Form H-With excise-No Tax"
                    },
                    {
                        "value": "BV",
                        "TaxType": "Output Tax",
                        "text": "BV - Sales -Bihar- VAT-5%"
                    },
                    {
                        "value": "BW",
                        "TaxType": "Output Tax",
                        "text": "BW - Sales -Haryana Vat 12.5%"
                    },
                    {
                        "value": "BX",
                        "TaxType": "Output Tax",
                        "text": "BX - 0% Tax on Rm/Pm(Gujurat)"
                    },
                    {
                        "value": "BY",
                        "TaxType": "Output Tax",
                        "text": "BY - Sales -Kerala-VAT-5%"
                    },
                    {
                        "value": "BZ",
                        "TaxType": "Output Tax",
                        "text": "BZ - Sales -Bihar- VAT-6%"
                    },
                    {
                        "value": "C1",
                        "TaxType": "Output Tax",
                        "text": "C1 - Sales  (IC/CA) - CST- 2%  Agnst form ' C '"
                    },
                    {
                        "value": "C2",
                        "TaxType": "Output Tax",
                        "text": "C2 - Sales - Gujarat CST 2%  Agnst form ' C '"
                    },
                    {
                        "value": "C3",
                        "TaxType": "Output Tax",
                        "text": "C3 - Sales - Jhagadia CST- 2%  Agnst form ' C '"
                    },
                    {
                        "value": "C4",
                        "TaxType": "Output Tax",
                        "text": "C4 - Sales - Andhra Pradesh- CST-2%"
                    },
                    {
                        "value": "C5",
                        "TaxType": "Output Tax",
                        "text": "C5 - Sales -Assam - CST- Regd - 2%"
                    },
                    {
                        "value": "C6",
                        "TaxType": "Output Tax",
                        "text": "C6 - Sales -Bihar- CST-2%"
                    },
                    {
                        "value": "C7",
                        "TaxType": "Output Tax",
                        "text": "C7 - Sales -Daman -CST -2%"
                    },
                    {
                        "value": "C8",
                        "TaxType": "Output Tax",
                        "text": "C8 - Sales -Haryana-CST - 2%"
                    },
                    {
                        "value": "C9",
                        "TaxType": "Output Tax",
                        "text": "C9 - Sales -Karnataka- CST-2%"
                    },
                    {
                        "value": "CA",
                        "TaxType": "Output Tax",
                        "text": "CA - Sales  (IC/CA) - CST- 3%  Agnst form ' C '"
                    },
                    {
                        "value": "CB",
                        "TaxType": "Output Tax",
                        "text": "CB - Sales - Gujarat CST 3%  Agnst form ' C '"
                    },
                    {
                        "value": "CC",
                        "TaxType": "Output Tax",
                        "text": "CC - Sales - Jhagadia CST- 3%  Agnst form ' C '"
                    },
                    {
                        "value": "CD",
                        "TaxType": "Output Tax",
                        "text": "CD - Sales - Andhra Pradesh- CST-3%"
                    },
                    {
                        "value": "CE",
                        "TaxType": "Output Tax",
                        "text": "CE - Sales -Assam - CST- Regd - 3%"
                    },
                    {
                        "value": "CF",
                        "TaxType": "Output Tax",
                        "text": "CF - Sales -Bihar- CST-3%"
                    },
                    {
                        "value": "CG",
                        "TaxType": "Output Tax",
                        "text": "CG - Sales -Daman -CST -3%"
                    },
                    {
                        "value": "CH",
                        "TaxType": "Output Tax",
                        "text": "CH - Sales -Haryana-CST - 3%"
                    },
                    {
                        "value": "CI",
                        "TaxType": "Output Tax",
                        "text": "CI - Sales -Karnataka- CST-3%"
                    },
                    {
                        "value": "CJ",
                        "TaxType": "Output Tax",
                        "text": "CJ - Sales -Maharastra - CST - 3% Agnst Form ' C'"
                    },
                    {
                        "value": "CK",
                        "TaxType": "Output Tax",
                        "text": "CK - Sales -Orissa- CST - 3% Regds Dealer"
                    },
                    {
                        "value": "CL",
                        "TaxType": "Output Tax",
                        "text": "CL - Sales -Punjab - CST - 3%"
                    },
                    {
                        "value": "CM",
                        "TaxType": "Output Tax",
                        "text": "CM - Sales -Rajasthan- CST- 3 %"
                    },
                    {
                        "value": "CN",
                        "TaxType": "Output Tax",
                        "text": "CN - Sales -Tamil Nadu-CST - 3%"
                    },
                    {
                        "value": "CO",
                        "TaxType": "Output Tax",
                        "text": "CO - Sales -Uttar Pradesh - CST-3%"
                    },
                    {
                        "value": "CP",
                        "TaxType": "Output Tax",
                        "text": "CP - Sales -West Bengal- CST - 3% REGD"
                    },
                    {
                        "value": "CQ",
                        "TaxType": "Output Tax",
                        "text": "CQ - Sales - Jammu CST VAT 3%"
                    },
                    {
                        "value": "CR",
                        "TaxType": "Output Tax",
                        "text": "CR - Sales - Andhra Pradesh- CST -3% (with Excise)"
                    },
                    {
                        "value": "CS",
                        "TaxType": "Output Tax",
                        "text": "CS - Sales -West Bengal- CST - 3% (With excise)"
                    },
                    {
                        "value": "CT",
                        "TaxType": "Output Tax",
                        "text": "CT - Sales -Kerala  CST - 3% (Without excise)"
                    },
                    {
                        "value": "CU",
                        "TaxType": "Output Tax",
                        "text": "CU - Sales - Gujarat CST 0%  Agnst form 'I '"
                    },
                    {
                        "value": "CV",
                        "TaxType": "Output Tax",
                        "text": "CV - Sales -Uttar Pradesh - LST- 12% + 1% Dev Tax"
                    },
                    {
                        "value": "CW",
                        "TaxType": "Output Tax",
                        "text": "CW - Sales - Guj CST 3%  Agnst form ' C ' without excis"
                    },
                    {
                        "value": "CX",
                        "TaxType": "Output Tax",
                        "text": "CX - Sales - Jhagadia CST 0%  Agnst form 'I '"
                    },
                    {
                        "value": "CY",
                        "TaxType": "Output Tax",
                        "text": "CY - Sales - Gujarat Vat 4% (Without Excise)"
                    },
                    {
                        "value": "CZ",
                        "TaxType": "Output Tax",
                        "text": "CZ - not to use"
                    },
                    {
                        "value": "D0",
                        "TaxType": "Input Tax",
                        "text": "D0 - Service Tax - Vapi-12.3%"
                    },
                    {
                        "value": "D1",
                        "TaxType": "Input Tax",
                        "text": "D1 - Service Tax - Ankleshwar U-1-12.3%"
                    },
                    {
                        "value": "D2",
                        "TaxType": "Input Tax",
                        "text": "D2 - Service Tax - Ankleshwar U-2-12.3%"
                    },
                    {
                        "value": "D3",
                        "TaxType": "Input Tax",
                        "text": "D3 - Service Tax - Ankleshwar U-3-12.3%"
                    },
                    {
                        "value": "D4",
                        "TaxType": "Input Tax",
                        "text": "D4 - Service Tax - Halol-12.3%"
                    },
                    {
                        "value": "D5",
                        "TaxType": "Input Tax",
                        "text": "D5 - Service Tax - Jhagadia-12.3%"
                    },
                    {
                        "value": "D6",
                        "TaxType": "Input Tax",
                        "text": "D6 - Service Tax - SCIL Vapi-12.3%"
                    },
                    {
                        "value": "D7",
                        "TaxType": "Input Tax",
                        "text": "D7 - Service Tax - Nerka Vapi-12.3%"
                    },
                    {
                        "value": "D8",
                        "TaxType": "Input Tax",
                        "text": "D8 - Service Tax - Haldia-12.3%"
                    },
                    {
                        "value": "D9",
                        "TaxType": "Input Tax",
                        "text": "D9 - Service Tax - HO-12.3%"
                    },
                    {
                        "value": "DG",
                        "TaxType": "Output Tax",
                        "text": "DG - SALES-Indore (MP) CST 2 %  Agnst Form C w/o Excise"
                    },
                    {
                        "value": "DJ",
                        "TaxType": "Output Tax",
                        "text": "DJ - Sales -Maharastra - CST -2% Agnst Form ' C'"
                    },
                    {
                        "value": "DK",
                        "TaxType": "Output Tax",
                        "text": "DK - Sales -Orissa- CST - 2% Regds Dealer"
                    },
                    {
                        "value": "DL",
                        "TaxType": "Output Tax",
                        "text": "DL - Sales -Punjab - CST - 2%"
                    },
                    {
                        "value": "DM",
                        "TaxType": "Output Tax",
                        "text": "DM - Sales -Rajasthan- CST- 2 %"
                    },
                    {
                        "value": "DN",
                        "TaxType": "Output Tax",
                        "text": "DN - Sales -Tamil Nadu-CST - 2%"
                    },
                    {
                        "value": "DO",
                        "TaxType": "Output Tax",
                        "text": "DO - Sales -Uttar Pradesh - CST-2%"
                    },
                    {
                        "value": "DP",
                        "TaxType": "Output Tax",
                        "text": "DP - Sales -West Bengal- CST - 2% REGD"
                    },
                    {
                        "value": "DQ",
                        "TaxType": "Output Tax",
                        "text": "DQ - Sales - Jammu CST VAT 2%"
                    },
                    {
                        "value": "DR",
                        "TaxType": "Output Tax",
                        "text": "DR - Sales - Andhra Pradesh- CST -2% (with Excise)"
                    },
                    {
                        "value": "DS",
                        "TaxType": "Output Tax",
                        "text": "DS - Sales -West Bengal- CST - 2% (With excise)"
                    },
                    {
                        "value": "DT",
                        "TaxType": "Output Tax",
                        "text": "DT - Sales -Kerala  CST - 2% (Without excise)"
                    },
                    {
                        "value": "DU",
                        "TaxType": "Output Tax",
                        "text": "DU - Sales -Jhagadia  Vat 5%(Without Excise)"
                    },
                    {
                        "value": "DW",
                        "TaxType": "Output Tax",
                        "text": "DW - Sales - Guj CST 2%  Agnst form ' C ' without excis"
                    },
                    {
                        "value": "DX",
                        "TaxType": "Output Tax",
                        "text": "DX - Sales - Tamil Nandu 2% (with Excise)"
                    },
                    {
                        "value": "DY",
                        "TaxType": "Output Tax",
                        "text": "DY - Sales - Gujarat Vat 5% (Without Excise)"
                    },
                    {
                        "value": "DZ",
                        "TaxType": "Output Tax",
                        "text": "DZ - Sales -West Bengal-(HALDIA FACTORY) VAT - 4%"
                    },
                    {
                        "value": "E1",
                        "TaxType": "Output Tax",
                        "text": "E1 - output tax(jain)-160654"
                    },
                    {
                        "value": "E2",
                        "TaxType": "Output Tax",
                        "text": "E2 - Sales -UP-Export to Nepal"
                    },
                    {
                        "value": "EA",
                        "TaxType": "Input Tax",
                        "text": "EA - TAX FREE/EXEMPTED GOODS-CST-0% -NO Form C"
                    },
                    {
                        "value": "EB",
                        "TaxType": "Output Tax",
                        "text": "EB - Sales -Haryana-VAT - 5.25%(Plant Growth Promoters)"
                    },
                    {
                        "value": "EC",
                        "TaxType": "Output Tax",
                        "text": "EC - Sales -PUNJAB-VAT - 5.50%"
                    },
                    {
                        "value": "ED",
                        "TaxType": "Output Tax",
                        "text": "ED - Sales - PUNJAB ST- 5.5% Without Form  C"
                    },
                    {
                        "value": "EE",
                        "TaxType": "Output Tax",
                        "text": "EE - Sales - Punjab- CST -2% (with Excise)"
                    },
                    {
                        "value": "EF",
                        "TaxType": "Output Tax",
                        "text": "EF - Sales -Maharastra - CST - 12.5% without form  C"
                    },
                    {
                        "value": "EG",
                        "TaxType": "Output Tax",
                        "text": "EG - INTERSTATE SALE(BOND)  FORM C 2% (WITOUT EXCISE)"
                    },
                    {
                        "value": "EH",
                        "TaxType": "Output Tax",
                        "text": "EH - Sales -Punjab - CST - 5.5% without form  C"
                    },
                    {
                        "value": "EI",
                        "TaxType": "Output Tax",
                        "text": "EI - Sales -Kerala VAT 4.04%- (with Excise)"
                    },
                    {
                        "value": "EJ",
                        "TaxType": "Output Tax",
                        "text": "EJ - Sales - Tamil Nadu- VAT -0%(with Excise)-Karamadai"
                    },
                    {
                        "value": "EK",
                        "TaxType": "Output Tax",
                        "text": "EK - Sales -VAT -0%(with Excise)-Kerala"
                    },
                    {
                        "value": "EL",
                        "TaxType": "Output Tax",
                        "text": "EL - SALES- PUNJAB- VAT- 6.05%"
                    },
                    {
                        "value": "EM",
                        "TaxType": "Output Tax",
                        "text": "EM - SALES- PUNJAB- VAT- 4.95%"
                    },
                    {
                        "value": "EN",
                        "TaxType": "Output Tax",
                        "text": "EN - sales-Uttar Pradesh Vat 5%(dummy for Fi entry)"
                    },
                    {
                        "value": "EO",
                        "TaxType": "Output Tax",
                        "text": "EO - SALES- PUNJAB- VAT- 4.95%(Without Form C)"
                    },
                    {
                        "value": "EP",
                        "TaxType": "Output Tax",
                        "text": "EP - Sales - CST- 2% Agnst form ' C '(TARAPUR)-Mah"
                    },
                    {
                        "value": "EQ",
                        "TaxType": "Output Tax",
                        "text": "EQ - Sales - CST-2% form ' C '(TARAPUR)-(without excise"
                    },
                    {
                        "value": "ER",
                        "TaxType": "Output Tax",
                        "text": "ER - CST -Sales -Without Excise-(ARE1 AND FORM-'I"
                    },
                    {
                        "value": "ES",
                        "TaxType": "Output Tax",
                        "text": "ES - Sales -Haryana-VAT - 13.125%(plant Growth Promothe"
                    },
                    {
                        "value": "ET",
                        "TaxType": "Output Tax",
                        "text": "ET - Sales - Stock Transfer (FTWZ)"
                    },
                    {
                        "value": "EU",
                        "TaxType": "Output Tax",
                        "text": "EU - Sales -Haryana-VAT - 4.20%(plant Growth Promoters)"
                    },
                    {
                        "value": "EV",
                        "TaxType": "Output Tax",
                        "text": "EV - SWAL-Jammu & Kashmir VAT 0% (without excise)"
                    },
                    {
                        "value": "EW",
                        "TaxType": "Output Tax",
                        "text": "EW - SWAL-Jammu & Kashmir CST 2%(without excise)"
                    },
                    {
                        "value": "EX",
                        "TaxType": "Output Tax",
                        "text": "EX - Sales -Maharashtra-VAT 13.5%"
                    },
                    {
                        "value": "EY",
                        "TaxType": "Output Tax",
                        "text": "EY - Sales -Maharastra - CST - 13.5% without form  C"
                    },
                    {
                        "value": "F0",
                        "TaxType": "Output Tax",
                        "text": "F0 - Output GST 0%"
                    },
                    {
                        "value": "F1",
                        "TaxType": "Input Tax",
                        "text": "F1 - Service Tax -THANE"
                    },
                    {
                        "value": "F2",
                        "TaxType": "Input Tax",
                        "text": "F2 - Service Tax - Vapi-14%"
                    },
                    {
                        "value": "F3",
                        "TaxType": "Input Tax",
                        "text": "F3 - Service Tax - Ankleshwar U-1-14%"
                    },
                    {
                        "value": "F4",
                        "TaxType": "Input Tax",
                        "text": "F4 - Service Tax - Ankleshwar U-2-14%"
                    },
                    {
                        "value": "F5",
                        "TaxType": "Input Tax",
                        "text": "F5 - Service Tax - Ankleshwar U-3-14%"
                    },
                    {
                        "value": "F6",
                        "TaxType": "Input Tax",
                        "text": "F6 - Service Tax - Halol-14%"
                    },
                    {
                        "value": "F7",
                        "TaxType": "Input Tax",
                        "text": "F7 - Service Tax - Jhagadia-14%"
                    },
                    {
                        "value": "F8",
                        "TaxType": "Input Tax",
                        "text": "F8 - Service Tax - SCIL Vapi-14%"
                    },
                    {
                        "value": "F9",
                        "TaxType": "Input Tax",
                        "text": "F9 - Service Tax - Nerka Vapi-14%"
                    },
                    {
                        "value": "FA",
                        "TaxType": "Output Tax",
                        "text": "FA - FI - Output SGST 2.5% + CGST 2.5%"
                    },
                    {
                        "value": "FB",
                        "TaxType": "Output Tax",
                        "text": "FB - FI - Output SGST 6% + CGST 6%"
                    },
                    {
                        "value": "FC",
                        "TaxType": "Output Tax",
                        "text": "FC - FI - Output SGST 9% + CGST 9%"
                    },
                    {
                        "value": "FD",
                        "TaxType": "Output Tax",
                        "text": "FD - FI - Output SGST 14% + CGST 14%"
                    },
                    {
                        "value": "FG",
                        "TaxType": "Output Tax",
                        "text": "FG - FI - Output IGST 5%"
                    },
                    {
                        "value": "FH",
                        "TaxType": "Output Tax",
                        "text": "FH - FI - Output IGST 12%"
                    },
                    {
                        "value": "FI",
                        "TaxType": "Output Tax",
                        "text": "FI - FI - Output IGST 18%"
                    },
                    {
                        "value": "FJ",
                        "TaxType": "Output Tax",
                        "text": "FJ - FI - Output IGST 28%"
                    },
                    {
                        "value": "FM",
                        "TaxType": "Output Tax",
                        "text": "FM - FI - Output UTGST 2.5% + CGST 2.5%"
                    },
                    {
                        "value": "FN",
                        "TaxType": "Output Tax",
                        "text": "FN - FI - Output UTGST 6% + CGST 6%"
                    },
                    {
                        "value": "FO",
                        "TaxType": "Output Tax",
                        "text": "FO - FI - Output UTGST 9% + CGST 9%"
                    },
                    {
                        "value": "FP",
                        "TaxType": "Output Tax",
                        "text": "FP - FI - Output UTGST 14% + CGST 14%"
                    },
                    {
                        "value": "FQ",
                        "TaxType": "Output Tax",
                        "text": "FQ - Trasnfer balance no tax"
                    },
                    {
                        "value": "FR",
                        "TaxType": "Output Tax",
                        "text": "FR - FI - Output IGST 0.10%"
                    },
                    {
                        "value": "FS",
                        "TaxType": "Output Tax",
                        "text": "FS - TDS ON PAYMENT BY E COMMERCE"
                    },
                    {
                        "value": "G0",
                        "TaxType": "Input Tax",
                        "text": "G0 - Service Tax - Haldia-14%"
                    },
                    {
                        "value": "G1",
                        "TaxType": "Input Tax",
                        "text": "G1 - Service Tax - HO-14%"
                    },
                    {
                        "value": "G2",
                        "TaxType": "Input Tax",
                        "text": "G2 - Service TAX-THANE 14%"
                    },
                    {
                        "value": "G3",
                        "TaxType": "Input Tax",
                        "text": "G3 - Service Tax-Tarapur 14%"
                    },
                    {
                        "value": "G4",
                        "TaxType": "Input Tax",
                        "text": "G4 - Service Tax - Ankleshwar U-11-14%"
                    },
                    {
                        "value": "G5",
                        "TaxType": "Input Tax",
                        "text": "G5 - Service Tax - Haldia-14+0.5+0.5"
                    },
                    {
                        "value": "GA",
                        "TaxType": "Input Tax",
                        "text": "GA - Service Tax - Vapi 10.30%"
                    },
                    {
                        "value": "GB",
                        "TaxType": "Input Tax",
                        "text": "GB - Service Tax - Ankleshwar U-1 10.30%"
                    },
                    {
                        "value": "GC",
                        "TaxType": "Input Tax",
                        "text": "GC - Service Tax - Ankleshwar U-2 10.30%"
                    },
                    {
                        "value": "GD",
                        "TaxType": "Input Tax",
                        "text": "GD - Service Tax - Ankleshwar U-3 10.30%"
                    },
                    {
                        "value": "GE",
                        "TaxType": "Input Tax",
                        "text": "GE - Service Tax - Halol-10.30%"
                    },
                    {
                        "value": "GF",
                        "TaxType": "Input Tax",
                        "text": "GF - Service Tax - Jhagadia-10.30%"
                    },
                    {
                        "value": "GG",
                        "TaxType": "Input Tax",
                        "text": "GG - Service Tax - SCIL Vapi-10.30%"
                    },
                    {
                        "value": "GH",
                        "TaxType": "Input Tax",
                        "text": "GH - Service Tax - Nerka Vapi-10.30%"
                    },
                    {
                        "value": "GI",
                        "TaxType": "Input Tax",
                        "text": "GI - Service Tax - Haldia-10.30%"
                    },
                    {
                        "value": "GJ",
                        "TaxType": "Input Tax",
                        "text": "GJ - Service Tax - HO 10.30%"
                    },
                    {
                        "value": "GK",
                        "TaxType": "Input Tax",
                        "text": "GK - Service Tax -THANE-10.30%"
                    },
                    {
                        "value": "GL",
                        "TaxType": "Input Tax",
                        "text": "GL - Service Tax - Jammu-10.30%"
                    },
                    {
                        "value": "GM",
                        "TaxType": "Input Tax",
                        "text": "GM - Service Tax - Bellary-10.30%"
                    },
                    {
                        "value": "GO",
                        "TaxType": "Output Tax",
                        "text": "GO - Sales- without Excise against Form-  H(Local)"
                    },
                    {
                        "value": "GP",
                        "TaxType": "Output Tax",
                        "text": "GP - Sales under Form H-With excise-No Tax"
                    },
                    {
                        "value": "H0",
                        "TaxType": "Input Tax",
                        "text": "H0 - Import IGST 0%"
                    },
                    {
                        "value": "HA",
                        "TaxType": "Input Tax",
                        "text": "HA - Import IGST 5%"
                    },
                    {
                        "value": "HB",
                        "TaxType": "Input Tax",
                        "text": "HB - Import IGST 12%"
                    },
                    {
                        "value": "HC",
                        "TaxType": "Input Tax",
                        "text": "HC - Import IGST 18%"
                    },
                    {
                        "value": "HD",
                        "TaxType": "Input Tax",
                        "text": "HD - Import IGST 28%"
                    },
                    {
                        "value": "I0",
                        "TaxType": "Input Tax",
                        "text": "I0 - Input IGST 0%"
                    },
                    {
                        "value": "I1",
                        "TaxType": "Input Tax",
                        "text": "I1 - DIRECT IMPORT"
                    },
                    {
                        "value": "I2",
                        "TaxType": "Input Tax",
                        "text": "I2 - HIGH SEA PURCHASE"
                    },
                    {
                        "value": "I3",
                        "TaxType": "Input Tax",
                        "text": "I3 - TAX EXEMPTED IN GUJARAT (WITHOUT C FORM)"
                    },
                    {
                        "value": "I4",
                        "TaxType": "Input Tax",
                        "text": "I4 - PURCHASE  CST - 0%  AGAINST FORM C"
                    },
                    {
                        "value": "I5",
                        "TaxType": "Input Tax",
                        "text": "I5 - PURCHASE GST 0 % against FORM 40"
                    },
                    {
                        "value": "I6",
                        "TaxType": "Input Tax",
                        "text": "I6 - PURCHASE GST 13%"
                    },
                    {
                        "value": "I7",
                        "TaxType": "Input Tax",
                        "text": "I7 - PURCHASE CST 2%"
                    },
                    {
                        "value": "I8",
                        "TaxType": "Input Tax",
                        "text": "I8 - PURCHASE  Maharashtra - 12.5% VAT"
                    },
                    {
                        "value": "I9",
                        "TaxType": "Input Tax",
                        "text": "I9 - PURCHASE CST 2% + 0.2% Niryat Kar"
                    },
                    {
                        "value": "IA",
                        "TaxType": "Input Tax",
                        "text": "IA - PURCHASE VAT 1.2% Gold  and Silver - Maharashtra"
                    },
                    {
                        "value": "IB",
                        "TaxType": "Input Tax",
                        "text": "IB - CST 6% WITHOUT  C FORM"
                    },
                    {
                        "value": "IC",
                        "TaxType": "Input Tax",
                        "text": "IC - PURCHASE CST 13.5 % W/O FORM C"
                    },
                    {
                        "value": "ID",
                        "TaxType": "Input Tax",
                        "text": "ID - PURCHASE CST 5.5 % W/O FORM C"
                    },
                    {
                        "value": "IE",
                        "TaxType": "Input Tax",
                        "text": "IE - PURCHASE VAT  5.5%  NON VATABLE"
                    },
                    {
                        "value": "IF",
                        "TaxType": "Input Tax",
                        "text": "IF - PURCHASE VAT  6%  NON VATABLE"
                    },
                    {
                        "value": "IG",
                        "TaxType": "Input Tax",
                        "text": "IG - PURCHASE VAT  13.5%  NON VATABLE"
                    },
                    {
                        "value": "J0",
                        "TaxType": "Input Tax",
                        "text": "J0 - Jammu - PURCHASE  CST-0% against form C"
                    },
                    {
                        "value": "J1",
                        "TaxType": "Input Tax",
                        "text": "J1 - Jammu Input CST - 4.%  Against Form C"
                    },
                    {
                        "value": "J2",
                        "TaxType": "Input Tax",
                        "text": "J2 - Jammu Input Vat - 4.%"
                    },
                    {
                        "value": "J3",
                        "TaxType": "Input Tax",
                        "text": "J3 - Service Tax - Jammu"
                    },
                    {
                        "value": "J4",
                        "TaxType": "Input Tax",
                        "text": "J4 - Jammu Input Vat - 12.5.%"
                    },
                    {
                        "value": "J5",
                        "TaxType": "Input Tax",
                        "text": "J5 - Jammu VAT/ Price Adj Method 4 %"
                    },
                    {
                        "value": "J6",
                        "TaxType": "Input Tax",
                        "text": "J6 - Jammu VAT/ Price Adj Method 12.5 %"
                    },
                    {
                        "value": "J7",
                        "TaxType": "Input Tax",
                        "text": "J7 - PURCHASE VAT  0%  - JAMMU"
                    },
                    {
                        "value": "J8",
                        "TaxType": "Input Tax",
                        "text": "J8 - Jammu - PURCHASE  CST-12.5% w/o C FORM (w/o excise"
                    },
                    {
                        "value": "J9",
                        "TaxType": "Input Tax",
                        "text": "J9 - Jammu - PURCHASE  CST-1% against form C"
                    },
                    {
                        "value": "JA",
                        "TaxType": "Input Tax",
                        "text": "JA - Jammu Input VAT 5%"
                    },
                    {
                        "value": "JB",
                        "TaxType": "Input Tax",
                        "text": "JB - Jammu Input VAT 13.5%"
                    },
                    {
                        "value": "JC",
                        "TaxType": "Input Tax",
                        "text": "JC - Jammu VAT/ Price Adj Method 5%"
                    },
                    {
                        "value": "JD",
                        "TaxType": "Input Tax",
                        "text": "JD - Jammu VAT/ Price Adj Method 13.5%"
                    },
                    {
                        "value": "JE",
                        "TaxType": "Output Tax",
                        "text": "JE - Jammu Local Output VAT 5%"
                    },
                    {
                        "value": "JF",
                        "TaxType": "Output Tax",
                        "text": "JF - Jammu Local Output VAT 13.5%"
                    },
                    {
                        "value": "JG",
                        "TaxType": "Output Tax",
                        "text": "JG - Sales -Jharkhand LST 5%"
                    },
                    {
                        "value": "JH",
                        "TaxType": "Input Tax",
                        "text": "JH - Maharashtra Purc  CST-14.5% w/o C FORM (wit excise"
                    },
                    {
                        "value": "JI",
                        "TaxType": "Input Tax",
                        "text": "JI - Gujarat Purc  CST-14.5% w/o C FORM (wit excise"
                    },
                    {
                        "value": "JJ",
                        "TaxType": "Input Tax",
                        "text": "JJ - Gujarat Purc  CST-14.5% w/o C FORM (without excise"
                    },
                    {
                        "value": "JK",
                        "TaxType": "Input Tax",
                        "text": "JK - Proj Mach /Capital Goods VAT 5% - Maharashtra"
                    },
                    {
                        "value": "JL",
                        "TaxType": "Input Tax",
                        "text": "JL - Proj Mach /Capital Goods VAT  12.5%"
                    },
                    {
                        "value": "JM",
                        "TaxType": "Input Tax",
                        "text": "JM - Mahrastra Input VAT 5% - Maharashtra(with excise)"
                    },
                    {
                        "value": "JN",
                        "TaxType": "Input Tax",
                        "text": "JN - Mahrastra Input VAT 12.5% - (with excise)"
                    },
                    {
                        "value": "JO",
                        "TaxType": "Input Tax",
                        "text": "JO - Maharashtra  CST-14.5% w/o C FORM (without excise"
                    },
                    {
                        "value": "JP",
                        "TaxType": "Input Tax",
                        "text": "JP - CST 5.5 WITHOUT  C FORM"
                    },
                    {
                        "value": "JQ",
                        "TaxType": "Input Tax",
                        "text": "JQ - Jammu-Purchase CST13.5% W/o C-Form(WithExcise12.5%"
                    },
                    {
                        "value": "JR",
                        "TaxType": "Input Tax",
                        "text": "JR - Gujjarat Purc  CST-12.5% w/o C FORM (wit excise"
                    },
                    {
                        "value": "JS",
                        "TaxType": "Input Tax",
                        "text": "JS - Mahrastra Input VAT 5.5%- Maharashtra(with excise)"
                    },
                    {
                        "value": "JT",
                        "TaxType": "Input Tax",
                        "text": "JT - Proj Mach /Capital Goods VAT 5.5% - Maharashtra"
                    },
                    {
                        "value": "JU",
                        "TaxType": "Input Tax",
                        "text": "JU - Jammu VAT/ Price Adj Method 14.5%"
                    },
                    {
                        "value": "JV",
                        "TaxType": "Input Tax",
                        "text": "JV - Proj Mach /Capital Goods VAT  13.5%"
                    },
                    {
                        "value": "JW",
                        "TaxType": "Input Tax",
                        "text": "JW - Proj Mach /Capital Goods VAT 6% - Maharashtra"
                    },
                    {
                        "value": "JX",
                        "TaxType": "Input Tax",
                        "text": "JX - Mahrastra Input VAT 6%- Maharashtra(with excise)"
                    },
                    {
                        "value": "JY",
                        "TaxType": "Input Tax",
                        "text": "JY - Maharashtra Input Vat  13.5%  (Without Excise)"
                    },
                    {
                        "value": "JZ",
                        "TaxType": "Input Tax",
                        "text": "JZ - Mahrastra Input VAT 13.5% - (with excise)"
                    },
                    {
                        "value": "K1",
                        "TaxType": "Input Tax",
                        "text": "K1 - Purchase Vat 0%-Madhya Pradesh"
                    },
                    {
                        "value": "K2",
                        "TaxType": "Input Tax",
                        "text": "K2 - Purchase Vat 0%-Gujarat"
                    },
                    {
                        "value": "K3",
                        "TaxType": "Input Tax",
                        "text": "K3 - Purchase Vat 0%-Chattisgarh"
                    },
                    {
                        "value": "K4",
                        "TaxType": "Input Tax",
                        "text": "K4 - Purchase Vat 0%-Maharashtra"
                    },
                    {
                        "value": "K5",
                        "TaxType": "Input Tax",
                        "text": "K5 - Purchase Vat 0%-West Bengal"
                    },
                    {
                        "value": "K6",
                        "TaxType": "Input Tax",
                        "text": "K6 - Purchase Vat 0%-Orissa"
                    },
                    {
                        "value": "K7",
                        "TaxType": "Input Tax",
                        "text": "K7 - Purchase Vat 0%-Assam"
                    },
                    {
                        "value": "K8",
                        "TaxType": "Input Tax",
                        "text": "K8 - Purchase Vat 0%-Bihar"
                    },
                    {
                        "value": "K9",
                        "TaxType": "Input Tax",
                        "text": "K9 - Purchase Vat 0%-Jharkhand"
                    },
                    {
                        "value": "KA",
                        "TaxType": "Input Tax",
                        "text": "KA - Maharashtra Input Vat  5%  (Without Excise)"
                    },
                    {
                        "value": "KB",
                        "TaxType": "Input Tax",
                        "text": "KB - Purchase CST 2% (Without Excise)SWAL"
                    },
                    {
                        "value": "KC",
                        "TaxType": "Input Tax",
                        "text": "KC - PURCHASE  CST - 0.25% Ag Form C"
                    },
                    {
                        "value": "KD",
                        "TaxType": "Input Tax",
                        "text": "KD - Interstat Purchase  :  CST 12.5% with  Excise"
                    },
                    {
                        "value": "KE",
                        "TaxType": "Input Tax",
                        "text": "KE - Maharashtra Input Vat  12.5%  (Without Excise)"
                    },
                    {
                        "value": "KF",
                        "TaxType": "Input Tax",
                        "text": "KF - Purchases - MST- 5% (Non Vatable)-MAHARASHTRA"
                    },
                    {
                        "value": "KG",
                        "TaxType": "Input Tax",
                        "text": "KG - Maharashtra Input Vat  8%  (Works Contract)"
                    },
                    {
                        "value": "KH",
                        "TaxType": "Input Tax",
                        "text": "KH - Karnataka  INPUT VAT 5.5%  (Without Excise)"
                    },
                    {
                        "value": "KI",
                        "TaxType": "Input Tax",
                        "text": "KI - Purchase CST 2% (Without Excise)UPL"
                    },
                    {
                        "value": "KJ",
                        "TaxType": "Input Tax",
                        "text": "KJ - PUR  CST - 2%  AGAINST FORM C (ADAMA)"
                    },
                    {
                        "value": "KK",
                        "TaxType": "Input Tax",
                        "text": "KK - Purchase VAT 5 % - (ADAMA)"
                    },
                    {
                        "value": "KL",
                        "TaxType": "Input Tax",
                        "text": "KL - Purchase VAT 15 % (ADAMA)"
                    },
                    {
                        "value": "KM",
                        "TaxType": "Input Tax",
                        "text": "KM - Purchase VAT 14.5%(TELANGANA)"
                    },
                    {
                        "value": "KN",
                        "TaxType": "Input Tax",
                        "text": "KN - PUR. CST -UNION TERR- INC AG FORM C(ADAMA)"
                    },
                    {
                        "value": "KO",
                        "TaxType": "Input Tax",
                        "text": "KO - Maharashtra Input Vat  5.5%  (Without Excise)"
                    },
                    {
                        "value": "KP",
                        "TaxType": "Input Tax",
                        "text": "KP - EOU Purchase VAT 5 % (Without Excise)"
                    },
                    {
                        "value": "KQ",
                        "TaxType": "Input Tax",
                        "text": "KQ - EOU Purchase CST 2% (Without Excise)"
                    },
                    {
                        "value": "KR",
                        "TaxType": "Input Tax",
                        "text": "KR - Maharashtra Input Vat  6%  (Without Excise)"
                    },
                    {
                        "value": "KS",
                        "TaxType": "Input Tax",
                        "text": "KS - Purchase Jammu cst 2%+service tax 15%"
                    },
                    {
                        "value": "KT",
                        "TaxType": "Input Tax",
                        "text": "KT - Input IGST 18.20%"
                    },
                    {
                        "value": "KU",
                        "TaxType": "Input Tax",
                        "text": "KU - Input SGST 9.10% + CGST 9.10%"
                    },
                    {
                        "value": "L0",
                        "TaxType": "Input Tax",
                        "text": "L0 - Input SGST 0% + CGST 0%"
                    },
                    {
                        "value": "L1",
                        "TaxType": "Input Tax",
                        "text": "L1 - Purchase Vat 0%-Andhra Pradesh"
                    },
                    {
                        "value": "L2",
                        "TaxType": "Input Tax",
                        "text": "L2 - Purchase Vat 0%-Karnataka"
                    },
                    {
                        "value": "L3",
                        "TaxType": "Input Tax",
                        "text": "L3 - Purchase Vat 0%-Tamilnadu"
                    },
                    {
                        "value": "L4",
                        "TaxType": "Input Tax",
                        "text": "L4 - Purchase Vat 0%-Kerala"
                    },
                    {
                        "value": "L5",
                        "TaxType": "Input Tax",
                        "text": "L5 - Purchase Vat 0%-Punjab"
                    },
                    {
                        "value": "L6",
                        "TaxType": "Input Tax",
                        "text": "L6 - Purchase Vat 0%-Rajasthan"
                    },
                    {
                        "value": "L7",
                        "TaxType": "Input Tax",
                        "text": "L7 - Purchase Vat 0%-Uttar Pradesh"
                    },
                    {
                        "value": "L8",
                        "TaxType": "Input Tax",
                        "text": "L8 - Purchase Vat 0%-Uttaranchal"
                    },
                    {
                        "value": "L9",
                        "TaxType": "Input Tax",
                        "text": "L9 - Purchase Vat 0%-Haryana"
                    },
                    {
                        "value": "LA",
                        "TaxType": "Input Tax",
                        "text": "LA - Input SGST 2.5% + CGST 2.5%"
                    },
                    {
                        "value": "LB",
                        "TaxType": "Input Tax",
                        "text": "LB - Input SGST 6% + CGST 6%"
                    },
                    {
                        "value": "LC",
                        "TaxType": "Input Tax",
                        "text": "LC - Input SGST 9% + CGST 9%"
                    },
                    {
                        "value": "LD",
                        "TaxType": "Input Tax",
                        "text": "LD - Input SGST 14% + CGST 14%"
                    },
                    {
                        "value": "LE",
                        "TaxType": "Input Tax",
                        "text": "LE - Input SGST 1.5% + CGST 1.5%"
                    },
                    {
                        "value": "LG",
                        "TaxType": "Input Tax",
                        "text": "LG - Input IGST 5%"
                    },
                    {
                        "value": "LH",
                        "TaxType": "Input Tax",
                        "text": "LH - Input IGST 12%"
                    },
                    {
                        "value": "LI",
                        "TaxType": "Input Tax",
                        "text": "LI - Input IGST 18%"
                    },
                    {
                        "value": "LJ",
                        "TaxType": "Input Tax",
                        "text": "LJ - Input IGST 28%"
                    },
                    {
                        "value": "LK",
                        "TaxType": "Input Tax",
                        "text": "LK - Input IGST 3%"
                    },
                    {
                        "value": "LL",
                        "TaxType": "Input Tax",
                        "text": "LL - TCS SGST Receivable"
                    },
                    {
                        "value": "LM",
                        "TaxType": "Input Tax",
                        "text": "LM - Input UTGST 2.5% + CGST 2.5%"
                    },
                    {
                        "value": "LN",
                        "TaxType": "Input Tax",
                        "text": "LN - Input UTGST 6% + CGST 6%"
                    },
                    {
                        "value": "LO",
                        "TaxType": "Input Tax",
                        "text": "LO - Input UTGST 9% + CGST 9%"
                    },
                    {
                        "value": "LP",
                        "TaxType": "Input Tax",
                        "text": "LP - Input UTGST 14% + CGST 14%"
                    },
                    {
                        "value": "LQ",
                        "TaxType": "Input Tax",
                        "text": "LQ - No Input SGST 2.5% + CGST 2.5%"
                    },
                    {
                        "value": "LR",
                        "TaxType": "Input Tax",
                        "text": "LR - No Input SGST 9% + CGST 9%"
                    },
                    {
                        "value": "LS",
                        "TaxType": "Input Tax",
                        "text": "LS - No Input IGST 5%"
                    },
                    {
                        "value": "LT",
                        "TaxType": "Input Tax",
                        "text": "LT - No Input IGST 18%"
                    },
                    {
                        "value": "LU",
                        "TaxType": "Input Tax",
                        "text": "LU - Input UTGST 1.5% + CGST 1.5%"
                    },
                    {
                        "value": "LV",
                        "TaxType": "Input Tax",
                        "text": "LV - No Input SGST 14% + CGST 14%"
                    },
                    {
                        "value": "LW",
                        "TaxType": "Input Tax",
                        "text": "LW - No Input SGST 6% + CGST 6%"
                    },
                    {
                        "value": "LX",
                        "TaxType": "Input Tax",
                        "text": "LX - No Input IGST 12%"
                    },
                    {
                        "value": "LY",
                        "TaxType": "Input Tax",
                        "text": "LY - No Input IGST 28%"
                    },
                    {
                        "value": "LZ",
                        "TaxType": "Input Tax",
                        "text": "LZ - TCS CGST Receivable"
                    },
                    {
                        "value": "M1",
                        "TaxType": "Input Tax",
                        "text": "M1 - Addn Mach VAT 4 % - Vapi / Ank / Halol"
                    },
                    {
                        "value": "M2",
                        "TaxType": "Input Tax",
                        "text": "M2 - Addn Mach VAT 4 % - Jhagadia"
                    },
                    {
                        "value": "M3",
                        "TaxType": "Input Tax",
                        "text": "M3 - Proj Mach VAT 4 % - Vapi / Ank / Halol"
                    },
                    {
                        "value": "M4",
                        "TaxType": "Input Tax",
                        "text": "M4 - Proj Mach VAT 4 % - Jhagadia"
                    },
                    {
                        "value": "M5",
                        "TaxType": "Input Tax",
                        "text": "M5 - Proj Mach VAT 12.5 % - Vapi / Ank / Halol"
                    },
                    {
                        "value": "M6",
                        "TaxType": "Input Tax",
                        "text": "M6 - Proj Mach VAT 12.5 % - Jhagadia"
                    },
                    {
                        "value": "M9",
                        "TaxType": "Input Tax",
                        "text": "M9 - PURCHASE CST 12.5 % W/O FORM C"
                    },
                    {
                        "value": "MA",
                        "TaxType": "Input Tax",
                        "text": "MA - CST 2 % - Bhiwandi-Maharashtra"
                    },
                    {
                        "value": "MB",
                        "TaxType": "Input Tax",
                        "text": "MB - CST 0 % - Bhiwandi-Maharashtra (No Form)"
                    },
                    {
                        "value": "N1",
                        "TaxType": "Input Tax",
                        "text": "N1 - Uttranchal INPUT VAT 4%  (Without Excise)"
                    },
                    {
                        "value": "N2",
                        "TaxType": "Input Tax",
                        "text": "N2 - Bihar INPUT VAT 4%  (Without Excise)"
                    },
                    {
                        "value": "N3",
                        "TaxType": "Input Tax",
                        "text": "N3 - Madhya Pradesh INPUT VAT 4%  (Without Excise)"
                    },
                    {
                        "value": "N4",
                        "TaxType": "Input Tax",
                        "text": "N4 - JHARKHAND INPUT VAT 4%  (Without Excise)"
                    },
                    {
                        "value": "N5",
                        "TaxType": "Input Tax",
                        "text": "N5 - ASSAM INPUT VAT 4%  (Without Excise)"
                    },
                    {
                        "value": "N6",
                        "TaxType": "Input Tax",
                        "text": "N6 - ORISSA INPUT VAT 4%  (Without Excise)"
                    },
                    {
                        "value": "N7",
                        "TaxType": "Input Tax",
                        "text": "N7 - CHATTISGARH  INPUT VAT 4%  (Without Excise)"
                    },
                    {
                        "value": "N8",
                        "TaxType": "Input Tax",
                        "text": "N8 - CHATTISGARH  INPUT VAT 5%  (Without Excise)"
                    },
                    {
                        "value": "N9",
                        "TaxType": "Input Tax",
                        "text": "N9 - Madhya Pradesh INPUT VAT 5%  (Without Excise)"
                    },
                    {
                        "value": "NA",
                        "TaxType": "Input Tax",
                        "text": "NA - PURCHASE CST 5.25% Without Form C"
                    },
                    {
                        "value": "NB",
                        "TaxType": "Input Tax",
                        "text": "NB - VAT RECEIVABLE (RAJASTHAN) 5%"
                    },
                    {
                        "value": "O1",
                        "TaxType": "Input Tax",
                        "text": "O1 - Purchase  :  5% Vat  (Maharashtra)"
                    },
                    {
                        "value": "O2",
                        "TaxType": "Input Tax",
                        "text": "O2 - CST 14% FULL TAX"
                    },
                    {
                        "value": "O3",
                        "TaxType": "Output Tax",
                        "text": "O3 - Sales - Jammu - 0% CST(with C Form)"
                    },
                    {
                        "value": "O4",
                        "TaxType": "Input Tax",
                        "text": "O4 - Purchase Gujarat  VAT 5 % - SWAL (No Excise)"
                    },
                    {
                        "value": "O5",
                        "TaxType": "Input Tax",
                        "text": "O5 - Input IGST 0.10%"
                    },
                    {
                        "value": "O6",
                        "TaxType": "Input Tax",
                        "text": "O6 - Input SGST 0.05%+ CGST 0.05%"
                    },
                    {
                        "value": "OA",
                        "TaxType": "Input Tax",
                        "text": "OA - Ineligible Input SGST 2.5% + CGST 2.5%"
                    },
                    {
                        "value": "OB",
                        "TaxType": "Input Tax",
                        "text": "OB - Ineligible Input SGST 6% + CGST 6%"
                    },
                    {
                        "value": "OC",
                        "TaxType": "Input Tax",
                        "text": "OC - Ineligible Input SGST 9% + CGST 9%"
                    },
                    {
                        "value": "OD",
                        "TaxType": "Input Tax",
                        "text": "OD - Ineligible Input SGST 14% + CGST 14%"
                    },
                    {
                        "value": "OG",
                        "TaxType": "Input Tax",
                        "text": "OG - Ineligible Input IGST 5%"
                    },
                    {
                        "value": "OH",
                        "TaxType": "Input Tax",
                        "text": "OH - Ineligible Input IGST 12%"
                    },
                    {
                        "value": "OI",
                        "TaxType": "Input Tax",
                        "text": "OI - Ineligible Input IGST 18%"
                    },
                    {
                        "value": "OJ",
                        "TaxType": "Input Tax",
                        "text": "OJ - Ineligible Input IGST 28%"
                    },
                    {
                        "value": "OM",
                        "TaxType": "Input Tax",
                        "text": "OM - Ineligible Input UTGST 2.5% + CGST 2.5%"
                    },
                    {
                        "value": "ON",
                        "TaxType": "Input Tax",
                        "text": "ON - Ineligible Input UTGST 6% + CGST 6%"
                    },
                    {
                        "value": "OO",
                        "TaxType": "Input Tax",
                        "text": "OO - Ineligible Input UTGST 9% + CGST 9%"
                    },
                    {
                        "value": "OP",
                        "TaxType": "Input Tax",
                        "text": "OP - Ineligible Input UTGST 14% + CGST 14%"
                    },
                    {
                        "value": "OQ",
                        "TaxType": "Input Tax",
                        "text": "OQ - TCS IGST Receivable"
                    },
                    {
                        "value": "P1",
                        "TaxType": "Input Tax",
                        "text": "P1 - ProjMachVAT5%-Vapi /Ank /Halol/Jhag(withoutexcise)"
                    },
                    {
                        "value": "P2",
                        "TaxType": "Input Tax",
                        "text": "P2 - PURCHASE  CST-2%  AGAINST FORM C (without excise)"
                    },
                    {
                        "value": "P3",
                        "TaxType": "Input Tax",
                        "text": "P3 - Jammu-Purchase CST 12.5%(WITH EXCISE)"
                    },
                    {
                        "value": "PA",
                        "TaxType": "Input Tax",
                        "text": "PA - Jammu Input CST - 3.%  Against Form C"
                    },
                    {
                        "value": "PB",
                        "TaxType": "Input Tax",
                        "text": "PB - CST 3 % - Third Party Excise"
                    },
                    {
                        "value": "PC",
                        "TaxType": "Input Tax",
                        "text": "PC - PURCHASE  CST 3% INCLUSIVE-  AGAINST FORM C"
                    },
                    {
                        "value": "PD",
                        "TaxType": "Input Tax",
                        "text": "PD - PUR. CST -UNION TERR- INCLUSIVE AGAINST FORM C"
                    },
                    {
                        "value": "PE",
                        "TaxType": "Input Tax",
                        "text": "PE - PURCHASE  CST - 3%  AGAINST FORM C"
                    },
                    {
                        "value": "PF",
                        "TaxType": "Input Tax",
                        "text": "PF - PURCh  CST - 3%  AGAsT FORM C(coimb)without excise"
                    },
                    {
                        "value": "PG",
                        "TaxType": "Input Tax",
                        "text": "PG - ANK / VAPI- PUR CST-12.5% w/o C FORM (w/o excise)"
                    },
                    {
                        "value": "PH",
                        "TaxType": "Input Tax",
                        "text": "PH - ANK / VAPI- PUR CST-4% w/o C FORM (w/o excise)"
                    },
                    {
                        "value": "PI",
                        "TaxType": "Input Tax",
                        "text": "PI - Jammu Input CST - 2.%  Against Form C"
                    },
                    {
                        "value": "PJ",
                        "TaxType": "Input Tax",
                        "text": "PJ - CST 2 % - Third Party Excise"
                    },
                    {
                        "value": "PK",
                        "TaxType": "Input Tax",
                        "text": "PK - PURCHASE  CST 2% INCLUSIVE-  AGAINST FORM C"
                    },
                    {
                        "value": "PL",
                        "TaxType": "Input Tax",
                        "text": "PL - PURCHASE  CST - 2%  AGAINST FORM C"
                    },
                    {
                        "value": "PM",
                        "TaxType": "Input Tax",
                        "text": "PM - PURCh  CST - 2%  AGAsT FORM C(coimb)without excise"
                    },
                    {
                        "value": "PN",
                        "TaxType": "Input Tax",
                        "text": "PN - Proj Mach VAT 5% - Vapi / Ank / Halol/Jhag"
                    },
                    {
                        "value": "PO",
                        "TaxType": "Input Tax",
                        "text": "PO - Proj Mach VAT 5% - Jhagadia"
                    },
                    {
                        "value": "PP",
                        "TaxType": "Output Tax",
                        "text": "PP - PLANT TO PLAN TRANSFER(BASIC EXCISE DUTY)"
                    },
                    {
                        "value": "PQ",
                        "TaxType": "Input Tax",
                        "text": "PQ - Proj Mach VAT 15 % - Vapi / Ank / Halol/Jhag"
                    },
                    {
                        "value": "PR",
                        "TaxType": "Input Tax",
                        "text": "PR - Proj Mach VAT 15 % - Jhagadia"
                    },
                    {
                        "value": "PS",
                        "TaxType": "Input Tax",
                        "text": "PS - PURCH  CST - 2% (FM MUMBAI) AG FORM-C-INTER STATE"
                    },
                    {
                        "value": "PT",
                        "TaxType": "Input Tax",
                        "text": "PT - PURCH  CST - 5% W/O FORM C"
                    },
                    {
                        "value": "PU",
                        "TaxType": "Input Tax",
                        "text": "PU - Addn Mach VAT 5 % - Vapi / Ank / Halol/Jhag"
                    },
                    {
                        "value": "PV",
                        "TaxType": "Input Tax",
                        "text": "PV - PURCHASE VAT 4% DECLARED GOODS"
                    },
                    {
                        "value": "PW",
                        "TaxType": "Input Tax",
                        "text": "PW - PURCH  CST - 15% W/O FORM C"
                    },
                    {
                        "value": "PX",
                        "TaxType": "Input Tax",
                        "text": "PX - PURCHASE CST 2% + 0.2% Niryat Kar"
                    },
                    {
                        "value": "PY",
                        "TaxType": "Input Tax",
                        "text": "PY - PUR. CST 0% AGAINST FORM C(MAHARASHTRA)"
                    },
                    {
                        "value": "PZ",
                        "TaxType": "Input Tax",
                        "text": "PZ - VAT 4% FOR DECLARED GOODS-PROJECT WITH EXCISE"
                    },
                    {
                        "value": "Q1",
                        "TaxType": "Input Tax",
                        "text": "Q1 - Purchase  - 0% CST (UPL Jammu to SWAL)"
                    },
                    {
                        "value": "Q2",
                        "TaxType": "Input Tax",
                        "text": "Q2 - PURCH  CST - 5.5% W/O FORM C"
                    },
                    {
                        "value": "Q3",
                        "TaxType": "Output Tax",
                        "text": "Q3 - ."
                    },
                    {
                        "value": "Q4",
                        "TaxType": "Output Tax",
                        "text": "Q4 - Sales - Maharashtra- VAT -5.5%(with Excise)"
                    },
                    {
                        "value": "Q5",
                        "TaxType": "Output Tax",
                        "text": "Q5 - Sales - Maharashtra  CST- 5.5% Without Form  C"
                    },
                    {
                        "value": "Q6",
                        "TaxType": "Output Tax",
                        "text": "Q6 - Sales -Maharashtra  Vat  2%"
                    },
                    {
                        "value": "Q7",
                        "TaxType": "Output Tax",
                        "text": "Q7 - Sales - Maharashtra- VAT -2%(with Excise)"
                    },
                    {
                        "value": "Q8",
                        "TaxType": "Output Tax",
                        "text": "Q8 - Sales - Maharashtra  CST- 2% Without Form  C"
                    },
                    {
                        "value": "Q9",
                        "TaxType": "Output Tax",
                        "text": "Q9 - Sales -Maharashtra  Vat  5.5%"
                    },
                    {
                        "value": "QA",
                        "TaxType": "Output Tax",
                        "text": "QA - Sales -Maharashtra-VAT 13.5%"
                    },
                    {
                        "value": "QB",
                        "TaxType": "Output Tax",
                        "text": "QB - Sales -Maharashtra  Vat  6%"
                    },
                    {
                        "value": "QC",
                        "TaxType": "Output Tax",
                        "text": "QC - Sales - Maharashtra- VAT -6%(with Excise)"
                    },
                    {
                        "value": "QD",
                        "TaxType": "Output Tax",
                        "text": "QD - Sales -Maharastra - CST - 13.5% without form  C"
                    },
                    {
                        "value": "QE",
                        "TaxType": "Output Tax",
                        "text": "QE - Sales - Maharashtra  CST- 6% Without Form  C"
                    },
                    {
                        "value": "QF",
                        "TaxType": "Output Tax",
                        "text": "QF - Sales -Jharkhand LST 5.5%"
                    },
                    {
                        "value": "QG",
                        "TaxType": "Output Tax",
                        "text": "QG - Sales -Chhatisgarh - VAT - 14.5%"
                    },
                    {
                        "value": "QH",
                        "TaxType": "Output Tax",
                        "text": "QH - Sales -West Bengal- CST- 5% Non Regd"
                    },
                    {
                        "value": "QY",
                        "TaxType": "Input Tax",
                        "text": "QY - Purchase cst 0% against Form C"
                    },
                    {
                        "value": "R1",
                        "TaxType": "Input Tax",
                        "text": "R1 - Service Tax - Bellary"
                    },
                    {
                        "value": "R2",
                        "TaxType": "Output Tax",
                        "text": "R2 - Sales -Rajasthan- LST - 5%"
                    },
                    {
                        "value": "R3",
                        "TaxType": "Output Tax",
                        "text": "R3 - Sales -Rajasthan- LST - 5.5%"
                    },
                    {
                        "value": "R4",
                        "TaxType": "Output Tax",
                        "text": "R4 - Sales -Assam - VAT- 6%"
                    },
                    {
                        "value": "R5",
                        "TaxType": "Output Tax",
                        "text": "R5 - Sales -Rajasthan- LST - 5.5%"
                    },
                    {
                        "value": "RA",
                        "TaxType": "Input Tax",
                        "text": "RA - RCM - Input SGST 2.5% + CGST 2.5%"
                    },
                    {
                        "value": "RB",
                        "TaxType": "Input Tax",
                        "text": "RB - RCM - Input SGST 6% + CGST 6%"
                    },
                    {
                        "value": "RC",
                        "TaxType": "Input Tax",
                        "text": "RC - RCM - Input SGST 9% + CGST 9%"
                    },
                    {
                        "value": "RD",
                        "TaxType": "Input Tax",
                        "text": "RD - RCM - Input SGST 14% + CGST 14%"
                    },
                    {
                        "value": "RG",
                        "TaxType": "Input Tax",
                        "text": "RG - RCM - Input IGST 5%"
                    },
                    {
                        "value": "RH",
                        "TaxType": "Input Tax",
                        "text": "RH - RCM - Input IGST 12%"
                    },
                    {
                        "value": "RI",
                        "TaxType": "Input Tax",
                        "text": "RI - RCM - Input IGST 18%"
                    },
                    {
                        "value": "RJ",
                        "TaxType": "Input Tax",
                        "text": "RJ - RCM - Input IGST 28%"
                    },
                    {
                        "value": "RM",
                        "TaxType": "Input Tax",
                        "text": "RM - RCM - Input UTGST 2.5% + CGST 2.5%"
                    },
                    {
                        "value": "RN",
                        "TaxType": "Input Tax",
                        "text": "RN - RCM - Input UTGST 6% + CGST 6%"
                    },
                    {
                        "value": "RO",
                        "TaxType": "Input Tax",
                        "text": "RO - RCM - Input UTGST 9% + CGST 9%"
                    },
                    {
                        "value": "RP",
                        "TaxType": "Input Tax",
                        "text": "RP - RCM - Input UTGST 14% + CGST 14%"
                    },
                    {
                        "value": "RS",
                        "TaxType": "Input Tax",
                        "text": "RS - RCM - No Input SGST 2.5% + CGST 2.5%"
                    },
                    {
                        "value": "RT",
                        "TaxType": "Input Tax",
                        "text": "RT - RCM - No Input IGST 5%"
                    },
                    {
                        "value": "RU",
                        "TaxType": "Input Tax",
                        "text": "RU - RCM - No Input UTGST 2.5% + CGST 2.5%"
                    },
                    {
                        "value": "RV",
                        "TaxType": "Input Tax",
                        "text": "RV - RCM -  No Input SGST 6% + CGST 6%"
                    },
                    {
                        "value": "RW",
                        "TaxType": "Input Tax",
                        "text": "RW - RCM -  No Input IGST 12%"
                    },
                    {
                        "value": "RX",
                        "TaxType": "Input Tax",
                        "text": "RX - RCM -  No Input UTGST 6% + CGST 6%"
                    },
                    {
                        "value": "RY",
                        "TaxType": "Input Tax",
                        "text": "RY - RCM -  No Input SGST 9% + CGST 9%"
                    },
                    {
                        "value": "RZ",
                        "TaxType": "Input Tax",
                        "text": "RZ - RCM -  No Input IGST 18%"
                    },
                    {
                        "value": "S0",
                        "TaxType": "Input Tax",
                        "text": "S0 - Service Tax - Vapi"
                    },
                    {
                        "value": "S1",
                        "TaxType": "Input Tax",
                        "text": "S1 - Service Tax - Ankleshwar U-1"
                    },
                    {
                        "value": "S2",
                        "TaxType": "Input Tax",
                        "text": "S2 - Service Tax - Ankleshwar U-2"
                    },
                    {
                        "value": "S3",
                        "TaxType": "Input Tax",
                        "text": "S3 - Service Tax - Ankleshwar U-3"
                    },
                    {
                        "value": "S4",
                        "TaxType": "Input Tax",
                        "text": "S4 - Service Tax - Halol"
                    },
                    {
                        "value": "S5",
                        "TaxType": "Input Tax",
                        "text": "S5 - Service Tax - Jhagadia"
                    },
                    {
                        "value": "S6",
                        "TaxType": "Input Tax",
                        "text": "S6 - Service Tax - SCIL Vapi"
                    },
                    {
                        "value": "S7",
                        "TaxType": "Input Tax",
                        "text": "S7 - Service Tax - Nerka Vapi"
                    },
                    {
                        "value": "S8",
                        "TaxType": "Input Tax",
                        "text": "S8 - Service Tax - Haldia"
                    },
                    {
                        "value": "S9",
                        "TaxType": "Input Tax",
                        "text": "S9 - Service Tax - HO"
                    },
                    {
                        "value": "SA",
                        "TaxType": "Output Tax",
                        "text": "SA - Sales -Gujarat- Export to Nepal(without excise)"
                    },
                    {
                        "value": "SB",
                        "TaxType": "Output Tax",
                        "text": "SB - Sales -Gujrat- Exp to Nepal-ag Cust Clearn Cert"
                    },
                    {
                        "value": "SC",
                        "TaxType": "Output Tax",
                        "text": "SC - Sales -Assam - VAT- 5%"
                    },
                    {
                        "value": "SD",
                        "TaxType": "Output Tax",
                        "text": "SD - Sales -Uttaranchal -VAT- 4.5%"
                    },
                    {
                        "value": "SE",
                        "TaxType": "Output Tax",
                        "text": "SE - Sales -Tamil Nadu VAT -5% (with Excise)"
                    },
                    {
                        "value": "SF",
                        "TaxType": "Output Tax",
                        "text": "SF - Not to use"
                    },
                    {
                        "value": "SG",
                        "TaxType": "Output Tax",
                        "text": "SG - Sales - Andhra Pradesh- VAT -5%"
                    },
                    {
                        "value": "SH",
                        "TaxType": "Output Tax",
                        "text": "SH - Sales -Uttaranchal -VAT- 5%"
                    },
                    {
                        "value": "SI",
                        "TaxType": "Output Tax",
                        "text": "SI - 0% TAX (For Rebate)"
                    },
                    {
                        "value": "SJ",
                        "TaxType": "Output Tax",
                        "text": "SJ - Sales -Karnataka- VAT - 5.5%"
                    },
                    {
                        "value": "SK",
                        "TaxType": "Output Tax",
                        "text": "SK - Sales -PUNJAB-VAT - 5%"
                    },
                    {
                        "value": "SL",
                        "TaxType": "Output Tax",
                        "text": "SL - Sales -West Bengal-(Calcutta-AF) VAT - 5%"
                    },
                    {
                        "value": "SM",
                        "TaxType": "Output Tax",
                        "text": "SM - Sales -West Bengal-(HALDIA FACTORY) VAT - 5%"
                    },
                    {
                        "value": "SN",
                        "TaxType": "Output Tax",
                        "text": "SN - VAT 1%(Used Motar Car)-Second Hand Car"
                    },
                    {
                        "value": "SO",
                        "TaxType": "Output Tax",
                        "text": "SO - Sales - Telangana- VAT -5%"
                    },
                    {
                        "value": "SP",
                        "TaxType": "Output Tax",
                        "text": "SP - Sales - Telangana-(IC/CA) -VAT 5%"
                    },
                    {
                        "value": "SQ",
                        "TaxType": "Output Tax",
                        "text": "SQ - Sales - Telangana- VAT -5%(with Excise)"
                    },
                    {
                        "value": "SR",
                        "TaxType": "Output Tax",
                        "text": "SR - Sales - Telangana- CST -2% (with Excise)"
                    },
                    {
                        "value": "SS",
                        "TaxType": "Output Tax",
                        "text": "SS - Sales - Telangana  CST- 4% Without Form  C"
                    },
                    {
                        "value": "ST",
                        "TaxType": "Output Tax",
                        "text": "ST - Sales -Telangana - VAT  0%"
                    },
                    {
                        "value": "SU",
                        "TaxType": "Output Tax",
                        "text": "SU - Sales - Telangana- VAT -5%(scrap)"
                    },
                    {
                        "value": "SV",
                        "TaxType": "Output Tax",
                        "text": "SV - Sales -West Bengal-(Calcutta-AF) VAT - 4.76%(SWAL)"
                    },
                    {
                        "value": "SW",
                        "TaxType": "Output Tax",
                        "text": "SW - Sales - Gujarat Vat 4% + 1%(Without Excise)"
                    },
                    {
                        "value": "SX",
                        "TaxType": "Output Tax",
                        "text": "SX - Sales - Telangana- VAT -14.5%"
                    },
                    {
                        "value": "SY",
                        "TaxType": "Output Tax",
                        "text": "SY - Sales -Chhatisgarh - VAT - 14"
                    },
                    {
                        "value": "SZ",
                        "TaxType": "Output Tax",
                        "text": "SZ - Sales-Telangana-CST -5%(with Excise)without c form"
                    },
                    {
                        "value": "T0",
                        "TaxType": "Output Tax",
                        "text": "T0 - Output GST 0%"
                    },
                    {
                        "value": "T1",
                        "TaxType": "Input Tax",
                        "text": "T1 - CST 4 % - Third Party Excise"
                    },
                    {
                        "value": "T2",
                        "TaxType": "Input Tax",
                        "text": "T2 - LST 6 % - Third Party Excise"
                    },
                    {
                        "value": "T3",
                        "TaxType": "Input Tax",
                        "text": "T3 - LST 2 % - Third Party Excise"
                    },
                    {
                        "value": "T4",
                        "TaxType": "Input Tax",
                        "text": "T4 - LST 0 % - Third Party Excise"
                    },
                    {
                        "value": "T5",
                        "TaxType": "Input Tax",
                        "text": "T5 - LST 4 % - Third Party Excise + VAT receivable"
                    },
                    {
                        "value": "TA",
                        "TaxType": "Output Tax",
                        "text": "TA - Output SGST 2.5% + CGST 2.5%"
                    },
                    {
                        "value": "TB",
                        "TaxType": "Output Tax",
                        "text": "TB - Output SGST 6% + CGST 6%"
                    },
                    {
                        "value": "TC",
                        "TaxType": "Output Tax",
                        "text": "TC - Output SGST 9% + CGST 9%"
                    },
                    {
                        "value": "TD",
                        "TaxType": "Output Tax",
                        "text": "TD - Output SGST 14% + CGST 14%"
                    },
                    {
                        "value": "TG",
                        "TaxType": "Output Tax",
                        "text": "TG - Output IGST 5%"
                    },
                    {
                        "value": "TH",
                        "TaxType": "Output Tax",
                        "text": "TH - Output IGST 12%"
                    },
                    {
                        "value": "TI",
                        "TaxType": "Output Tax",
                        "text": "TI - Output IGST 18%"
                    },
                    {
                        "value": "TJ",
                        "TaxType": "Output Tax",
                        "text": "TJ - Output IGST 28%"
                    },
                    {
                        "value": "TM",
                        "TaxType": "Output Tax",
                        "text": "TM - Output UTGST 2.5% + CGST 2.5%"
                    },
                    {
                        "value": "TN",
                        "TaxType": "Output Tax",
                        "text": "TN - Output UTGST 6% + CGST 6%"
                    },
                    {
                        "value": "TO",
                        "TaxType": "Output Tax",
                        "text": "TO - Output UTGST 9% + CGST 9%"
                    },
                    {
                        "value": "TP",
                        "TaxType": "Output Tax",
                        "text": "TP - Output UTGST 14% + CGST 14%"
                    },
                    {
                        "value": "TQ",
                        "TaxType": "Output Tax",
                        "text": "TQ - Output IGST 0%"
                    },
                    {
                        "value": "TR",
                        "TaxType": "Output Tax",
                        "text": "TR - Output IGST 0.10"
                    },
                    {
                        "value": "TS",
                        "TaxType": "Output Tax",
                        "text": "TS - Output SGST 0.05 + CGST 0.05"
                    },
                    {
                        "value": "TT",
                        "TaxType": "Output Tax",
                        "text": "TT - Output TCS  5% Section 206"
                    },
                    {
                        "value": "TU",
                        "TaxType": "Output Tax",
                        "text": "TU - TCS CGST/SGST Payable"
                    },
                    {
                        "value": "TV",
                        "TaxType": "Output Tax",
                        "text": "TV - TCS IGST PAYABLE"
                    },
                    {
                        "value": "TY",
                        "TaxType": "Output Tax",
                        "text": "TY - Output TCS 1% Section 206"
                    },
                    {
                        "value": "TZ",
                        "TaxType": "Output Tax",
                        "text": "TZ - Output TCS 0.10 % Section 206"
                    },
                    {
                        "value": "U1",
                        "TaxType": "Input Tax",
                        "text": "U1 - PURCHASE  CST 4% INCLUSIVE-  AGAINST FORM C"
                    },
                    {
                        "value": "U2",
                        "TaxType": "Input Tax",
                        "text": "U2 - PURCHASE  GST INCLUSIVE."
                    },
                    {
                        "value": "U3",
                        "TaxType": "Input Tax",
                        "text": "U3 - PUR. CST -UNION TERR- INCLUSIVE AGAINST FORM C"
                    },
                    {
                        "value": "U4",
                        "TaxType": "Input Tax",
                        "text": "U4 - PURCHASE CST 3% against FORM 'C"
                    },
                    {
                        "value": "U5",
                        "TaxType": "Input Tax",
                        "text": "U5 - PURCHASE CST 1%"
                    },
                    {
                        "value": "U6",
                        "TaxType": "Input Tax",
                        "text": "U6 - PURCHASE CST - 10% + 1% TOT"
                    },
                    {
                        "value": "U7",
                        "TaxType": "Input Tax",
                        "text": "U7 - PURCHASE -ANDHRA PRADESH VAT 4% (W/O EXCISE)"
                    },
                    {
                        "value": "U8",
                        "TaxType": "Input Tax",
                        "text": "U8 - PURCHASE - G.S.T. 15% (Non Vatable)"
                    },
                    {
                        "value": "U9",
                        "TaxType": "Input Tax",
                        "text": "U9 - Purchases - GST- 4%  (WITHOUT EXCISE)"
                    },
                    {
                        "value": "UD",
                        "TaxType": "Input Tax",
                        "text": "UD - PURCHASE CST 2% against FORM 'C"
                    },
                    {
                        "value": "UE",
                        "TaxType": "Input Tax",
                        "text": "UE - West Bengal INPUT VAT 13.5%  (Without  Excise)"
                    },
                    {
                        "value": "UF",
                        "TaxType": "Input Tax",
                        "text": "UF - PURCHASE -ANDHRA PRADESH VAT 5% (W/O EXCISE)"
                    },
                    {
                        "value": "UG",
                        "TaxType": "Input Tax",
                        "text": "UG - Maharashtra Input VAT 1%"
                    },
                    {
                        "value": "UH",
                        "TaxType": "Input Tax",
                        "text": "UH - West Bengal INPUT VAT 5%  (With Excise)"
                    },
                    {
                        "value": "UI",
                        "TaxType": "Input Tax",
                        "text": "UI - West Bengal INPUT VAT 5%  (W/o Excise)"
                    },
                    {
                        "value": "UJ",
                        "TaxType": "Input Tax",
                        "text": "UJ - West Bengal INPUT VAT 14.5%  (Without  Excise)"
                    },
                    {
                        "value": "UK",
                        "TaxType": "Input Tax",
                        "text": "UK - CST 6% WITHOUT  C FORM"
                    },
                    {
                        "value": "UL",
                        "TaxType": "Input Tax",
                        "text": "UL - PURCHASE CST 1.5%"
                    },
                    {
                        "value": "UM",
                        "TaxType": "Input Tax",
                        "text": "UM - PURCHASE GST 13.5% (Non Vatable)"
                    },
                    {
                        "value": "UN",
                        "TaxType": "Input Tax",
                        "text": "UN - Maharashtra Input VAT 1.10%"
                    },
                    {
                        "value": "UO",
                        "TaxType": "Input Tax",
                        "text": "UO - West Bengal INPUT VAT 14.5%  (With  Excise)"
                    },
                    {
                        "value": "UP",
                        "TaxType": "Input Tax",
                        "text": "UP - PURCHASE Fm Him. Prad. CST - 1.5%  AGAINST FORM C"
                    },
                    {
                        "value": "UQ",
                        "TaxType": "Input Tax",
                        "text": "UQ - PURCHASE GST 14.5% (Non Vatable)"
                    },
                    {
                        "value": "V0",
                        "TaxType": "Input Tax",
                        "text": "V0 - Purchase VAT 8.50% - Vapi / Ank / Halol(GAS Purch)"
                    },
                    {
                        "value": "V1",
                        "TaxType": "Input Tax",
                        "text": "V1 - PURCHASE VAT  4%  - JAMMU"
                    },
                    {
                        "value": "V2",
                        "TaxType": "Input Tax",
                        "text": "V2 - PURCHASE VAT  12.5%  - JAMMU"
                    },
                    {
                        "value": "V3",
                        "TaxType": "Input Tax",
                        "text": "V3 - Purchase 4%Vat  without Additional Tax."
                    },
                    {
                        "value": "V4",
                        "TaxType": "Input Tax",
                        "text": "V4 - Purchase VAT 12.5 % - Vapi / Ank / Halol"
                    },
                    {
                        "value": "V5",
                        "TaxType": "Input Tax",
                        "text": "V5 - Purchase VAT 26 % - Vapi / Ank / Halol"
                    },
                    {
                        "value": "V6",
                        "TaxType": "Input Tax",
                        "text": "V6 - Purchase VAT 4 % - Jhagadia"
                    },
                    {
                        "value": "V7",
                        "TaxType": "Input Tax",
                        "text": "V7 - Purchase VAT 12.5 % - Jhagadia"
                    },
                    {
                        "value": "V8",
                        "TaxType": "Input Tax",
                        "text": "V8 - Purchase VAT 15% - Vapi / Ank / Halol"
                    },
                    {
                        "value": "V9",
                        "TaxType": "Input Tax",
                        "text": "V9 - Purchase VAT 15% - Jhagadia"
                    },
                    {
                        "value": "VA",
                        "TaxType": "Output Tax",
                        "text": "VA - VAT 0%"
                    },
                    {
                        "value": "VB",
                        "TaxType": "Output Tax",
                        "text": "VB - jammu - Local Output VAT 4%"
                    },
                    {
                        "value": "VC",
                        "TaxType": "Output Tax",
                        "text": "VC - jammu - Output CST VAT 4%"
                    },
                    {
                        "value": "VD",
                        "TaxType": "Output Tax",
                        "text": "VD - Sales - Stock Transfer From VAT State"
                    },
                    {
                        "value": "VE",
                        "TaxType": "Output Tax",
                        "text": "VE - F Form Depot to Depot Transfer (VAT STATE)"
                    },
                    {
                        "value": "VF",
                        "TaxType": "Output Tax",
                        "text": "VF - PUNJAB VAT LOCAL 0%"
                    },
                    {
                        "value": "VG",
                        "TaxType": "Output Tax",
                        "text": "VG - PUNJAB VAT CST 0%"
                    },
                    {
                        "value": "VH",
                        "TaxType": "Output Tax",
                        "text": "VH - CST  0%   Against   form c"
                    },
                    {
                        "value": "VI",
                        "TaxType": "Output Tax",
                        "text": "VI - Sales -Maharashtra-VAT 12.5%"
                    },
                    {
                        "value": "VJ",
                        "TaxType": "Output Tax",
                        "text": "VJ - Sales -West Bengal- VAT - 4%"
                    },
                    {
                        "value": "VK",
                        "TaxType": "Output Tax",
                        "text": "VK - Sales -M.P.-VAT - 12.5%"
                    },
                    {
                        "value": "VL",
                        "TaxType": "Output Tax",
                        "text": "VL - Sales -Chhatisgarh - VAT - 12.5%"
                    },
                    {
                        "value": "VM",
                        "TaxType": "Output Tax",
                        "text": "VM - Sales - Gujarat  CST- 4%  Without Form  C"
                    },
                    {
                        "value": "VN",
                        "TaxType": "Output Tax",
                        "text": "VN - Sales -Daman -4% CST"
                    },
                    {
                        "value": "VO",
                        "TaxType": "Output Tax",
                        "text": "VO - Sales -Maharastra - CST - 4% without form  C"
                    },
                    {
                        "value": "VP",
                        "TaxType": "Output Tax",
                        "text": "VP - Sales - Punjab CST - 0% (FOR IC/AT)"
                    },
                    {
                        "value": "VQ",
                        "TaxType": "Output Tax",
                        "text": "VQ - Sales -uttar pradesh - VAT - 4%."
                    },
                    {
                        "value": "VR",
                        "TaxType": "Output Tax",
                        "text": "VR - Sales - Gujarat  CST- 5% Without Form  C"
                    },
                    {
                        "value": "VS",
                        "TaxType": "Output Tax",
                        "text": "VS - Sales - Gujrat(Jhagad) CST- 5% Without Form  C"
                    },
                    {
                        "value": "VT",
                        "TaxType": "Output Tax",
                        "text": "VT - Sales -uttar pradesh - VAT - 4.5%."
                    },
                    {
                        "value": "VU",
                        "TaxType": "Output Tax",
                        "text": "VU - Sales -Chhatisgarh - VAT - 5%"
                    },
                    {
                        "value": "VV",
                        "TaxType": "Output Tax",
                        "text": "VV - Sales -Uttar Pradesh - VAT - 5%."
                    },
                    {
                        "value": "VW",
                        "TaxType": "Output Tax",
                        "text": "VW - Sales -Maharashtra  Vat  5%"
                    },
                    {
                        "value": "VX",
                        "TaxType": "Output Tax",
                        "text": "VX - Sales -Karnataka- VAT - 5%"
                    },
                    {
                        "value": "VY",
                        "TaxType": "Output Tax",
                        "text": "VY - Sales -Maharashtra  - CST - 12.5%"
                    },
                    {
                        "value": "VZ",
                        "TaxType": "Output Tax",
                        "text": "VZ - Sales - Karnataka- VAT -0%"
                    },
                    {
                        "value": "W0",
                        "TaxType": "Output Tax",
                        "text": "W0 - HARYANA VAT 0%"
                    },
                    {
                        "value": "W1",
                        "TaxType": "Input Tax",
                        "text": "W1 - West Bengal INPUT VAT 4%  (With Excise)"
                    },
                    {
                        "value": "W2",
                        "TaxType": "Input Tax",
                        "text": "W2 - West Bengal INPUT VAT 12.5%  (With Excise)"
                    },
                    {
                        "value": "W3",
                        "TaxType": "Input Tax",
                        "text": "W3 - West Bengal INPUT VAT(HALDIA) 4%  (Without Excise)"
                    },
                    {
                        "value": "W4",
                        "TaxType": "Input Tax",
                        "text": "W4 - West Bengal INPUT VAT 12.5%  (Without  Excise)"
                    },
                    {
                        "value": "W5",
                        "TaxType": "Input Tax",
                        "text": "W5 - Maharastra  INPUT VAT 4%  (Without Excise)"
                    },
                    {
                        "value": "W6",
                        "TaxType": "Input Tax",
                        "text": "W6 - KERALA INPUT VAT 4.04%  (Without Excise)"
                    },
                    {
                        "value": "W7",
                        "TaxType": "Input Tax",
                        "text": "W7 - Karnataka  INPUT VAT 4%  (Without Excise)"
                    },
                    {
                        "value": "W8",
                        "TaxType": "Input Tax",
                        "text": "W8 - GUJARAT VAT  RECEIVABLE 4%  (Without Excise)"
                    },
                    {
                        "value": "W9",
                        "TaxType": "Input Tax",
                        "text": "W9 - Haryana  INPUT VAT 4%  (Without Excise)"
                    },
                    {
                        "value": "WA",
                        "TaxType": "Output Tax",
                        "text": "WA - Sales -Tamil Nadu-LST-0%"
                    },
                    {
                        "value": "WB",
                        "TaxType": "Output Tax",
                        "text": "WB - Sales - Andhra Pradesh- VAT -4% (with Excise)"
                    },
                    {
                        "value": "WC",
                        "TaxType": "Output Tax",
                        "text": "WC - Sales - Andhra Pradesh- CST -4% (with Excise)"
                    },
                    {
                        "value": "WD",
                        "TaxType": "Output Tax",
                        "text": "WD - Sales -West Bengal- CST - 4% (With excise)"
                    },
                    {
                        "value": "WE",
                        "TaxType": "Output Tax",
                        "text": "WE - Sales -Kerala  CST - 4% (Without excise)"
                    },
                    {
                        "value": "WF",
                        "TaxType": "Output Tax",
                        "text": "WF - Sales -West Bengal- CST - 0% (With excise)  Form H"
                    },
                    {
                        "value": "WG",
                        "TaxType": "Output Tax",
                        "text": "WG - Sales - Jhagadia CST- 4%  Agnst form ' D '"
                    },
                    {
                        "value": "WH",
                        "TaxType": "Output Tax",
                        "text": "WH - Sales - Punjab VAT - 4 % (FOR IC)"
                    },
                    {
                        "value": "WI",
                        "TaxType": "Output Tax",
                        "text": "WI - Sales -Karnataka VAT - 0% (Without Excise)"
                    },
                    {
                        "value": "WJ",
                        "TaxType": "Output Tax",
                        "text": "WJ - Sales -Tamil Nadu VAT -4% (with Excise)"
                    },
                    {
                        "value": "WK",
                        "TaxType": "Output Tax",
                        "text": "WK - Sales -West Bengal- LST - 4% (With excise)"
                    },
                    {
                        "value": "WL",
                        "TaxType": "Output Tax",
                        "text": "WL - Sales - Jhagadia CST- 3%  Agnst form ' D '"
                    },
                    {
                        "value": "WM",
                        "TaxType": "Output Tax",
                        "text": "WM - Sales -Karnataka- VAT - 12.5%"
                    },
                    {
                        "value": "WN",
                        "TaxType": "Output Tax",
                        "text": "WN - Sales - Gujarat Vat 4% + 1%"
                    },
                    {
                        "value": "WO",
                        "TaxType": "Output Tax",
                        "text": "WO - Sales - Gujarat Vat 12.5 % + 2.5%"
                    },
                    {
                        "value": "WP",
                        "TaxType": "Output Tax",
                        "text": "WP - Sales Gujarat Vat 15% (Jhagadia)"
                    },
                    {
                        "value": "WQ",
                        "TaxType": "Output Tax",
                        "text": "WQ - Sales - Gujarat Vat 5%  (Jhagadia)"
                    },
                    {
                        "value": "WR",
                        "TaxType": "Output Tax",
                        "text": "WR - Sales - Gujarat CST- 15 %  Without Form  C"
                    },
                    {
                        "value": "WS",
                        "TaxType": "Output Tax",
                        "text": "WS - Sales - Jhagadia CST- 15% without Form C"
                    },
                    {
                        "value": "WT",
                        "TaxType": "Output Tax",
                        "text": "WT - Tran Sales(E1 Form)Interstate 2%CST  AG C FORM-V/A"
                    },
                    {
                        "value": "WU",
                        "TaxType": "Output Tax",
                        "text": "WU - Tran Sales(E1 Form)Interstate 2%CST  AG C FORM-JHA"
                    },
                    {
                        "value": "WV",
                        "TaxType": "Output Tax",
                        "text": "WV - Sales -Uttar Pradesh - LST- 12.5%"
                    },
                    {
                        "value": "WW",
                        "TaxType": "Output Tax",
                        "text": "WW - Sales Against Form H (Sattur Depot)"
                    },
                    {
                        "value": "WX",
                        "TaxType": "Output Tax",
                        "text": "WX - Tran Sales(E1 Form)U/F C(INCLUSIVE CST)"
                    },
                    {
                        "value": "WY",
                        "TaxType": "Output Tax",
                        "text": "WY - Sales -M.P.-VAT -5%"
                    },
                    {
                        "value": "WZ",
                        "TaxType": "Output Tax",
                        "text": "WZ - Sales - Against Form H & Wo Excise(Jhagadia)"
                    },
                    {
                        "value": "X1",
                        "TaxType": "Input Tax",
                        "text": "X1 - VAT RECEIVABLE (UTTAR PRADESH)"
                    },
                    {
                        "value": "X2",
                        "TaxType": "Input Tax",
                        "text": "X2 - VAT RECEIVABLE (RAJASTHAN)"
                    },
                    {
                        "value": "X3",
                        "TaxType": "Input Tax",
                        "text": "X3 - Purchase - Tamilnadu Vat 0%"
                    },
                    {
                        "value": "X4",
                        "TaxType": "Input Tax",
                        "text": "X4 - Purchase - Uttar Pradesh Vat 0%"
                    },
                    {
                        "value": "X5",
                        "TaxType": "Input Tax",
                        "text": "X5 - Purchase VAT 5 % - Vapi / Ank / Halol/Jhag"
                    },
                    {
                        "value": "X6",
                        "TaxType": "Input Tax",
                        "text": "X6 - Purchase VAT 15 % - Vapi / Ank / Halol/Jhag"
                    },
                    {
                        "value": "X7",
                        "TaxType": "Input Tax",
                        "text": "X7 - Purchase VAT 17.5% - Vapi / Ank / Halol/Jhag"
                    },
                    {
                        "value": "X8",
                        "TaxType": "Input Tax",
                        "text": "X8 - Purchase VAT 5 % - Jhagadia"
                    },
                    {
                        "value": "X9",
                        "TaxType": "Input Tax",
                        "text": "X9 - Purchase VAT 17.5%-Jhagadia"
                    },
                    {
                        "value": "XA",
                        "TaxType": "Input Tax",
                        "text": "XA - Purchase VAT 15 % - Jhagadia"
                    },
                    {
                        "value": "XB",
                        "TaxType": "Input Tax",
                        "text": "XB - W B INPUT VAT(CALCUTTA AF DEP )4% (Without Excise)"
                    },
                    {
                        "value": "XC",
                        "TaxType": "Input Tax",
                        "text": "XC - Purch VAT proj-mac-17.5%  Vapi / Ank / Halol/Jhag"
                    },
                    {
                        "value": "XD",
                        "TaxType": "Input Tax",
                        "text": "XD - PURCHASE  INCULSIVE  AGAINST  C  FORM"
                    },
                    {
                        "value": "XE",
                        "TaxType": "Input Tax",
                        "text": "XE - CST 4% WITHOUT  C FORM"
                    },
                    {
                        "value": "XF",
                        "TaxType": "Input Tax",
                        "text": "XF - Karnataka  INPUT VAT 5% (Without Excise)"
                    },
                    {
                        "value": "XG",
                        "TaxType": "Input Tax",
                        "text": "XG - CST 5% WITHOUT  C FORM"
                    },
                    {
                        "value": "XH",
                        "TaxType": "Output Tax",
                        "text": "XH - Sales -Maharastra - CST - 5% without form  C"
                    },
                    {
                        "value": "XI",
                        "TaxType": "Output Tax",
                        "text": "XI - Sales - Andhra Pradesh  CST- 4% Without Form  C"
                    },
                    {
                        "value": "XJ",
                        "TaxType": "Output Tax",
                        "text": "XJ - Sales -Tamil Nadu-VAT-5%"
                    },
                    {
                        "value": "XK",
                        "TaxType": "Output Tax",
                        "text": "XK - Sales - Andhra Pradesh- VAT -5%"
                    },
                    {
                        "value": "XL",
                        "TaxType": "Output Tax",
                        "text": "XL - Sales - APST - (IC/CA) -VAT 5%"
                    },
                    {
                        "value": "XM",
                        "TaxType": "Output Tax",
                        "text": "XM - Sales - Andhra Pradesh- VAT -5%(with Excise)"
                    },
                    {
                        "value": "XN",
                        "TaxType": "Output Tax",
                        "text": "XN - Sales(Oil Seed)-Punjab-Vat 4.40%"
                    },
                    {
                        "value": "XO",
                        "TaxType": "Output Tax",
                        "text": "XO - SALE-JAMMU CST 0%(WITHOUT EXCISE)"
                    },
                    {
                        "value": "XP",
                        "TaxType": "Output Tax",
                        "text": "XP - Sales -Karnataka- CST-5%"
                    },
                    {
                        "value": "XQ",
                        "TaxType": "Output Tax",
                        "text": "XQ - Sales(Oil Seed)-ANDHRA-VAT 5%"
                    },
                    {
                        "value": "XR",
                        "TaxType": "Output Tax",
                        "text": "XR - Sales -Orissa- VAT- 5%"
                    },
                    {
                        "value": "XS",
                        "TaxType": "Output Tax",
                        "text": "XS - Sales - Maharashtra Vat 5% (with Excise)"
                    },
                    {
                        "value": "XT",
                        "TaxType": "Output Tax",
                        "text": "XT - Sales- without Excise-(ARE1 AND FORM I)"
                    },
                    {
                        "value": "XU",
                        "TaxType": "Output Tax",
                        "text": "XU - Sales - Maharashtra- VAT -5%(with Excise)"
                    },
                    {
                        "value": "XV",
                        "TaxType": "Output Tax",
                        "text": "XV - Sales -Haryana Vat 12.5 + S CHARGE 0.625"
                    },
                    {
                        "value": "XW",
                        "TaxType": "Input Tax",
                        "text": "XW - PUrchase Punjab VAT 4.95%"
                    },
                    {
                        "value": "XX",
                        "TaxType": "Input Tax",
                        "text": "XX - PUrchase Punjab VAT 6.05%"
                    },
                    {
                        "value": "XY",
                        "TaxType": "Output Tax",
                        "text": "XY - Sales - Tamil Nadu CST- 5% Without Form  C"
                    },
                    {
                        "value": "XZ",
                        "TaxType": "Output Tax",
                        "text": "XZ - SALES(Vat on Edible oil)-6.875"
                    },
                    {
                        "value": "Y0",
                        "TaxType": "Input Tax",
                        "text": "Y0 - PURCHASE TAX EXEMPT(SERVICE SHEET)"
                    },
                    {
                        "value": "Y1",
                        "TaxType": "Input Tax",
                        "text": "Y1 - PURCHASE  GST - FORM H"
                    },
                    {
                        "value": "Y2",
                        "TaxType": "Input Tax",
                        "text": "Y2 - PURCHASE  GST - FORM 19"
                    },
                    {
                        "value": "Y3",
                        "TaxType": "Input Tax",
                        "text": "Y3 - PURCHASE  CST - 4%  AGAINST FORM C"
                    },
                    {
                        "value": "Y4",
                        "TaxType": "Input Tax",
                        "text": "Y4 - PURCHASE  CST - 10 %"
                    },
                    {
                        "value": "Y5",
                        "TaxType": "Input Tax",
                        "text": "Y5 - II ND  SALES FORM 31"
                    },
                    {
                        "value": "Y6",
                        "TaxType": "Input Tax",
                        "text": "Y6 - MST - FULL TAX 15.3 %"
                    },
                    {
                        "value": "Y7",
                        "TaxType": "Input Tax",
                        "text": "Y7 - TAX FREE GOODS"
                    },
                    {
                        "value": "Y8",
                        "TaxType": "Input Tax",
                        "text": "Y8 - FORM H"
                    },
                    {
                        "value": "Y9",
                        "TaxType": "Input Tax",
                        "text": "Y9 - Others-(Expense)"
                    },
                    {
                        "value": "YG",
                        "TaxType": "Input Tax",
                        "text": "YG - TDS RECEIVABLE ON PAYMENT TO E COMMERCE 1%"
                    },
                    {
                        "value": "YH",
                        "TaxType": "Input Tax",
                        "text": "YH - TDS RECEIVABLE ON PAYMENT TO E COMMERCE 5%"
                    },
                    {
                        "value": "YI",
                        "TaxType": "Input Tax",
                        "text": "YI - Input IGST 18% Intercompany"
                    },
                    {
                        "value": "Z1",
                        "TaxType": "Input Tax",
                        "text": "Z1 - Purchase GST 2 %"
                    },
                    {
                        "value": "Z2",
                        "TaxType": "Input Tax",
                        "text": "Z2 - Purchases - GST - 4% (Non Vatable)"
                    },
                    {
                        "value": "Z3",
                        "TaxType": "Input Tax",
                        "text": "Z3 - PURCHASE GST 5%"
                    },
                    {
                        "value": "Z4",
                        "TaxType": "Input Tax",
                        "text": "Z4 - PURCHASE GST 6%"
                    },
                    {
                        "value": "Z5",
                        "TaxType": "Input Tax",
                        "text": "Z5 - PURCHASE GST 8%"
                    },
                    {
                        "value": "Z6",
                        "TaxType": "Input Tax",
                        "text": "Z6 - PURCHASE GST 12.5% (Non Vatable)"
                    },
                    {
                        "value": "Z7",
                        "TaxType": "Input Tax",
                        "text": "Z7 - PURCHASE GST 20%"
                    },
                    {
                        "value": "Z8",
                        "TaxType": "Input Tax",
                        "text": "Z8 - PURCHASE GST 0.25 % against FORM 26/40"
                    },
                    {
                        "value": "Z9",
                        "TaxType": "Input Tax",
                        "text": "Z9 - PURCHASE  GST - URD"
                    },
                    {
                        "value": "ZZ",
                        "TaxType": "Input Tax",
                        "text": "ZZ - Ariba Integration"
                    }
                ]
            }
        default:
            return {}
    }
}

export default OptionsUPLBillApproval;